webpackJsonp([1],{

/***/ "+G02":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/european-year.9db16e4.png";

/***/ }),

/***/ "+iZI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-socialWallPage"},[_c('div',{staticClass:"title-container"},[_c('h1',[_vm._v(_vm._s(_vm.activeLanguage.youtubeGallery))])]),_vm._v(" "),_c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.fetchVideosOnLoadMore),expression:"fetchVideosOnLoadMore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"50"}},[_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[(_vm.isLoadingContent)?_c('div',{key:"1"},[_c('p',{staticClass:"loading-subtitle"},[_vm._v(_vm._s(_vm.activeLanguage.contentLoading))]),_vm._v(" "),_c('grid-loader',{staticStyle:{"width":"100%"},attrs:{"loading":_vm.isLoadingContent,"color":"#c41c21","size":"40px"}})],1):(_vm.isEmptyContent)?_c('div',{key:"2"},[_c('p',{staticClass:"loading-subtitle"},[_vm._v(_vm._s(_vm.activeLanguage.contentEmpty))]),_vm._v(" "),_c('div',{staticClass:"empty-box"})]):_c('div',{key:"3"},[_c('div',{directives:[{name:"masonry",rawName:"v-masonry"}],class:_vm.getContainerClass,attrs:{"fit-width":true,"item-selector":".item","transition-duration":"0.3s"}},_vm._l((_vm.posts),function(post,index){return _c('div',{directives:[{name:"masonry-tile",rawName:"v-masonry-tile"}],key:index,staticClass:"item"},[_c('VideoCard',{attrs:{"post-content":post}})],1)}))])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+vcn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/I/1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/LwZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BecomeSupporterModal',
  computed: {
    activeLanguage: function activeLanguage() {
      return this.$translations[this.$store.getters.currentLanguageValue];
    }
  },
  methods: {
    showModal: function showModal() {
      this.$refs.becomeSupporterModal.show();
    },
    hideModal: function hideModal() {
      this.$refs.becomeSupporterModal.hide();
    }
  },
  mounted: function mounted() {
    document.getElementById('becomeSupporterModal___BV_modal_header_').setAttribute('style', 'background-color: #c41c21 !important; color: white !important;');
    document.getElementById('becomeSupporterModal___BV_modal_header_').lastChild.setAttribute('style', 'color: white !important;');
  }
});

/***/ }),

/***/ "/Q6p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/fQ9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignForm_vue__ = __webpack_require__("Klpr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_014a26a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignForm_vue__ = __webpack_require__("E/lr");
function injectStyle (ssrContext) {
  __webpack_require__("tLpT")
  __webpack_require__("E35V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-014a26a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_014a26a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0EMm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SignCaption__ = __webpack_require__("tC7f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SignForm__ = __webpack_require__("/fQ9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilComponents_ValueSlider__ = __webpack_require__("q/1w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ThankYouModal__ = __webpack_require__("VBuC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SignaturesCounter__ = __webpack_require__("LDej");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SignPetitionPage',
  components: { SignaturesCounter: __WEBPACK_IMPORTED_MODULE_4__SignaturesCounter__["a" /* default */], ThankYouModal: __WEBPACK_IMPORTED_MODULE_3__ThankYouModal__["a" /* default */], ValueSlider: __WEBPACK_IMPORTED_MODULE_2__utilComponents_ValueSlider__["a" /* default */], SignForm: __WEBPACK_IMPORTED_MODULE_1__SignForm__["a" /* default */], SignCaption: __WEBPACK_IMPORTED_MODULE_0__SignCaption__["a" /* default */] },
  computed: {
    activeLanguage: function activeLanguage() {
      return this.$translations[this.$store.getters.currentLanguageValue];
    }
  },
  methods: {
    showModal: function showModal(petitionerName) {
      this.$refs.thankYouModal.showModal(petitionerName);
    },
    hideModal: function hideModal() {
      this.$refs.thankYouModal.hideModal();
    }
  },
  props: {
    default: {
      type: Object
    }
  },
  mounted: function mounted() {
    this.$store.commit('setCurrentView', this.default);
  }
});

/***/ }),

/***/ "0IXM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0eYP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"v-spinner",style:(_vm.containerStyle)},[_c('div',{staticClass:"v-grid v-grid1",style:([_vm.spinnerStyle,_vm.animationStyle,_vm.animationStyle1])}),_c('div',{staticClass:"v-grid v-grid2",style:([_vm.spinnerStyle,_vm.animationStyle,_vm.animationStyle2])}),_c('div',{staticClass:"v-grid v-grid3",style:([_vm.spinnerStyle,_vm.animationStyle,_vm.animationStyle3])}),_c('div',{staticClass:"v-grid v-grid4",style:([_vm.spinnerStyle,_vm.animationStyle,_vm.animationStyle4])}),_c('div',{staticClass:"v-grid v-grid5",style:([_vm.spinnerStyle,_vm.animationStyle,_vm.animationStyle5])}),_c('div',{staticClass:"v-grid v-grid6",style:([_vm.spinnerStyle,_vm.animationStyle,_vm.animationStyle6])}),_c('div',{staticClass:"v-grid v-grid7",style:([_vm.spinnerStyle,_vm.animationStyle,_vm.animationStyle7])}),_c('div',{staticClass:"v-grid v-grid8",style:([_vm.spinnerStyle,_vm.animationStyle,_vm.animationStyle8])}),_c('div',{staticClass:"v-grid v-grid9",style:([_vm.spinnerStyle,_vm.animationStyle,_vm.animationStyle9])})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0kkJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((Math.ceil(_vm.supporters.length / 5)),function(i,idx){return _c('b-row',{key:idx,staticClass:"supporter-row"},_vm._l((_vm.supporters.slice((i - 1) * 5, i * 5)),function(item,index){return _c('b-col',{key:index,attrs:{"cols":"12","sm":"6","lg":"2","id":"f1_container"}},[_c('div',{staticClass:"shadow",attrs:{"id":"f1_card"}},[_c('div',{staticClass:"front face",style:({ 'background-image': 'url(' + _vm.imagePath(item.imageLink) + ')' })}),_vm._v(" "),_c('a',{attrs:{"href":item.externalLink,"target":"_blank"}},[_c('div',{staticClass:"back face center"},[_c('div',{staticClass:"back-text"},[_c('h2',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(item.description))])])])])])])}))}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0u4U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutUs_vue__ = __webpack_require__("jSHs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ad69110_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutUs_vue__ = __webpack_require__("BFT3");
function injectStyle (ssrContext) {
  __webpack_require__("c/fg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ad69110"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutUs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ad69110_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutUs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1dLw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((Math.ceil(_vm.supporters.length / 5)),function(i,idx){return _c('b-row',{key:idx,staticClass:"supporter-row"},_vm._l((_vm.supporters.slice((i - 1) * 5, i * 5)),function(item,index){return _c('b-col',{key:index,attrs:{"cols":"12","sm":"6","lg":"2","id":"f1_container"}},[_c('div',{staticClass:"shadow",attrs:{"id":"f1_card"}},[_c('div',{staticClass:"front face",style:({ 'background-image': 'url(' + _vm.imagePath(item.imageLink) + ')' })}),_vm._v(" "),_c('a',{attrs:{"href":item.externalLink,"target":"_blank"}},[_c('div',{staticClass:"back face center"},[_c('div',{staticClass:"back-text"},[_c('h2',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(item.description))])])])])])])}))}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1phh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lombardy-region.f933f50.jpg";

/***/ }),

/***/ "2VY6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DiscoverAlpFoodway',
  computed: {
    activeLanguage: function activeLanguage() {
      return this.$translations[this.$store.getters.currentLanguageValue];
    }
  },
  methods: {
    showModal: function showModal() {
      this.$refs.discoverAlpfoodway.show();
    },
    hideModal: function hideModal() {
      this.$refs.discoverAlpfoodway.hide();
    }
  },
  mounted: function mounted() {
    document.getElementById('discoverAlpfoodway___BV_modal_header_').setAttribute('style', 'background-color: #c41c21 !important; color: white !important;');
    document.getElementById('discoverAlpfoodway___BV_modal_header_').lastChild.setAttribute('style', 'color: white !important;');
  }
});

/***/ }),

/***/ "2bmP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2t+/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-thankYouModal"},[_c('b-modal',{ref:"panelWindowRef",attrs:{"size":"lg","centered":"","hide-footer":"","hide-header":"","no-close-on-backdrop":true,"no-close-on-esc":true,"title":"Using Component Methods"}},[_c('div',{staticClass:"d-block text-center"},[_c('h1',{staticClass:"thank-you-style"},[_vm._v(_vm._s(_vm.activeLanguage.thankYouTitle)+" "+_vm._s(_vm.petitionerName)+"!")]),_vm._v(" "),_c('h6',{staticClass:"thank-you-style"},[_vm._v(_vm._s(_vm.activeLanguage.thankYouSubtitle))]),_vm._v(" "),_c('div',{staticClass:"socials-wrapper"},[_c('div',{staticClass:"row mr-2 ml-2"},[_c('a',{staticClass:"col-md-6 p-2"},[_c('div',{staticClass:"text-center facebook-wrapper wrapper",on:{"click":_vm.hasShared}},[_c('social-sharing',{attrs:{"url":"https://alpfoodway.eu/sign-petition","title":"Sign the AlpFoodway Petition","description":"Contribute to the UNESCO application.","quote":"Alpine Food is an intangible heritage. Sign the petition here -->","network-tag":"div"},inlineTemplate:{render:function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('network',{staticClass:"icon facebook-icon mr-2",attrs:{"network":"facebook","aria-label":"Share on Facebook","title":"Share on Facebook"}})},staticRenderFns:[]}})],1)]),_vm._v(" "),_c('a',{staticClass:"col-md-6 p-2",attrs:{"target":"_blank"}},[_c('div',{staticClass:"text-center email-wrapper wrapper",on:{"click":_vm.hasShared}},[_c('social-sharing',{attrs:{"url":"https://alpfoodway.eu/sign-petition","title":"Sign the AlpFoodway Petition","description":"Contribute to the UNESCO application.","network-tag":"div"},inlineTemplate:{render:function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('network',{staticClass:"icon email-icon mr-2",attrs:{"network":"email","aria-label":"Share on Email","title":"Share on Email"}})},staticRenderFns:[]}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row  mr-2 ml-2"},[_c('a',{staticClass:"col-md-6 p-2",attrs:{"target":"_blank"}},[_c('div',{staticClass:"text-center twitter-wrapper wrapper",on:{"click":_vm.hasShared}},[_c('social-sharing',{attrs:{"url":"https://alpfoodway.eu/sign-petition","title":"Sign the AlpFoodway Petition","description":"Contribute to the UNESCO application.","hashtags":"alpfoodway, AlpFoodway, alpFoodway, Alpfooday","twitter-user":"AlpFoodway","network-tag":"div"},inlineTemplate:{render:function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('network',{staticClass:"icon twitter-icon mr-2",attrs:{"network":"twitter","aria-label":"Share on Twitter","title":"Share on Twitter"}})},staticRenderFns:[]}})],1)]),_vm._v(" "),_c('a',{staticClass:"col-md-6 p-2",attrs:{"target":"_blank"}},[_c('div',{staticClass:"text-center linkedin-wrapper wrapper",on:{"click":_vm.hasShared}},[_c('social-sharing',{attrs:{"url":"https://alpfoodway.eu/sign-petition","title":"Sign the AlpFoodway Petition","description":"Contribute to the UNESCO application.","network-tag":"div"},inlineTemplate:{render:function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('network',{staticClass:"icon linkedin-icon mr-2",attrs:{"network":"linkedin","aria-label":"Share on Linkedin","title":"Share on Linkedin"}})},staticRenderFns:[]}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row  mr-2 ml-2"},[_c('a',{staticClass:"col-md-6 p-2",attrs:{"target":"_blank"}},[_c('div',{staticClass:"text-center whatsapp-wrapper wrapper",on:{"click":_vm.hasShared}},[_c('social-sharing',{attrs:{"url":"https://alpfoodway.eu/sign-petition","title":"Sign the AlpFoodway Petition","description":"Contribute to the UNESCO application.","network-tag":"div"},inlineTemplate:{render:function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('network',{staticClass:"icon whatsapp-icon mr-2",attrs:{"network":"whatsapp","aria-label":"Share on Whatsapp","title":"Share on Whatsapp"}})},staticRenderFns:[]}})],1)]),_vm._v(" "),_c('a',{staticClass:"col-md-6 p-2",attrs:{"target":"_blank"}},[_c('div',{staticClass:"text-center telegram-wrapper wrapper",on:{"click":_vm.hasShared}},[_c('social-sharing',{attrs:{"url":"https://alpfoodway.eu/sign-petition","title":"Sign the AlpFoodway Petition","description":"Contribute to the UNESCO application.","network-tag":"div"},inlineTemplate:{render:function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('network',{staticClass:"icon telegram-icon mr-2",attrs:{"network":"telegram","aria-label":"Share on Telegram","title":"Share on Telegram"}})},staticRenderFns:[]}})],1)])])]),_vm._v(" "),(_vm.hasNotShared)?_c('p',{staticClass:"maybe-later",on:{"click":_vm.emitClosing}},[_vm._v(_vm._s(_vm.activeLanguage.maybeLater))]):_c('h6',{staticClass:"thank-you-sharing maybe-later",on:{"click":_vm.emitClosing}},[_vm._v(_vm._s(_vm.activeLanguage.thanksForSharing))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3I5K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3cDv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3cM1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/european-year.7e079ec.jpg";

/***/ }),

/***/ "3dke":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3gCV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3j9A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "47q3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4BCQ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "4pd3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NewsArticleCard',
  data: function data() {
    return {
      imageUrl: '',
      link: '',
      newspaper: '',
      title: '',
      datePublished: '',
      description: '',
      id: '',
      name: '',
      source: '',
      isSmallWindow: false
    };
  },

  props: {
    postContent: {
      type: Object
    }
  },
  computed: {
    newsUrl: function newsUrl() {
      return this.link;
    },
    createdAtMoment: function createdAtMoment() {
      if (this.datePublished) {
        var s = this.$moment(this.datePublished);
        if (s.isValid()) {
          return s;
        }
      }
      return this.$moment();
    },
    giveClassFromType: function giveClassFromType() {
      return 'icon ' + this.newspaper;
    },
    getBodyClass: function getBodyClass() {
      return this.isSmallWindow ? 'row post-body' : 'post-body';
    },
    getCardClass: function getCardClass() {
      return this.isSmallWindow ? 'post-card-mobile' : 'post-card';
    }
  },
  methods: {
    initializeFields: function initializeFields() {
      this.imageUrl = this.postContent.thumbnailUrl;
      this.link = 'https://www.youtube.com/watch?v=' + this.postContent.videoLinkId;
      this.title = this.postContent.title;
      this.datePublished = this.postContent.datePublished;
      this.description = this.postContent.description;
      this.id = this.postContent.id;
      this.source = this.postContent.source;
    },
    checkWindowSize: function checkWindowSize() {
      if (!this.isSmallWindow && window.innerWidth < 1051) {
        this.isSmallWindow = true;
      } else if (this.isSmallWindow && window.innerWidth > 1051) {
        this.isSmallWindow = false;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.initializeFields();
    this.checkWindowSize();
    window.addEventListener('resize', function () {
      return _this.checkWindowSize();
    });
  }
});

/***/ }),

/***/ "4xIF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventCard_vue__ = __webpack_require__("teHs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d487c09c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventCard_vue__ = __webpack_require__("QXzP");
function injectStyle (ssrContext) {
  __webpack_require__("BWZQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d487c09c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d487c09c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "58Na":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alpfoodway_background1_resized.b793d11.jpg";

/***/ }),

/***/ "5LL5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"f-mainFooter dark-color pt-small",attrs:{"id":"main-footer"}},[_c('b-row',{staticClass:"pt-small",attrs:{"no-gutters":""}},[_c('b-col',{class:[{'col-3':!_vm.isSmallWindow}, {'col-12':_vm.isSmallWindow}]},[_c('div',{staticClass:"footer-widget"},[_c('h3',{staticClass:"text-light"},[_vm._v("#AlpFoodway")]),_vm._v(" "),_c('h5',{staticClass:"large text-left"},[_vm._v(_vm._s(_vm.activeLanguage.alpFoodWayDescription))])])]),_vm._v(" "),_c('b-col',{class:[{'col-9':!_vm.isSmallWindow}, {'col-12':_vm.isSmallWindow}, 'footer-widget']},[_c('b-row',{staticClass:"supporters-box float-right",attrs:{"no-gutters":""}},[_c('b-col',{class:[{'col-4':!_vm.isSmallWindow}, {'col-12':_vm.isSmallWindow}]},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{staticStyle:{"display":"flex"}},[_c('img',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:[{'europeLeft': !_vm.$store.getters.isMobileValue},'imgLogoEurope'],attrs:{"src":__webpack_require__("7qbX"),"alt":"European Union","title":"European Union"}}),_vm._v(" "),_c('img',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"imgLogoEurope",attrs:{"src":__webpack_require__("6DkJ"),"alt":"European Year of Cultural Heritage","title":"European Year of Cultural Heritage"}}),_vm._v(" "),_c('img',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"imgLogoEurope",attrs:{"src":__webpack_require__("OKCu"),"alt":"NRP","title":"NRP"}})])],1)],1),_vm._v(" "),_c('b-col',{class:[{'col-8':!_vm.isSmallWindow}, {'col-12':_vm.isSmallWindow}]},[_c('b-row',{staticClass:"spacer",attrs:{"no-gutters":""}},[_c('b-col',{staticStyle:{"margin-left":"5px"},attrs:{"cols":"2"}},[_c('a',{attrs:{"href":_vm.partnersLink + 'polo-poschiavo',"target":"_blank"}},[_c('img',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"imgLogoBig",attrs:{"src":_vm.imagePath('polo-poschiavo.jpg'),"title":"Polo Poschiavo"}})])]),_vm._v(" "),_c('b-col',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:[{slovenianLeft: !_vm.$store.getters.isMobileValue}],attrs:{"cols":"2","title":"Research Centre of the Slovenian Academy of Sciences and Arts"}},[_c('a',{attrs:{"href":_vm.partnersLink + 'zrc-sazu'}},[_c('img',{staticClass:"imgLogoBig",attrs:{"src":_vm.imagePath('zrc-sazu.jpg'),"target":"_blank"}})])]),_vm._v(" "),_c('b-col',{class:[{colLeft: !_vm.$store.getters.isMobileValue}],attrs:{"cols":"6"}},[_c('b-row',{staticClass:"spacer",attrs:{"no-gutters":""}},_vm._l((_vm.partnersLogoSmall),function(item,index){return (index < 6)?_c('b-col',{key:item,staticClass:"spacer-side"},[_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"href":_vm.partnersLink + item.split('.')[0],"target":"_blank","alt":_vm.getTooltipName(item.split('.')[0]),"title":_vm.getTooltipName(item.split('.')[0])}},[_c('img',{class:[{'logo-remove-height' : _vm.$store.getters.isMobileValue},'imgLogoSmall'],attrs:{"src":_vm.imagePath(item)}})])]):_vm._e()})),_vm._v(" "),_c('b-row',{attrs:{"no-gutters":""}},_vm._l((_vm.partnersLogoSmall),function(item,index){return (index < 12 && index >= 6)?_c('b-col',{key:item,staticClass:"spacer-side"},[_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"href":_vm.partnersLink + item.split('.')[0],"target":"_blank","alt":_vm.getTooltipName(item.split('.')[0]),"title":_vm.getTooltipName(item.split('.')[0])}},[_c('img',{class:[{'logo-remove-height' : _vm.$store.getters.isMobileValue},'imgLogoSmall'],attrs:{"src":_vm.imagePath(item)}})])]):_vm._e()}))],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"id":"footer-rights"}},[_c('div',{staticClass:"container"},[_c('b-row',[_c('b-col',{staticClass:"uppercase",attrs:{"cols":"12"}},[_c('h6',[_vm._v("Copyright © 2019 / Powered by")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('a',{on:{"click":_vm.openCreditsModal}},[_c('img',{staticClass:"logo-match",attrs:{"src":__webpack_require__("sOzK"),"alt":"Match Strategies"}})])])],1)],1)]),_vm._v(" "),_c('credits-modal',{ref:"creditsModal",attrs:{"id":"creditsModal"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5Qhs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CountdownFooter',
  data: function data() {
    return {
      emailValue: ''
    };
  },

  computed: {
    validEmail: function validEmail() {
      return this.isEmailValid(this.emailValue);
    }
  },
  methods: {
    isEmailValid: function isEmailValid(email) {
      var re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    submitSubscrition: function submitSubscrition() {
      alert('Store to DB the email ' + this.emailValue);

      var self = this;
      this.$http.post(this.$PATH_NAME + 'sessions/', {
        email: this.emailValue
      }).then(function (response) {
        if (response.status === 201) {
          self.$store.commit('setSession', response.body);
          self.$router.push('/dashboard');
        }
      }).catch(function (err) {
        if (err.status >= 500) {
          self.uploadStatus = 'An error occurred!';
          self.statusClass = 'error-status';
        } else if (err.status >= 400) {
          self.uploadStatus = 'Bad Request!';
          self.statusClass = 'warning-status';
        }
      }).finally(function () {
        this.emailValue = '';
      });
    }
  }
});

/***/ }),

/***/ "66Im":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_leaflet__ = __webpack_require__("nrd6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet_dist_images_marker_icon_png__ = __webpack_require__("TJ5S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet_dist_images_marker_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_leaflet_dist_images_marker_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_leaflet_dist_images_marker_shadow_png__ = __webpack_require__("wkq0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_leaflet_dist_images_marker_shadow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_leaflet_dist_images_marker_shadow_png__);

//
//
//
//
//
//
//
//
//
//
//
//
//





__webpack_require__("0J91");
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InventoryMapPage',
  props: {
    default: {
      type: Object
    }
  },
  data: function data() {
    return {
      isSmallWindow: false
    };
  },

  computed: {
    activeLanguage: function activeLanguage() {
      return this.$translations[this.$store.getters.currentLanguageValue];
    },
    getMapClass: function getMapClass() {
      return this.isSmallWindow ? 'map-mobile' : 'map';
    }
  },
  methods: {
    loadInventory: function loadInventory() {
      var tiles = void 0,
          latlng = void 0;
      // tiles = L.tileLayer('https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}{r}.png', {
      //   maxZoom: 13,
      //   minZoom: 2,
      //   attribution: '<a href="https://wikimediafoundation.org/wiki/Maps_Terms_of_Use">Wikimedia</a>'
      // })
      // tiles = L.tileLayer('https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png', {
      //   maxZoom: 13,
      //   minZoom: 2,
      //   attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="http://cartodb.com/attributions">CartoDB</a>'
      // })
      tiles = __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}', {
        maxZoom: 13,
        minZoom: 2,
        continuousWorld: true,
        attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community'
      });
      latlng = __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.latLng(19.638534, -39.399043);
      var map = __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.map('map', { center: latlng, zoom: 2.2, layers: [tiles], worldCopyJump: true });
      map.scrollWheelZoom.disable();
      map.on('click', function () {
        if (map.scrollWheelZoom.enabled()) {
          map.scrollWheelZoom.disable();
        } else {
          map.scrollWheelZoom.enable();
        }
      });
      var markers = __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.markerClusterGroup({
        chunkedLoading: true,
        iconCreateFunction: function iconCreateFunction(cluster) {
          var markers = cluster.getAllChildMarkers();
          var n = 0;
          for (var i = 0; i < markers.length; i++) {
            n += markers[i].petitions;
          }
          var size = n.toString().length;
          var xy = 0;
          var className = '';
          var divClass = '';
          var spanStyle = '';
          if (size === 1) {
            xy = 30;
            className = 'clusterIcon-1';
            divClass = 'divClass-1';
            spanStyle = '20px';
          } else if (size <= 4) {
            xy = 40;
            className = 'clusterIcon-4';
            divClass = 'divClass-4';
            spanStyle = '30px';
          } else if (size <= 5) {
            xy = 50;
            className = 'clusterIcon-6';
            divClass = 'divClass-6';
            spanStyle = '40px';
          } else if (size <= 10) {
            xy = 60;
            className = 'clusterIcon-10';
            divClass = 'divClass-10';
            spanStyle = '50px';
          } else if (size > 10) {
            xy = 70;
            className = 'clusterIcon-10';
            divClass = 'divClass-10';
            spanStyle = '60px';
          }
          return __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.divIcon({
            html: '<div class="' + divClass + '"> <span style="line-height: ' + spanStyle + '">' + n + '</span></div>',
            iconSize: __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.point(xy, xy),
            className: className
          });
        },
        // spiderfyOnMaxZoom: false,
        singleMarkerMode: true,
        chunkProgress: this.updateProgressBar
      });
      var markerList = [];
      this.$http.get(this.$PATH_NAME + 'petitions/cities/countAggregate').then(function (response) {
        var res = response.body;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(res).forEach(function (key, index) {
          if (res[key].latitude && res[key].longitude) {
            var title = res[key].signatures;
            var marker = __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.marker(__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.latLng(res[key].latitude, res[key].longitude));
            var icon = __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.icon({ iconUrl: __WEBPACK_IMPORTED_MODULE_2_leaflet_dist_images_marker_icon_png___default.a, shadowUrl: __WEBPACK_IMPORTED_MODULE_3_leaflet_dist_images_marker_shadow_png___default.a });
            marker.setIcon(icon);
            marker.petitions = title;
            marker.on('mouseover', function () {
              marker.bindPopup(key).openPopup();
            });
            marker.on('click', function (a) {
              var latlng = __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.latLng(a.latlng.lat, a.latlng.lng);
              map.setZoomAround(latlng, 9);
            });
            markerList.push(marker);
          }
        });
      }).catch(function (err) {
        if (err.status >= 500) {
          console.log('Server-Related problem');
        } else if (err.status === 400) {
          console.log('A bad request occurred');
        } else if (err.status === 404) {
          console.log(err.body.message);
        }
      }).finally(function () {
        markers.addLayers(markerList);
        map.addLayer(markers);
      });
      document.getElementsByClassName('leaflet-top')[0].setAttribute('style', 'z-index: 974 !important;');
      document.getElementsByClassName('leaflet-bottom')[0].setAttribute('style', 'z-index: 974 !important;');
      document.getElementsByClassName('leaflet-bottom')[1].setAttribute('style', 'z-index: 974 !important;');
    },
    updateProgressBar: function updateProgressBar(processed, total, elapsed, layersArray) {
      var progress = document.getElementById('progress');
      var progressBar = document.getElementById('progress-bar');
      if (elapsed > 1000) {
        // if it takes more than a second to load, display the progress bar:
        progress.style.display = 'block';
        progressBar.style.width = Math.round(processed / total * 100) + '%';
      }

      if (processed === total) {
        // all markers processed - hide the progress bar:
        progress.style.display = 'none';
      }
    },
    handleError: function handleError(err) {
      if (err.status >= 500) {
        console.log('Server-Related problem');
      } else if (err.status === 400) {
        console.log('A bad request occurred');
      } else if (err.status === 404) {
        console.log(err.body.message);
      }
    },
    checkWindowSize: function checkWindowSize() {
      if (!this.isSmallWindow && window.innerWidth < 1051) {
        this.isSmallWindow = true;
      } else if (this.isSmallWindow && window.innerWidth > 1051) {
        this.isSmallWindow = false;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.commit('setCurrentView', this.default);
    this.loadInventory();
    this.checkWindowSize();
    window.addEventListener('resize', function () {
      return _this.checkWindowSize();
    });
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),

/***/ "6A06":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/munich-university-of-applied-sciences.1a39568.jpg";

/***/ }),

/***/ "6DkJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/european-year.7e079ec.jpg";

/***/ }),

/***/ "6LGH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kedge-business-school.6a8f439.jpg";

/***/ }),

/***/ "6NYf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PageContentPlaceholder'
});

/***/ }),

/***/ "6Nz6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alpfoodway_background7_resized.a2c5660.jpg";

/***/ }),

/***/ "6Owy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__signPetitionPageComponents_SignPetitionPage__ = __webpack_require__("HPm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__paperPageComponents_PaperPage__ = __webpack_require__("sH5r");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ReadCartaModal',
  computed: {
    activeLanguage: function activeLanguage() {
      var currLang = this.$translations[this.$store.getters.currentLanguageValue];
      if (currLang.chartaContent) {
        return this.$translations[this.$store.getters.currentLanguageValue];
      } else {
        return this.$translations['English'];
      }
    },
    modalTitle: function modalTitle() {
      return this.activeLanguage.read + ' ' + this.activeLanguage.theCarta;
    }
  },
  methods: {
    showModal: function showModal() {
      this.$refs.readCartaModal.show();
    },
    hideModal: function hideModal() {
      this.$refs.readCartaModal.hide();
    },
    loadSignPetition: function loadSignPetition() {
      this.$store.commit('setCurrentView', __WEBPACK_IMPORTED_MODULE_0__signPetitionPageComponents_SignPetitionPage__["a" /* default */]);
      this.$router.push('/sign-petition');
    },
    loadPaper: function loadPaper() {
      this.$store.commit('setCurrentView', __WEBPACK_IMPORTED_MODULE_1__paperPageComponents_PaperPage__["a" /* default */]);
      this.$router.push('/paper');
    }
  },
  mounted: function mounted() {
    document.getElementById('readCartaModal___BV_modal_header_').setAttribute('style', 'background-color: #c41c21 !important; color: white !important;');
    document.getElementById('readCartaModal___BV_modal_header_').lastChild.setAttribute('style', 'color: white !important;');
  }
});

/***/ }),

/***/ "6Yfi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6omf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eventsPageComponents_EventsPage__ = __webpack_require__("Vd6i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilComponents_EventCard__ = __webpack_require__("4xIF");
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Events',
  components: { EventCard: __WEBPACK_IMPORTED_MODULE_1__utilComponents_EventCard__["a" /* default */] },
  data: function data() {
    return {
      events: []
    };
  },

  computed: {
    activeLanguage: function activeLanguage() {
      return this.$translations[this.$store.getters.currentLanguageValue];
    },
    areEventsPresent: function areEventsPresent() {
      return this.events.length > 0;
    }
  },
  methods: {
    loadEvents: function loadEvents() {
      this.$store.commit('setCurrentView', __WEBPACK_IMPORTED_MODULE_0__eventsPageComponents_EventsPage__["a" /* default */]);
      this.$router.push('/events');
    },
    fetchMostRecentEvents: function fetchMostRecentEvents() {
      var self = this;
      this.$http.get(this.$PATH_NAME + 'events/getHighlights/').then(function (response) {
        self.events = response.body;
      });
    }
  },
  mounted: function mounted() {
    this.fetchMostRecentEvents();
  }
});

/***/ }),

/***/ "6qrn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7EGA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-winnersModal"},[_c('b-modal',{ref:"winnersModal",attrs:{"id":"winnersModal","centered":"","hide-footer":"","size":"lg","title":"Contest \"Alpine Food Heritage Stories\""}},[_c('h1',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.activeLanguage.winners))]),_vm._v(" "),_c('b-row',_vm._l((_vm.activeLanguage.winnersList),function(person,idx){return _c('b-col',{key:idx,staticClass:"personal-card"},[_c('b-img',{staticClass:"m-1",attrs:{"rounded":"circle","width":"90","height":"90","blank-color":"#777","alt":person.surname,"src":person.picture}}),_vm._v(" "),_c('div',[_c('span',{staticClass:"name-style"},[_vm._v(_vm._s(person.name))]),_vm._v(" "),_c('span',{staticClass:"surname-style"},[_vm._v(_vm._s(person.surname))])]),_vm._v(" "),_c('p',{staticClass:"title-style"},[_vm._v(_vm._s(person.onSocial))]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('a',{staticStyle:{"text-align":"center"},attrs:{"href":person.postLink}},[_c('img',{staticStyle:{"background-color":"white","height":"100%","width":"80%","padding-bottom":"2%"},attrs:{"src":person.photo}})])])],1)],1)})),_vm._v(" "),_c('p',{staticClass:"adv-style"},[_vm._v(_vm._s(_vm.activeLanguage.regulationsItems[6].title)+":")]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.activeLanguage.regulationsItems[6].content)}}),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-button',{staticClass:"button-style float-right",on:{"click":_vm.hideModal}},[_vm._v(_vm._s(_vm.activeLanguage.close))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7VUD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alpfoodway_background11_resized.970a1c6.jpg";

/***/ }),

/***/ "7qbX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/europe-logo.0267703.jpg";

/***/ }),

/***/ "7vcr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountdownPanel_vue__ = __webpack_require__("EEWV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87d1f52a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountdownPanel_vue__ = __webpack_require__("dVbd");
function injectStyle (ssrContext) {
  __webpack_require__("ZZij")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-87d1f52a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountdownPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87d1f52a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountdownPanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7xEH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/uibk.fdb9d06.jpg";

/***/ }),

/***/ "8JEu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticStyle:{"max-width":"285px !important"},attrs:{"target":"_blank","href":_vm.newsUrl}},[_c('div',{staticClass:"f-newsCard embeddedPost-post"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 postAuthor"},[_c('span',{staticClass:"postAuthor-name identity-name",attrs:{"title":_vm.title}},[_vm._v("\n                "+_vm._s(_vm.title)+"\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-3 post-brand no-padding"},[[_c('a',{attrs:{"target":"_blank","href":_vm.newsUrl}},[_c('span',{staticClass:"followButton"},[_c('div',{class:_vm.giveClassFromType,attrs:{"aria-label":'View on ' + _vm.name,"title":'View on ' + _vm.name}})])])]],2)]),_vm._v(" "),_c('div',{class:_vm.getBodyClass},[(_vm.imageUrl)?_c('div',{class:_vm.getCardClass},[_c('img',{staticClass:"post-image",attrs:{"src":_vm.imageUrl}})]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"post-text text-justify",attrs:{"dir":"ltr"}},[_vm._v(_vm._s(_vm.description))]),_vm._v(" "),_c('div',{staticClass:"post-metadata dateline"},[_c('a',{staticClass:"u-linkBlend u-url customisable-highlight long-permalink",attrs:{"data-datetime":"2017-04-06T15:24:15+0000","data-scribe":"element:full_timestamp","data-url-ref-attrs-injected":"true"}},[_c('p',{staticClass:"dt-updated post-alert",attrs:{"title":"Time posted"}},[_vm._v("\n            "+_vm._s(_vm._f("moment")(_vm.createdAtMoment,'MMMM D, YYYY'))+"\n          ")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8Wzx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-signPetitionPage"},[_c('div',{staticClass:"title-container"},[_c('h1',[_vm._v(_vm._s(_vm.activeLanguage.signPetition)),_c('br'),_vm._v(" #AlpFoodwayUNESCO ")])]),_vm._v(" "),_c('signatures-counter'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 colg-md-6 col-sm-12"},[_c('SignCaption')],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 colg-md-6 col-sm-12"},[_c('SignForm',{on:{"submittedSign":_vm.showModal}})],1)]),_vm._v(" "),_c('ThankYouModal',{ref:"thankYouModal",on:{"closeModal":_vm.hideModal}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8XxR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "93d4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-aboutUsModal"},[_c('b-modal',{ref:"aboutUsModal",attrs:{"id":"aboutUsModal","centered":"","size":"lg","title":"AlpFoodwayUNESCO"}},[_c('p',{staticClass:"my-4 citation",attrs:{"id":"captionText"}},[_vm._v("\"Foodways are socioeconomic and cultural practices related to food production and consumption. Food heritage is a strong identity source for alpine populations. It goes beyond products to include productive landscapes and traditional knowledge on production techniques, consumption customs and rituals, and the transmission of ancient wisdom.\"\n    ")]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('a',{attrs:{"href":"http://www.alpine-space.eu/projects/alpfoodway/en/about/the-project/aims-activities","target":"_blank"}},[_c('b-button',{staticClass:"button-style"},[_vm._v(_vm._s(_vm.activeLanguage.readMore))])],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9v6C":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alpfoodway_background14_resized.43b1f79.jpg";

/***/ }),

/***/ "A4IU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_GridLoader_vue__ = __webpack_require__("N18m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1d07568d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_GridLoader_vue__ = __webpack_require__("0eYP");
function injectStyle (ssrContext) {
  __webpack_require__("MlWh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_GridLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1d07568d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_GridLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ABjK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-socialWallPage"},[_c('div',{staticClass:"title-container"},[_c('h1',[_vm._v(_vm._s(_vm.activeLanguage.contest)+"\n        "),_c('br'),_vm._v("\n        \"Alpine Food Heritage Stories\"")])]),_vm._v(" "),_c('b-row',{staticClass:"buttons-wrapper"},[_c('div',{staticClass:"regulation-box"},[_c('h5',{domProps:{"innerHTML":_vm._s(_vm.activeLanguage.regulationsItems[1].title)}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.activeLanguage.regulationsItems[1].content)}}),_vm._v(" "),_c('h5',{domProps:{"innerHTML":_vm._s(_vm.activeLanguage.regulationsItems[2].title)}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.activeLanguage.regulationsItems[2].content)}})]),_vm._v(" "),_c('b-col',[_c('button',{class:[ _vm.iconWrapper],on:{"click":function($event){_vm.openRegulationsModal()}}},[_c('p',{staticClass:"activeLabel",staticStyle:{"padding":"0"}},[_c('span',{staticClass:"iconc icon-rules"}),_vm._v("\n            "+_vm._s(_vm.activeLanguage.regulations)+"\n          ")])])]),_vm._v(" "),(_vm.activeLanguage.winnersList && _vm.activeLanguage.winnersList.length > 0)?_c('b-col',[_c('button',{class:[ _vm.iconWrapper],on:{"click":function($event){_vm.openWinnersModal()}}},[_c('p',{staticClass:"activeLabel",staticStyle:{"padding":"0"}},[_c('span',{staticClass:"iconc icon-winner"}),_vm._v(_vm._s(_vm.activeLanguage.winners)+"\n          ")])])]):_vm._e(),_vm._v(" "),_c('regulations-modal',{ref:"regulationsModal"}),_vm._v(" "),_c('winners-modal',{ref:"winnersModal"})],1),_vm._v(" "),(new Date() >= new Date('4/23/2019 13:00:00'))?[(new Date() >= new Date('6/16/2019 23:55:00'))?_c('div',[_c('p',{staticClass:"loading-subtitle"},[_vm._v(_vm._s(_vm.activeLanguage.contestClosing))])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.fetchTweetsOnLoadMore),expression:"fetchTweetsOnLoadMore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},[_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[(_vm.isLoadingContent)?_c('div',{key:"1"},[_c('p',{staticClass:"loading-subtitle"},[_vm._v(_vm._s(_vm.activeLanguage.contentLoading))]),_vm._v(" "),_c('grid-loader',{staticStyle:{"width":"100%"},attrs:{"loading":_vm.isLoadingContent,"color":"#c41c21","size":"40px"}})],1):(_vm.isEmptyContent)?_c('div',{key:"2"},[_c('p',{staticClass:"loading-subtitle"},[_vm._v(_vm._s(_vm.activeLanguage.contentEmpty))]),_vm._v(" "),_c('div',{staticClass:"empty-box"}),_vm._v(" "),_c('p',{staticClass:"loading-subtitle",staticStyle:{"margin-top":"10px"}},[_vm._v(_vm._s(_vm.activeLanguage.contestEnding))])]):_c('div',{key:"3"},[_c('div',{directives:[{name:"masonry",rawName:"v-masonry"}],class:_vm.getContainerClass,attrs:{"fit-width":true,"item-selector":".item","transition-duration":"0.3s"}},_vm._l((_vm.posts),function(post,index){return _c('div',{directives:[{name:"masonry-tile",rawName:"v-masonry-tile"}],key:index,staticClass:"item"},[_c('social-card',{attrs:{"post-content":post},on:{"update-image":_vm.handleOutDatedPost}})],1)}))])])],1)]:[_c('div',[_c('p',{staticClass:"loading-subtitle"},[_vm._v(_vm._s(_vm.activeLanguage.contestOpening))]),_vm._v(" "),_c('div',{staticClass:"contest-photo"})])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AC4n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statistics_vue__ = __webpack_require__("pHbe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bdea9ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Statistics_vue__ = __webpack_require__("sHBF");
function injectStyle (ssrContext) {
  __webpack_require__("D55E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6bdea9ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statistics_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bdea9ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Statistics_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AO9I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contestPageComponents_ContestPage__ = __webpack_require__("gz4D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilComponents_SocialCard__ = __webpack_require__("Kumg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contestPageComponents_WinnersModal__ = __webpack_require__("si9r");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Contest',
  components: { WinnersModal: __WEBPACK_IMPORTED_MODULE_2__contestPageComponents_WinnersModal__["a" /* default */], SocialCard: __WEBPACK_IMPORTED_MODULE_1__utilComponents_SocialCard__["a" /* default */] },
  data: function data() {
    return {
      posts: []
    };
  },

  computed: {
    activeLanguage: function activeLanguage() {
      var currLang = this.$translations[this.$store.getters.currentLanguageValue];
      if (currLang.regulationsItems) {
        return this.$translations[this.$store.getters.currentLanguageValue];
      } else {
        return this.$translations['Italian'];
      }
    },
    getContainerClass: function getContainerClass() {
      return this.isSmallWindow ? 'post-container-mobile' : 'post-container';
    },
    arePostsPresent: function arePostsPresent() {
      return this.posts.length > 0;
    }
  },
  methods: {
    loadContest: function loadContest() {
      this.$store.commit('setCurrentView', __WEBPACK_IMPORTED_MODULE_0__contestPageComponents_ContestPage__["a" /* default */]);
      this.$router.push('/contest');
    },
    loadWinners: function loadWinners() {
      this.$refs.winnersModal.showModal();
    },
    fetchMostRecentPosts: function fetchMostRecentPosts() {
      var self = this;
      this.$http.get(this.$PATH_NAME + 'contest/getHighlights/').then(function (response) {
        self.posts = response.body;
      });
    },
    handleOutDatedPost: function handleOutDatedPost(userScreenName) {
      this.areInformationOutdated = true;
      if (!this.profilesToUpdate) {
        this.profilesToUpdate = [];
      }
      if (!this.profilesToUpdate.includes(userScreenName)) {
        this.profilesToUpdate.push(userScreenName);
        console.log('Ask to update picture of ' + userScreenName);
      }
    },
    updateOutDatedPost: function updateOutDatedPost(userScreenName) {
      var self = this;
      this.$http.get(this.$PATH_NAME + '/social/updateProfileInformation/profile=' + userScreenName).then(function (response) {
        self.posts.forEach(function (post) {
          if (post.user.screenName === userScreenName) {
            post.user.profileImageUrl = response.body;
          }
        });
      }).catch(function (err) {
        this.handleError(err);
      });
    },
    checkWindowSize: function checkWindowSize() {
      if (!this.isSmallWindow && window.innerWidth < 1051) {
        this.isSmallWindow = true;
      } else if (this.isSmallWindow && window.innerWidth > 1051) {
        this.isSmallWindow = false;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.fetchMostRecentPosts();
    this.checkWindowSize();
    window.addEventListener('resize', function () {
      return _this.checkWindowSize();
    });
  }
});

/***/ }),

/***/ "AcjR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SocialCard',
  data: function data() {
    return {
      iconStyle: 'icon icon-verified',
      profileImageUrl: '',
      userScreenName: '',
      userName: '',
      verifiedUser: false,
      postId: '',
      postText: '',
      createdAt: '',
      imageUrl: '',
      externalUrl: '',
      type: '',
      isSmallWindow: false
    };
  },

  props: {
    postContent: {
      type: Object,
      default: {}
    }
  },
  computed: {
    userPostUrl: function userPostUrl() {
      if (this.type === 'Instagram') {
        return 'https://www.instagram.com/' + this.userScreenName;
      } else {
        return 'https://www.twitter.com/' + this.userScreenName;
      }
    },
    atScreenName: function atScreenName() {
      return this.userScreenName ? '@' + this.userScreenName : '(utente non riconosciuto)';
    },
    viewOnSocialUrl: function viewOnSocialUrl() {
      if (this.type === 'Instagram') {
        return this.externalUrl;
      }
      return this.userPostUrl + '/status/' + this.postId;
    },
    createdAtMoment: function createdAtMoment() {
      if (this.createdAt) {
        var s = this.$moment(this.createdAt);
        if (s.isValid()) {
          return s;
        }
      }
      return this.$moment();
    },
    isTwitter: function isTwitter() {
      return this.type === 'Twitter';
    },
    isInstagram: function isInstagram() {
      return this.type === 'Instagram';
    },
    isFacebook: function isFacebook() {
      return this.type === 'Facebook';
    },
    getCardClass: function getCardClass() {
      return this.isSmallWindow ? 'f-socialCard-mobile embeddedPost-post' : 'f-socialCard embeddedPost-post';
    }
  },
  methods: {
    initializeFields: function initializeFields() {
      if (this.postContent) {
        this.userScreenName = this.postContent.user.screenName;
        this.userName = this.postContent.user.name;
        this.verifiedUser = this.postContent.user.verified;
        this.postId = this.postContent.id_str;
        this.postText = this.postContent && this.postContent.text ? this.postContent.text.replace(/#(\w+)/g, '<a target="_blank" href="https://twitter.com/search?q=%23$1&src=typd" style="color: #1c94e0;">#$1</a>') : '';
        this.createdAt = this.postContent.createdAt;
        this.imageUrl = this.postContent.imageUrl;
        this.externalUrl = this.postContent.externalUrl;
        this.type = this.postContent.type;
      }
    },
    checkWindowSize: function checkWindowSize() {
      if (!this.isSmallWindow && window.innerWidth < 1051) {
        this.isSmallWindow = true;
      } else if (this.isSmallWindow && window.innerWidth > 1051) {
        this.isSmallWindow = false;
      }
    },
    checkProfileImage: function checkProfileImage(clb) {
      var self = this;
      if (this.postContent.user.profileImageUrl) {
        this.$http.get(this.postContent.user.profileImageUrl).then(function (response) {
          if (response.status === 200) {
            self.profileImageUrl = self.postContent.user.profileImageUrl;
            clb();
          }
        }).catch(function () {
          self.$emit('update-image', self.postContent.user.screenName);
          self.profileImageUrl = __webpack_require__("4BCQ");
          clb();
        });
      } else {
        self.$emit('update-image', self.postContent.user.screenName);
        self.profileImageUrl = __webpack_require__("4BCQ");
        clb();
      }
    }
  },
  created: function created() {
    var _this = this;

    this.checkProfileImage(function () {
      return _this.initializeFields();
    });
    this.checkWindowSize();
    window.addEventListener('resize', function () {
      return _this.checkWindowSize();
    });
  }
});

/***/ }),

/***/ "AhAL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AmSj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreditsModal_vue__ = __webpack_require__("HSNJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_004f6315_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreditsModal_vue__ = __webpack_require__("FB88");
function injectStyle (ssrContext) {
  __webpack_require__("E4zC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-004f6315"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreditsModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_004f6315_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreditsModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ApDy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilComponents_SocialCard__ = __webpack_require__("Kumg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_GridLoader_vue__ = __webpack_require__("A4IU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_masonry__ = __webpack_require__("w/U7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RegulationsModal__ = __webpack_require__("EhIp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WinnersModal__ = __webpack_require__("si9r");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_masonry__["a" /* VueMasonryPlugin */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContestPage',
  components: { WinnersModal: __WEBPACK_IMPORTED_MODULE_5__WinnersModal__["a" /* default */], RegulationsModal: __WEBPACK_IMPORTED_MODULE_4__RegulationsModal__["a" /* default */], SocialCard: __WEBPACK_IMPORTED_MODULE_0__utilComponents_SocialCard__["a" /* default */], GridLoader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_GridLoader_vue__["a" /* default */] },
  data: function data() {
    return {
      posts: [],
      socialFilter: { 'Twitter': false, 'Instagram': true },
      userFilter: { 'AlpFoodway': true, 'Others': true },
      isLoadingState: true,
      areInformationOutdated: false,
      profilesToUpdate: [],
      iconWrapper: 'icon-wrapper',
      isSmallWindow: false
    };
  },

  props: {
    default: {
      type: Object
    }
  },
  methods: {
    openRegulationsModal: function openRegulationsModal() {
      this.$refs.regulationsModal.showModal();
    },
    openWinnersModal: function openWinnersModal() {
      this.$refs.winnersModal.showModal();
    },
    fetchTweetsOnLoad: function fetchTweetsOnLoad() {
      var self = this;
      this.$http.get(this.$PATH_NAME + 'contest/get20' + this.getRequestValue).then(function (response) {
        if (response.status === 200) {
          self.posts = response.body;
          // setInterval(function () {
          //   self.pollNewPosts()
          // }, 3000)
        }
      }).catch(function (err) {
        this.handleError(err);
      }).finally(function () {
        this.isLoadingState = false;
      });
    },

    // pollNewPosts () {
    //   let self = this
    //   let lastId = this.posts[0].id_str
    //   this.$http.get(this.$PATH_NAME + 'contest/pollNew&fromId=' + lastId + this.getRequestValue).then((response) => {
    //     if (response.status === 200) {
    //       response.body.forEach((post) => {
    //         self.posts.push(post)
    //       })
    //     }
    //   }).catch(function (err) {
    //     this.handleError(err)
    //   })
    // },
    fetchTweetsOnLoadMore: function fetchTweetsOnLoadMore() {
      var self = this;
      if (this.posts[this.posts.length - 1]) {
        var lastId = this.posts[this.posts.length - 1].id_str;
        this.$http.get(this.$PATH_NAME + 'contest/get20&fromId=' + lastId + this.getRequestValue).then(function (response) {
          response.body.forEach(function (post) {
            self.posts.push(post);
          });
        }).catch(function (err) {
          this.handleError(err);
        });
      }
    },
    postIsShown: function postIsShown(post) {
      return this.socialFilter[post.type];
    },
    handleOutDatedPost: function handleOutDatedPost(userScreenName) {
      this.areInformationOutdated = true;
      if (!this.profilesToUpdate) {
        this.profilesToUpdate = [];
      }
      if (!this.profilesToUpdate.includes(userScreenName)) {
        this.profilesToUpdate.push(userScreenName);
        this.updateOutDatedPost(userScreenName);
      }
    },
    updateOutDatedPost: function updateOutDatedPost(userScreenName) {
      var self = this;
      this.$http.get(this.$PATH_NAME + '/social/updateProfileInformation/profile=' + userScreenName).then(function (response) {
        self.posts.forEach(function (post) {
          if (post.user.screenName === userScreenName) {
            post.user.profileImageUrl = response.body;
          }
        });
      }).catch(function (err) {
        this.handleError(err);
      });
    },
    handleError: function handleError(err) {
      if (err.status >= 500) {
        console.log('Server-Related problem');
      } else if (err.status === 400) {
        console.log('A bad request occurred');
      } else if (err.status === 404) {
        console.log(err.body.message);
      }
    },
    checkWindowSize: function checkWindowSize() {
      if (!this.isSmallWindow && window.innerWidth < 1051) {
        this.isSmallWindow = true;
      } else if (this.isSmallWindow && window.innerWidth > 1051) {
        this.isSmallWindow = false;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.commit('setCurrentView', this.default);
    this.fetchTweetsOnLoad();
    this.checkWindowSize();
    window.addEventListener('resize', function () {
      return _this.checkWindowSize();
    });
  },

  computed: {
    activeLanguage: function activeLanguage() {
      var currLang = this.$translations[this.$store.getters.currentLanguageValue];
      if (currLang.regulationsItems) {
        return this.$translations[this.$store.getters.currentLanguageValue];
      } else {
        return this.$translations['Italian'];
      }
    },
    isLoadingContent: function isLoadingContent() {
      return this.isLoadingState;
    },
    isEmptyContent: function isEmptyContent() {
      return this.posts.length === 0 && !this.isLoadingState;
    },
    getRequestValue: function getRequestValue() {
      return '/Twitter=' + this.socialFilter['Twitter'] + '&Instagram=' + this.socialFilter['Instagram'] + '/AlpFoodway=' + this.userFilter['AlpFoodway'] + '&OtherPosts=' + this.userFilter['Others'] + '/';
    },
    isAlpfoodwayDisabled: function isAlpfoodwayDisabled() {
      return !this.userFilter['AlpFoodway'];
    },
    getContainerClass: function getContainerClass() {
      return this.isSmallWindow ? 'post-container-mobile' : 'post-container';
    }
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),

/***/ "Aznw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B9Mr":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./NRP.jpg": "pLyr",
	"./bauges-park.jpg": "dlX9",
	"./brel.jpg": "mjNv",
	"./camonica-valley.jpg": "Zu6P",
	"./cassiano.jpg": "RJcO",
	"./crepa.jpg": "skj6",
	"./dislivelli-association.jpg": "xPuL",
	"./europe-logo.jpg": "jNpv",
	"./european-year.jpg": "3cM1",
	"./european-year.png": "+G02",
	"./kedge-business-school.jpg": "hyH3",
	"./lombardy-region.jpg": "1phh",
	"./munich-university-of-applied-sciences.jpg": "XD4g",
	"./polo-poschiavo.jpg": "qxbl",
	"./ragor.jpg": "g+Sx",
	"./rda.jpg": "V2UA",
	"./tsm.jpg": "ruDj",
	"./uibk.jpg": "MYcH",
	"./zrc-sazu.jpg": "GQI/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "B9Mr";

/***/ }),

/***/ "BCYe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bauges-park.1491121.jpg";

/***/ }),

/***/ "BDJT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LanguageHeader__ = __webpack_require__("F0Pn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader__ = __webpack_require__("rBvK");
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Headers',
  components: { MainHeader: __WEBPACK_IMPORTED_MODULE_1__MainHeader__["a" /* default */], LanguageHeader: __WEBPACK_IMPORTED_MODULE_0__LanguageHeader__["a" /* default */] },
  methods: {
    stickyAndDisappear: function stickyAndDisappear() {
      this.$refs.languageHeader.disappearBar();
      var header = document.getElementById('headersWrapper');
      var sticky = header.offsetTop;
      if (window.pageYOffset > sticky) {
        header.classList.add('sticky');
        header.setAttribute('style', 'width: ' + document.getElementById('app').offsetWidth + 'px !important;');
      } else {
        header.classList.remove('sticky');
      }
    }
  }
});

/***/ }),

/***/ "BFT3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-aboutUs"},[_c('h2',{staticClass:"title-container clickable",on:{"click":_vm.loadSignPetition}},[_vm._v("#AlpFoodway")]),_vm._v(" "),_c('div',{staticClass:"embed-frame"},[_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","controls":"","poster":"poster.png","src":"https://www.youtube.com/embed/s8AWxn-_3l0?rel=0","allowfullscreen":""}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BWZQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BYKs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShareCampaignModal_vue__ = __webpack_require__("Tzsc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_269d1671_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareCampaignModal_vue__ = __webpack_require__("UIej");
function injectStyle (ssrContext) {
  __webpack_require__("Aznw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-269d1671"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShareCampaignModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_269d1671_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareCampaignModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BbRT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bbv1":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./alpfoodway_background10_resized.jpg": "pYJd",
	"./alpfoodway_background11_resized.jpg": "7VUD",
	"./alpfoodway_background12_resized.jpg": "RL8R",
	"./alpfoodway_background13_resized.jpg": "fizp",
	"./alpfoodway_background14_resized.jpg": "9v6C",
	"./alpfoodway_background15_resized.jpg": "iOrO",
	"./alpfoodway_background16_resized.jpg": "HBbu",
	"./alpfoodway_background17_resized.jpg": "Pl2d",
	"./alpfoodway_background18_resized.jpg": "Cl5c",
	"./alpfoodway_background1_resized.jpg": "k9ZN",
	"./alpfoodway_background2_resized.jpg": "omdU",
	"./alpfoodway_background3_resized.jpg": "shP3",
	"./alpfoodway_background4_resized.jpg": "Y88W",
	"./alpfoodway_background5_resized.jpg": "WWdp",
	"./alpfoodway_background6_resized.jpg": "O5be",
	"./alpfoodway_background7_resized.jpg": "6Nz6",
	"./alpfoodway_background8_resized.jpg": "VlXi",
	"./alpfoodway_background9_resized.jpg": "XWjL"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Bbv1";

/***/ }),

/***/ "BnIg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contest_vue__ = __webpack_require__("AO9I");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5126c84e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contest_vue__ = __webpack_require__("QFP8");
function injectStyle (ssrContext) {
  __webpack_require__("bWOx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5126c84e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5126c84e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CArz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsPage_vue__ = __webpack_require__("OAz2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_386bb8ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsPage_vue__ = __webpack_require__("GwGh");
function injectStyle (ssrContext) {
  __webpack_require__("AhAL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-386bb8ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_386bb8ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Cl5c":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alpfoodway_background18_resized.25a61e4.jpg";

/***/ }),

/***/ "D3Vz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/polo-poschiavo.c39cc25.jpg";

/***/ }),

/***/ "D55E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dfce":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__signPetitionPageComponents_SignPetitionPage__ = __webpack_require__("HPm8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PaperPage',
  props: {
    default: {
      type: Object
    }
  },
  data: function data() {
    return {
      isSmallWindow: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.commit('setCurrentView', this.default);
    this.checkWindowSize();
    window.addEventListener('resize', function () {
      return _this.checkWindowSize();
    });
  },

  computed: {
    activeLanguage: function activeLanguage() {
      var currLang = this.$translations[this.$store.getters.currentLanguageValue];
      if (currLang.chartaContent) {
        return this.$translations[this.$store.getters.currentLanguageValue];
      } else {
        return this.$translations['English'];
      }
    }
  },
  methods: {
    loadSignPetition: function loadSignPetition() {
      this.$store.commit('setCurrentView', __WEBPACK_IMPORTED_MODULE_0__signPetitionPageComponents_SignPetitionPage__["a" /* default */]);
      this.$router.push('/sign-petition');
    },
    imagePath: function imagePath(imageNumber) {
      imageNumber = imageNumber + 7;
      return __webpack_require__("Bbv1")("./alpfoodway_background" + imageNumber + '_resized.jpg');
    },
    checkWindowSize: function checkWindowSize() {
      if (!this.isSmallWindow && window.innerWidth < 1051) {
        this.isSmallWindow = true;
      } else if (this.isSmallWindow && window.innerWidth > 1051) {
        this.isSmallWindow = false;
      }
    }
  }
});

/***/ }),

/***/ "E+vS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  Italian: {
    italianPartners: 'PARTNERS ITALIA',
    swissPartners: 'PARTNERS SVIZZERA',
    alpFoodWayDescription: 'Un approccio interdisciplinare, transnazionale e partecipativo al patrimonio culturale dell\'alimentazione alpina.',
    englishLanguage: 'INGLESE',
    italianLanguage: 'ITALIANO',
    germanLanguage: 'TEDESCO',
    frenchLanguage: 'FRANCESE',
    slovenianLanguage: 'SLOVENO',
    home: 'Home',
    events: 'Eventi',
    pastEvents: 'Eventi Passati',
    socials: 'Social Network',
    news: 'Notizie',
    supporters: 'Sostenitori',
    signPetition: 'Firma La Petizione',
    socialWall: 'Social Wall',
    loadMore: 'Carica Altro',
    peopleHaveSigned: 'Persone che hanno già firmato',
    mainSupporters: 'partners',
    otherSupporters: 'Sostenitori',
    supportersPosition: 'Scopri da dove vengono i nostri sostenitori',
    haveSigned: 'Persone che hanno già firmato la Petizione',
    statistics: 'Statistiche',
    read: 'Leggi',
    theCarta: 'La Carta',
    theCartaRound: 'La Carta del Patrimonio Alimentare Alpino',
    sign: 'Firma',
    thePetition: 'La petizione',
    thePetitionRound: 'La petizione AlpFoodwayUNESCO',
    share: 'Condividi',
    ourCampaign: 'La nostra campagna',
    signs: 'Firme',
    socialContents: 'Contenuti Social',
    insertName: 'Nome',
    insertSurname: 'Cognome',
    insertCity: 'Città',
    insertEmail: 'Indirizzo email',
    updatesAboutPetition: 'Desidero ricevere aggiornamenti riguardo la Petizione',
    confirmationPrivacyStatementPT1: 'Confermo di aver preso visione dell’',
    confirmationPrivacyStatementPT2: 'informativa sul trattamento dei dati',
    alreadyUsedEmail: 'Questo indirizzo email ha già firmato la Petizione',
    thankYouTitle: 'Grazie per aver firmato',
    thankYouSubtitle: 'Aiutaci a condividere la Petizione sui tuoi social network preferiti',
    maybeLater: 'Forse più tardi',
    noCitiesFound: 'Non sono state trovate città',
    contentLoading: 'Stiamo caricando i contenuti di questa pagina',
    contentEmpty: 'Al momento non ci sono contenuti disponibili in questa pagina',
    close: 'Chiudi',
    thanksForSharing: 'Grazie per aver condiviso, torna alla piattaforma',
    whySign: 'Perchè Firmare?',
    captionTitleSign: 'Petizione per l\'iscrizione nella Lista Rappresentativa del Patrimonio Culturale Immateriale dell’UNESCO   ',
    captionText: {
      p1: 'Il Patrimonio Alimentare delle Alpi comprende tutte le pratiche di produzione e conservazione  del cibo, nonchè i rituali di consumo, i saperi, le conoscenze e i paesaggi che lo rappresentano. La sua soppravvivenza dipende dalla capacità delle comunità alpine di scambiare cibo e servizi, di gestire beni comuni, di aiutarsi vicendevolmente. \n' + '\n' + 'Noi che abbiamo a cuore il futuro dell Alpi, vogliamo iscrivere il Patrimonio Alimentare Alpino nelle Lista Rappresentativa del Patrimonio Immateriale dell\'UNESCO:',
      p2: 'Leggi la Charta, scopri come puoi contribuire alla salvaguardia del Patrimonio Alimentare delle Alpi e sostieni la candidatura multinazionale UNESCO del Patrimonio Alimentare delle Alpi sottoscrivendo la Petizione.',
      reasons: ['perché è un elemento fondamentale dell\'identità culturale e delle abitudini di vita delle Alpi,', 'perché contribuisce alla resilienza delle comunità alpine,', 'perché è un motivo di scelta delle Alpi come luogo salubre di vita,', 'perché preserva la qualità dei paesaggi e la biodiversità delle Alpi,', 'perché è fondamentale per lo sviluppo sostenibile delle Alpi,', 'perché sostiene l\'attrattività turistica delle Alpi.']
    },
    insertYourData: 'Inserisci i tuoi dati',
    letsGetTo: 'Arriviamo a',
    inventory: 'Inventario',
    carouselTitles: ['#AlpFoodway', 'Creare un modello di sviluppo sostenibile', 'Sensibilizzazione', 'Mappatura e creazione di un inventario online', 'Collegare il patrimonio alimentare', 'Sviluppare e condividere'],
    carouselSubtitles: ['Un approccio interdisciplinare e partecipativo al patrimonio culturale dell\'alimentazione alpina', 'per le aree montane periferiche', 'per generare una rete di comunità del patrimonio alpino', 'all\'avanguardia del patrimonio alimentare alpino tradizionale', 'con strumenti innovativi di marketing e governance', 'una Charta of Alpine Food Heritage'],
    readMore: 'Leggi di più',
    others: 'Altri',
    joinUs: 'Trovaci nei nostri Social Networks',
    discover: 'Scopri',
    chartaContent: {
      generalTitle: 'Carta del Patrimonio Alimentare Alpino \n',
      catchPhrase: 'Preservare il Patrimonio Alimentare Alpino è anche nostra responsabilità.',
      chapter1: {
        title: 'Premessa',
        text: 'Noi, che abbiamo a cuore il futuro delle Alpi, vogliamo contribuire a salvaguardare il Patrimonio Alimentare Alpino attraverso la sua candidatura nella Lista Rappresentativa del Patrimonio Culturale Immateriale dell’Umanità dell’UNESCO.\n\n' + 'Il Patrimonio Alimentare delle Alpi comprende tutte le pratiche di produzione, trasformazione e conservazione del cibo, nonché i rituali di consumo, i saperi, le conoscenze e i paesaggi che lo rappresentano. Da sempre si fonda sulla capacità delle comunità alpine di scambiare cibo e servizi, di gestire beni comuni, di aiutarsi vicendevolmente.\n\n' + 'Crediamo sia importante per il futuro delle Alpi, perché:',
        purposes: ['è un elemento fondamentale dell’identità culturale e del modo di vivere delle popolazioni delle  Alpi,', 'contribuisce alla resilienza delle comunità alpine, ', 'preserva la qualità dei paesaggi e la biodiversità delle Alpi,', 'è fondamentale per lo sviluppo sostenibile delle Alpi,', 'aumenta l’attrattività delle regioni alpine.']
      },
      chapter2: {
        title: 'Lo scopo',
        text: 'La Carta del Patrimonio Alimentare delle Alpi è un documento partecipativo e condiviso che mobilita ogni cittadino, associazione, società e istituzione ad assumersi la responsabilità nell’assicurarne la salvaguardia e nel supportare la sua candidatura nella Lista Rappresentativa del Patrimonio Culturale Immateriale dell’Umanità dell’UNESCO.'
      },
      chapter3: {
        title: 'Patrimonio Alimentare delle Alpi',
        text: {
          p1: 'Le Alpi sono una delle catene montuose più estese d’Europa che attraversano l’Austria, la Slovenia, la Svizzera, il Liechtenstein, la Germania, la Francia e il Principato di Monaco. Comunemente descritte come il cuore montano d’Europa, sono caratterizzate da alti picchi, valli di origine glaciale, laghi e torrenti. Queste peculiarità, congiuntamente a condizioni climatiche e del suolo uniche, dovute all’esposizione solare e all’altitudine, creano le condizioni per una biodiversità straordinaria, arricchita da attività pastorali e agricole di popoli che si sono insediati in questi luoghi già dal Paleolitico.',
          p2: 'Nel corso dei secoli, dovendo vivere in queste aree periferiche, caratterizzate da condizioni climatiche sfavorevoli, da aree agricole di piccolo dimensioni e da insediamenti dispersi, le comunità alpine hanno attivato strategie di sopravvivenza specifiche e hanno trovato il modo di sostentarsi grazie alla trasmissione di conoscenze e stili di vita alle nuove generazioni. Le comunità hanno continuato a produrre e consumare localmente, spostandosi con cadenza stagionale dalle aree a bassa quota alle aree più alte, praticando l’agricoltura in armonia con la natura, basando la propria economia di sussistenza sulla transumanza e sulla conservazione degli alimenti, sfruttando le risorse naturali in modo sostenibile, lottando per la propria sopravvivenza e facendo un uso parsimonioso delle risorse. Queste comunità sono dipese dalla condivisione di beni e servizi, contando sull’aiuto reciproco e sullo sviluppo di competenze multifunzionali. La combinazione dell’autosostentamento con un’apertura alle altre culture e con l’abilità nell’adattare le innovazioni provenienti da altre aree ai territori montani ha forgiato i territori alpini e ha portato allo sviluppo di uno straordinario patrimonio alimentare alpino. Supportato dalla crescita di città alpine, hub di innovazioni tecnologiche e sociali con un’industria della distribuzione e del turismo in rapida crescita, questo patrimonio contribuisce alla competitività e all’attrattività dei territori alpini come insediamenti economicamente sostenibili.',
          p3: 'Il patrimonio alimentare delle Alpi è uno dei più importanti indicatori di questa particolare identità (macro) regionale. Essendo basato sulle comunità, crea legami forti tra persone molto diverse, replica valori comuni ed è parte di una particolare qualità di vita. È caratterizzato da un insieme di aspetti specifici della regione alpina, tangibili (territori produttivi, fabbricati, coltivazioni, piatti e utensili da cucina) e intangibili (agricoltura, viticoltura, allevamento, caccia, pesca d’acqua dolce e apicoltura, metodi di cottura e conservazione, ricette, abitudini alimentari, connotazioni sociali, relazioni familiari e comunitarie, riti e feste). La miscela di aspetti tradizionali diversi sono il risultato di una cultura alimentare versatile. Varietà di pani a lunga conservazione, verdure, formaggi, carni affumicate e salate e alimenti a base di carne lavorata per una lunga conservazione, erbe e frutti alpini, prelibatezze a base di impasti dolci sono alcuni fra i più rinomati esempi di piatti che, considerando le pratiche di consumo e le produzioni specifiche, preservano i valori culturali alpini e caratterizzano l’unicità di questa regione.'
        }
      },
      chapter4: {
        title: 'Il patrimonio alimentare delle Alpi rischia la perdita dei propri tratti distintivi',
        text: {
          p1: 'L’espansione urbana incontrollata, il turismo di massa, il traffico intenso, l’inquinamento dell’aria e dell’acqua, l’agricoltura intensiva e il surriscaldamento globale hanno un effetto negativo sulla qualità della vita degli abitanti e minacciano gli stili di vita tradizionali delle Alpi. Malgrado rimangano le montagne più densamente abitate del mondo, le Alpi oggigiorno devono affrontare fenomeni di spopolamento e abbandono delle terre alte che causano una decrescita delle terre coltivate secondo l’agricoltura tradizionale e delle occupazioni relative, così come una perdita delle conoscenze e delle competenze, delle tradizioni, delle pratiche e dei valori che caratterizzano il patrimonio alpino alimentare. La salvaguardia del patrimonio alimentare alpino è quindi essenziale per preservare la cultura e l’identità degli abitanti delle Alpi, per ripristinare uno stile di vita sostenibile che rispetti i fragili ecosistemi dell’ambiente alpino, per promuovere e preservare la qualità dei territori e per assicurare uno sviluppo sostenibile delle regioni alpine per le generazioni presenti e future.',
          p2: 'Nel 2003, l’UNESCO ha adottato la Convenzione per la Salvaguardia del Patrimonio Culturale Immateriale che supporta le comunità, i gruppi e gli individui nell’identificare e definire il proprio patrimonio culturale immateriale e per accrescere la consapevolezza per la sua salvaguardia. Le comunità alpine di Austria, Slovenia, Italia, Svizzera, Germania e Francia intendono quindi unitamente convincere gli Stati a depositare una candidatura congiunta del Patrimonio Alimentare delle Alpi nella Lista Rappresentativa del Patrimonio Culturale Immateriale dell’Umanità dell’UNESCO.'
        }
      },
      chapter5: {
        title: 'Impegno nel salvaguardare il Patrimonio Alimentare delle Alpi',
        text: {
          p1: 'Per superare queste sfide, l’iscrizione del Patrimonio Alimentare delle Alpi nella Lista Rappresentativa del Patrimonio Culturale Immateriale dell’Umanità dell’UNESCO può essere ottenuto solo attraverso il coinvolgimento dei cittadini, delle comunità, delle associazioni, degli imprenditori, delle istituzioni nelle Alpi e attraverso il loro impegno nella salvaguardia del patrimonio. Tutti possono assumersi e condividere questa responsabilità per il futuro del Patrimonio Alimentare delle Alpi.',
          uls: [{
            title: 'Come agricoltori e produttori:',
            lis: ['continueremo nella produzione di cibi specifici locali, preservando paesaggi rurali e biodiversità, agevolando al tempo stesso l’utilizzo di varietà locali di semenze, specie vegetali e allevamenti di animali;', 'rispetteremo i principi ecologici fondanti nelle attività agricole e nel trasporto degli alimenti per garantire il consumo di cibi salutari ai consumatori e per contribuire alla sostenibilità ambientale;', 'valorizzeremo i prodotti prevedendo prezzi equi nel rispetto della dignità del nostro lavoro, prezzi capaci di evidenziare la differenza dei nostri prodotti rispetto a beni di consumo di massa;', 'coopereremo con i ristoratori locali e con gli imprenditori del turismo attraverso catene produttive che offrano prodotti locali finalizzati a promuovere la cultura alimentare locale;', 'preserveremo, manifesteremo orgoglio e promuoveremo le pratiche agricole tradizionali, la conservazione dei saperi legati al cibo, le ricette e le tecniche culinarie così come i piatti tipici che costituiscono la base del Patrimonio Alimentare delle Alpi.']
          }, {
            title: 'Come cittadini delle Alpi:',
            lis: ['daremo supporto ai contadini, agli artigiani, ai produttori di cibi alpini acquistando le loro coltivazioni e produzioni;', 'visiteremo i mercati locali per avvantaggiarci delle varietà dei prodotti locali;', 'prepareremo piatti alpini per trasferire queste conoscenze alle giovani generazioni;', 'ci uniremo alle comunità di pratica, svolgendo attività di volontariato finalizzate a promuovere e preservare il Patrimonio Alimentare delle Alpi;', 'incoraggeremo le istituzioni locali per supportare la salvaguardia del Patrimonio Alimentare delle Alpi.']
          }, {
            title: 'Come turisti nelle Alpi:',
            lis: ['rispetteremo l’ambiente naturale per preservare la biodiversità e la qualità dei territori rurali alpini;', 'chiederemo ai ristoratori alpini di servire cibo tradizionale prodotto localmente;', 'prenderemo parte a festival alpini e ad altri eventi per sostenere le comunità locali;', 'visiteremo musei locali per conoscere il cibo alpino e le altre componenti del  Patrimonio Alimentare delle Alpi;', 'promuoveremo il Patrimonio Alimentare delle Alpi e i festival dedicati al cibo alpino diffondendone la conoscenza presso amici e comunità a livello globale.']
          }, {
            title: 'Come istituzioni culturali ed educative ci impegniamo per:',
            lis: ['salvaguardare il Patrimonio Alimentare delle Alpi locale con studi, documentazione, analisi e promozione;', 'rafforzare la trasmissione del Patrimonio Alimentare delle Alpi grazie all’organizzazione di forum ed eventi culturali così come provvedendo a fornire spazi dedicati a performance dedicate al tema;', 'migliorare la conoscenza comune del Patrimonio Alimentare Alpino facendo conoscere alle persone le tradizioni locali e il loro potenziale nel salvaguardare il patrimonio;', 'trasmettere la conoscenza presso le giovani generazioni;', 'supportare le comunità di pratica alpine aiutandole a riconoscere e valorizzare il loro patrimonio alimentare e motivandole nel rivestire un ruolo attivo nelle attività di preservazione del patrimonio;', 'assistere le comunità alpine nel preservare i paesaggi rurali così come i loro spazi abitativi e gli elementi fondanti della loro identità locale;', 'cooperare con istituzioni similari dentro e fuori le regioni o le nazioni tramite azioni comuni impegnate a favore del Patrimonio Alimentare Alpino;', 'convincere le autorità della necessità di salvaguardare il Patrimonio Alimentare Alpino e di supportare le comunità di pratica.']

          }, {
            title: 'Come istituzioni scientifiche, ci impegniamo:',
            lis: ['nella ricerca sul Patrimonio Alimentare delle Alpi, in particolare sui suoi effetti sulla salute umana, l’identità culturale e lo stile di vita, la biodiversità, la conservazione del paesaggio e lo sviluppo sostenibile;', 'nello studiare i collegamenti tra aree rurali e aree urbane alpine per comprendere le dinamiche rurali e urbane nella produzione e nel consumo di cibo;', 'a cooperare con le organizzazioni culturali, educative e turistiche e con i media per garantire una migliore trasmissione delle conoscenze;', 'a collaborare con diverse comunità scientifiche per fornire approfondimenti transnazionali multidisciplinari sull’importanza del Patrimonio Alimentare delle Alpi;', 'a fare pressioni sugli Stati e sull’Unione europea per finanziare la ricerca multidisciplinare, programmi o progetti applicati a sostegno dello sviluppo delle regioni alpine.']
          }, {
            title: 'Come organizzazioni turistiche, possiamo:',
            lis: ['promuovere i ristoranti e i festival alpini tradizionali come attrazioni turistiche;', 'creare pacchetti turistici a tema focalizzati sul cibo artigianale e sull’agricoltura di montagna, sulla produzione, la lavorazione, la cucina o la degustazione mettendo in evidenza la relazione fra la qualità della produzione alimentare e la qualità del paesaggio rurale;', 'potenziare percorsi o circuiti relativi al cibo alpino regionale e transnazionale;', 'supportare le comunità locali nell’organizzazione di attività ed eventi a tema alimentare.']
          }, {
            title: 'Come media, giornalisti e influencer, possiamo:',
            lis: ['diffondere nel mondo l’unicità del Patrimonio Alimentare delle Alpi;', 'promuovere il lavoro di agricoltori, produttori di cibi, e venditori al dettaglio delle aree alpine;', 'cooperare con le comunità locali e con le organizzazioni culturali per promuovere le loro attività attraverso modalità innovative;', 'informare gli imprenditori e le autorità locali in merito alle potenzialità del Patrimonio Alimentare delle Alpi per l’identità regionale, l’economia locale e per lo sviluppo sostenibile.']
          }, {
            title: 'Come imprenditori e venditori al dettaglio della catena produttiva:',
            lis: ['compreremo e venderemo cibi prodotti nelle aree alpine, sostenendo gli agricoltori e i produttori di cibo tradizionali;', 'stabiliremo prezzi equi per i prodotti che sono Patrimonio Alimentare Alpino;', 'useremo strategie promozionali che evidenzino le caratteristiche peculiari di questi prodotti raccontando le loro storie ed educando il gusto dei consumatori;', 'supporteremo le iniziative quali i marchi territoriali e le reti locali che promuovono il Patrimonio Alimentare Alpino;', 'rispetteremo i diritti delle comunità di pratica nel definire il marchio dei prodotti o nel registrare le indicazioni geografiche.']
          }, {
            title: 'Come ristoranti e chef, possiamo:',
            lis: ['comprare ingredienti prodotti nelle Alpi al fine di sostenere gli agricoltori e i produttori di cibo locali;', 'contribuire alla promozione del Patrimonio Alimentare Alpino offrendo piatti ispirati alle tradizioni locali, usando ingredienti autentici e rispettando il ritmo delle stagioni;', 'imparare ricette tradizionali dalle comunità alpine e riconoscere il ruolo dei portatori degli interessi della tradizione;', 'supportare le iniziative quali i marchi territoriali e le reti locali che promuovono il Patrimonio Alimentare Alpino']
          }, {
            title: 'In qualità di autorità locali e regionali, possiamo:',
            lis: ['agevolare l’accesso delle comunità, associazioni, istituzioni e imprenditori alpini alla conoscenza delle modalità di preservazione, trasmissione e promozione del patrimonio alimentare;', 'adottare misure adeguate per proteggere il Patrimonio Alimentare Alpino delle regioni e per supportare gli agricoltori locali, gli artigiani produttori di cibo e le comunità di pratica nel loro sforzo per preservarlo e promuoverlo;', 'supportare attivamente la rete di attori impegnati nell’iscrivere il Patrimonio Alimentare Alpino nella Lista UNESCO Rappresentativa del Patrimonio Culturale Intangibile dell’Umanità e nel metterli in contatto con le autorità nazionali.']
          }, {
            title: 'Come autorità nazionali, possiamo:',
            lis: ['lavorare con le autorità locali e regionali presenti nelle Alpi per sostenere la tutela del Patrimonio Alimentare Alpino e per creare modalità sostenibili per la sua fruizione nell’economia locale;', 'adottare misure a sostegno dello sviluppo sostenibile delle regioni alpine nei nostri Paesi;', 'cooperare a livello transnazionale per il riconoscimento del Patrimonio Alimentare Alpino  come patrimonio comune meritevole di salvaguardia e portatore di un ruolo cruciale per lo sviluppo sostenibile delle Alpi;', 'supportare la candidatura del Patrimonio Alimentare Alpino nella Lista UNESCO Rappresentativa del Patrimonio Culturale Intangibile dell’Umanità e promuovere gli sforzi delle comunità alpine a livello transnazionale.']
          }]
        }
      },
      chapter6: {
        title: '',
        text: {
          p1: 'Noi, che abbiamo a cuore il futuro delle Alpi, crediamo sia urgente salvaguardare il Patrimonio Alimentare delle Alpi per preservare l’identità, lo stile di vita, il paesaggio, la biodiversità, e lo sviluppo sostenibile delle Alpi. Condividendo questa responsabilità, il Patrimonio Alimentare delle Alpi può essere salvaguardato con maggiore efficacia.',
          p2: ''
        }
      }
    },
    privacyPolicy: [{
      title: 'POLITICHE DI RISERVATEZZA',
      content: 'Visitando il nostro sito Web, l’utente accetta le pratiche descritte nella presente sezione informativa sulla privacy denominata “Privacy Policy”.'
    }, {
      title: 'INFORMAZIONI',
      content: 'AlpFoodway non raccoglie informazioni quando si compila il modulo di firma della petizione. Il modulo compilato viene inviato direttamente al nostro server come e-mail. AlpFoodway utilizza i tuoi dati solo per interagire con te, per fornirti il ​​supporto richiesto e per localizzare in modo aggregato i sostenitori dell’iniziativa. AlpFoodway non utilizzerà il tuo indirizzo per inviarti e-mail periodiche o per scopi commerciali e utilizzerà solamente una localizzazione aggregata degli utenti. Se, in qualsiasi momento, desideri che cancelliamo i tuoi dati di contatto inerenti la firma della petizione, ti invitiamo ad inviarci una e-mail a <a href="mailto:info@alpfoodway.eu">info@alpfoodway.eu</a> e lo faremo entro quindici giorni lavorativi.'
    }, {
      title: 'INFORMAZIONI CONDIVISE',
      content: 'AlpFoodway non vende, scambia o trasferisce in alcun modo informazioni di identificazione personale a terzi parti. Qualora AlpFoodway dovesse trasferire informazioni personali identificabili a terze parti che ci assistono nella gestione della piattaforma web, AlpFoodway lo farebbe solo a condizione che queste terze parti accettino di mantenere tali informazioni riservate. Inoltre, Alpfoodway rilascerà alcune informazioni personali identificabili se obbligate a farlo, nel rispetto della legge o per proteggere i diritti, la sicurezza o le proprietà dei nostri o di altri partner.'
    }, {
      title: 'LINK DI TERZE PARTI',
      content: 'Eccezionalmente, a nostra discrezione, potremmo pubblicare link di terze parti sul nostro sito web. Questi siti di terze parti hanno politiche sulla privacy separate e indipendenti. Quindi AlpFoodway non può essere ritenuta responsabile per il contenuto e le attività di questi siti collegati. Sono graditi un qualsiasi feed-back o segnalazioni su questi siti web.'
    }, {
      title: 'COOKIES',
      content: 'AlpFoodway non utilizza alcun cookie nel suo sito, ma non possiamo escludere che Google Analytics lo faccia. I cookie sono piccoli file che un sito web, o il suo fornitore di servizi, trasferisce sul disco rigido del tuo computer attraverso il tuo browser web (se lo permetti). I cookie consentono al sito o ai sistemi dei suoi fornitori di servizi di riconoscere il tuo browser e di acquisire e ricordare alcune informazioni.'
    }, {
      title: 'I CAMBIAMENTI',
      content: 'Alpfoodway si riserva il diritto di modificare la sua politica sulla privacy in qualsiasi momento. L’ultima versione sarà sempre pubblicata online.\n' + 'Per ulteriori informazioni sulla nostra politica sulla privacy, vi preghiamo di contattarci all’indirizzo <a href="mailto:info@alpfoodway.eu">info@alpfoodway.eu</a>.'
    }],
    contest: 'Contest',
    regulations: 'Leggi il regolamento completo',
    winners: 'Vincitori',
    winnersList: [
      // {
      //   name: '',
      //   surname: '',
      //   picture: '',
      //   onSocial: '',
      //   postLink: '',
      //   photo: ''
      // }
    ],
    contestOpening: 'Il contest fotografico inizierà il 23/04/2019',
    contestEnding: 'Il contest fotografico terminerà il 16/06/2019',
    contestClosing: 'Il contest fotografico è terminato il 16/06/2019',
    regulationsItems: [{
      title: 'CONCORSO DI STORYTELLING  FOTOGRAFICO: "ALPINE FOOD HERITAGE STORIES"',
      content: 'AlpFoodway, progetto di Cooperazione transnazionale Alpine Space, organizza un concorso di storytelling fotografico denominato “Alpine Food Heritage Stories”, secondo le modalità indicate nel presente regolamento.'
    }, {
      title: 'Tema',
      content: 'Il Concorso, intende raccontare il Patrimonio Alimentare alpino attraverso narrazioni fotografiche. Scopo dell’iniziativa è allargare il supporto alla salvaguardia del Patrimonio Alimentare delle Alpi e alla sua candidatura nella Lista Rappresentativa del Patrimonio Culturale Immateriale dell’Umanità dell’UNESCO.\n' + 'I progetti di storytelling proposti dovranno raccontare il Patrimonio Alimentare Alpino che comprende le pratiche di produzione, trasformazione e conservazione del cibo, nonché i rituali di consumo, i saperi, le conoscenze e i paesaggi che lo rappresentano. \n' + 'Un patrimonio di cultura e socialità che da sempre si fonda sulla capacità delle comunità alpine di “vivere di montagna”, scambiando cibo e servizi, gestendo beni comuni e trasmettendo pratiche e saperi tra le generazioni.'
    }, {
      title: 'Modalità di partecipazione',
      content: 'A partire dal 13/05/2019 e fino al 16/06/2019 puoi postare i tuoi racconti visivi sul social network “Instagram” utilizzando il tuo account in modalità pubblica.<br/><br/>Per partecipare al concorso, occorre attenersi alle seguenti regole:' + '<ul style="padding-left: 7%; padding-top: 2%">' + '<li>i post dovranno essere realizzati attraverso n. 3 sole immagini di buona qualità;</li>' + '<li>i post dovranno essere corredati dall’hashtag #AlpFoodwayContest e dal tag @AlpFoodway_project;</li>' + '<li>i post devono essere geolocalizzati;</li>' + '<li>nella descrizione del post occorre indicare il luogo e la data dei tre scatti. Nessun altro testo è ammesso.</li>' + '<li>altri hashtags, strettamente connessi alle immagini possono essere aggiunti, ma non più di 10;</li>' + '<li>per consentire l’accesso ai post ai membri della Giuria, è essenziale che l’account sia utilizzato in modalità pubblica.</li>' + '</ul>' + '<p style="color: #c41c21; text-align: center;"><b>Tutti i post pubblicati verranno visualizzati sul social wall della piattaforma <a href="https://www.alpfoodway.eu" target="_blank">www.alpfoodway.eu</a>.</p>'
    }, {
      title: 'Idoneità',
      content: 'La partecipazione è riservata a coloro che abbiano almeno 18 anni. Non è ammessa la partecipazione al Contest di staff e collaboratori dei partners del progetto Alpfoodway.'
    }, {
      title: 'Dichiarazioni e Garanzie',
      content: 'Partecipando al concorso, i partecipanti accettano incondizionatamente il presente regolamento.<br/><br/>' + 'I contenuti dovranno essere coerenti alle tematiche oggetto del Concorso. A tal proposito, il gruppo dei partner di progetto, a suo insindacabile giudizio, potrà escludere dalle visualizzazioni i post ritenuti impropri che violino qualsivoglia diritto di qualsiasi parte, incluso, a titolo non esaustivo il diritto d’autore, marchi registrati, diritto pubblicitario, diritto alla proprietà intellettuale di terze parti e il diritto alla privacy. In nessun caso le immagini inviate potranno contenere dati qualificabili come sensibili, inappropriati, indecenti, lesivi, diffamatori nonché illegali o contrari alla legge.' + '<br/><br/>Ogni partecipante è responsabile civilmente e penalmente delle proprie opere; Polo Poschiavo, lead partner del progetto Alpfoodway e promotore del Contest, sarà sollevato da ogni responsabilità, anche nei confronti di eventuali soggetti raffigurati nelle fotografie. Il concorrente dovrà tuttavia informare persone eventualmente ritratte, nonché procurarsi il consenso alla diffusione dagli stessi, pena l’esclusione dal concorso. L’Organizzatore non sarà̀ in alcun modo responsabile per eventuali richieste di risarcimento avanzate da soggetti ritratti che appaiono nelle fotografie inviate o da detentori di diritti per cui non sia stata richiesta la necessaria liberatoria.' + '<br/><br/>In caso di controversia, il proprietario autorizzato dell’account di social media utilizzato per l’iscrizione sarà considerato come il partecipante e dovrà conformarsi al presente Regolamento. \n' + 'Il "titolare autorizzato dell\'account" è la persona fisica assegnata all\'account di social media o all\'indirizzo email applicabili da un provider Internet, un fornitore di servizi online o un\'altra organizzazione responsabile dell\'assegnazione degli indirizzi email per il dominio associato all\'indirizzo in oggetto. Ogni partecipante potrebbe essere tenuto a dare prova di essere un titolare autorizzato di account.'
    }, {
      title: 'Proprietà e disponibilità delle fotografie ',
      content: 'I partecipanti, nel momento in cui scelgono di postare la o le foto/video con l’hashtag che identifica l’adesione al bando concorsuale, ne legittimano l’utilizzo, la pubblicazione e diffusione (con qualsiasi mezzo consentito dalla tecnologia, in qualsiasi formato e tramite qualsiasi canale) da parte del  gruppo dei partner di progetto per le sole finalità connesse alla promozione del concorso stesso e del progetto “Alpfoodway”, senza che ciò implichi l’obbligo di una previa richiesta di autorizzazione.'
    }, {
      title: 'Premi',
      content: 'Non sono previsti premi in denaro. Il premio, quale riconoscimento del merito personale dei 3 migliori partecipanti, consisterà̀ in:' + '<ul>' + '<li>il migliore lavoro verrà premiato con la partecipazione gratuita al Media Trip “Alpfoodway” con giornalisti e fotografi di fama internazionale. Il Media trip partirà il 3 luglio 2019 da Le Chatelard (Savoie, FR) e arriverà a Edolo (Valcamonica, I) il giorno 9 luglio 2019. Tappe intermedie: Valle d’Aosta, Cantone Vallese (CH), Cantone Grigioni –(CH);</li>' + '<li>pubblicazione dei migliori lavori sul sito e su tutti i social media del progetto “AlpFoodway”;</li>' + '</ul>' + 'Tutti i lavori presentati potranno inoltre essere inclusi nel Dossier di candidatura all’UNESCO per la nomina del Patrimonio Alimentare Alpino nella Lista Rappresentativa del Patrimonio Culturale Immateriale dell’Umanità.'
    }, {
      title: 'Giuria e comunicazione ai vincitori',
      content: 'I lavori verranno valutati da una Giuria qualificata composta da un gruppo selezionato dei partner di progetto. La Giuria valuterà gli elaborati e sceglierà, a suo insindacabile giudizio, i 3 lavori migliori sulla base dei seguenti elementi: ' + '<ul>' + '<li> coerenza con il tema proposto (50%);</li>' + '<li>originalità e creatività; (25%)</li>' + '<li>numero di preferenze (likes) espresse dagli utenti Instagram (25%).</li>' + '</ul>' + 'Si prega di considerare il fatto che verranno valutati solo i post che avranno raggiunto minimo 100 likes in totale, considerando le tre foto pubblicate. La Giuria valuterà i post a partire dai primi 100 partecipanti che hanno raggiunto minimo 100 likes, in ordine cronologico di arrivo.<br/><br/>' + 'Il Vincitore e gli Autori Meritevoli saranno avvisati dall’Organizzatore con messaggio entro il 24 giugno 2019.<br/><br/>' + 'Se necessario verrà richiesto di inviare le liberatorie/autorizzazioni di tutte le terze parti che appaiono nelle immagini.<br/><br/>' + 'L’Elenco dei vincitori sarà disponibile all’indirizzo <a href="https://www.alpfoodway.eu" target="_blank">www.alpfoodway.eu</a>' + '<br/><br/>' + '<h6 style="color: #c41c21;">Link Utili</h6>' + '<ul>' + '<li><a href="https://www.alpine-space.eu/projects/alpfoodway/en/home" target="_blank">www.alpine-space.eu/projects/alpfoodway/en/home</a></li>' + '<li><a href="https://www.alpfoodway.eu" target="_blank">www.alpfoodway.eu</a></li>' + '<li><a href="https://www.intagiblesearch.eu">www.intagiblesearch.eu</a></li>' + '</ul>'
    }],
    youtubeGallery: 'Video',
    inventoryMap: 'Mappa Inventario',
    becomeSupporter: 'Diventa Sostenitore',
    gallery: 'Valori ICH'
  },
  English: {
    italianPartners: 'ITALIAN PARTNERS',
    swissPartners: 'SWISS PARTNERS',
    alpFoodWayDescription: 'A cross-disciplinary, transnational and participative approach to Alpine food cultural heritage.',
    englishLanguage: 'ENGLISH',
    italianLanguage: 'ITALIAN',
    germanLanguage: 'GERMAN',
    frenchLanguage: 'FRENCH',
    slovenianLanguage: 'SLOVENIAN',
    home: 'Home',
    events: 'Events',
    pastEvents: 'Past Events',
    socials: 'Social Networks',
    news: 'News',
    supporters: 'Supporters',
    signPetition: 'Sign The Petition',
    socialWall: 'Social Wall',
    loadMore: 'Load More',
    whySign: 'Why Sign?',
    captionTitleSign: 'Petition for the nomination for the UNESCO Representative list of the Intangible cultural heritage of Humanity',
    captionText: {
      p1: 'Alpine Food Heritage is the set of sustainable production and consumption practices, knowledge and skills, productive landscapes and locally produced traditional food in the Alpine regions. It depends on commons, shared goods and services, and on mutual assistance. We, people who care about the future of the Alps, want to safeguard Alpine Food Heritage, also through the inscription on the UNESCO Representative List of the Intangible Cultural Heritage of Humanity, because:',
      p2: 'Read the Charter, discover how you can engage in Alpine Food Heritage safeguarding, and support the multinational nomination of the Alpine Food Heritage for the UNESCO Representative list of the Intangible cultural heritage of Humanity by signing the petition.',
      reasons: ['it is the basis of Alpine cultural identity and way of life,', 'it contributes to the resilience of Alpine communities,', 'it motivates people to live in Alpine rural areas,', 'it preserves productive landscapes and biodiversity,', 'it is fundamental for the sustainability of the Alps,', 'it fosters the attractiveness of Alpine regions.']
    },
    peopleHaveSigned: 'People that have already signed',
    mainSupporters: 'partners',
    otherSupporters: 'Supporters',
    supportersPosition: 'Find out from where our supporters come from',
    haveSigned: 'People that have already signed the Petition',
    statistics: 'Statistics',
    read: 'Read',
    theCarta: 'The Charter',
    theCartaRound: 'Alpine Food Heritage Charter',
    sign: 'Sign',
    thePetition: 'The petition',
    thePetitionRound: 'The AlpFoodwayUNESCO petition',
    share: 'Share',
    ourCampaign: 'Our campaign',
    signs: 'Signatures',
    socialContents: 'Social Contents',
    insertName: 'Name',
    insertSurname: 'Surname',
    insertCity: 'City',
    insertEmail: 'email address',
    updatesAboutPetition: 'I would like to receive updates about the Petition',
    confirmationPrivacyStatementPT1: 'I confirm that I have read the',
    confirmationPrivacyStatementPT2: ' information on the processing of data',
    alreadyUsedEmail: 'This email address has already signed the Petition',
    thankYouTitle: 'Thank you for having signed',
    thankYouSubtitle: 'Help us share the Petition on your favourite social networks',
    maybeLater: 'Maybe later',
    noCitiesFound: 'No cities found',
    contentLoading: 'We are loading the content of this page',
    contentEmpty: 'Right now there is no available content in this page',
    close: 'Close',
    thanksForSharing: 'Thanks for sharing, go back to the platform',
    insertYourData: 'Fill out the Petition form',
    letsGetTo: 'Let\'s get to',
    inventory: 'Inventory',
    carouselTitles: ['#AlpFoodway', 'Creating a sustainable development model', 'Raising awareness to generate', 'Mapping and creating a cutting edge', 'Linking food heritage', 'Developing and sharing'],
    carouselSubtitles: ['A cross-disciplinary and participative approach to Alpine food cultural heritage', 'For peripheral mountain areas', 'A network of Alpine Heritage Communities', 'Online inventory of traditional Alpine food heritage', 'With innovative marketing and governance tools', 'A Charter of Alpine Food Heritage'],
    readMore: 'Read More',
    others: 'Others',
    joinUs: 'Join Us in our Social Networks',
    discover: 'Discover',
    chartaContent: {
      generalTitle: 'Alpine Food Heritage Charter',
      catchPhrase: 'Preserving Alpine food heritage is our responsibility too',
      chapter1: {
        title: 'Preamble',
        text: 'We, people who care about the future of the Alps, endorse safeguarding of Alpine Food Heritage through shared responsibilities and its inscription on the UNESCO Representative List of the Intangible Cultural Heritage of Humanity.\n\n' + 'We understand Alpine Food Heritage as the set of sustainable production and consumption practices, knowledge and skills, productive landscapes, and traditional food produced in Alpine regions through relying on the commons, shared goods and services as well as on mutual assistance. \n\n' + 'We believe it is crucial for the future of the Alps, as it:',
        purposes: ['provides the basis of Alpine cultural identity and a way of life,', 'contributes to the resilience of Alpine communities,', 'motivates people to live in Alpine rural areas,', 'preserves productive landscapes and biodiversity,', 'fosters the sustainability of the Alps, and', 'boost the attractiveness of Alpine regions.']
      },
      chapter2: {
        title: 'The aim',
        text: 'The Alpine Food Heritage Charter is a participatory and shared document that calls on every citizen, association, company, institution, and authority to assume responsibility in ensuring the safeguarding of Alpine Food Heritage and to support its nomination to the UNESCO Representative List of the Intangible Cultural Heritage of Humanity.'
      },
      chapter3: {
        title: 'Alpine Food Heritage',
        text: {
          p1: 'The Alps are one of the greatest mountain ranges in Europe, stretching across Austria, Slovenia, Italy, Switzerland, Liechtenstein, Germany, France, and Monaco. Commonly referred to as Europe’s mountain heart, they are characterized by high pyramidal peaks, glacial valleys, ribbon lakes, and fast-flowing rivers. These features, together with unique climate and soil conditions that depend on altitude and sun exposure, create extraordinary biodiversity, nurtured through pastoral and agricultural activities of humans who settled here as early as in Palaeolithic times.',
          p2: 'Over centuries of living in these peripheral areas, with their challenging weather conditions, scarce agricultural land and dispersed settlements, Alpine communities developed specific livelihood strategies and managed to maintain them through the transmission of knowledge and way of life to succeeding generations. Communities have been producing and consuming locally, migrating seasonally from lower to upper areas and back, practising agriculture in harmony with nature, relying on transhumance and food conservation, sustainably using natural resources, striving for self-subsistence, and carefully using material goods. They have depended on the sharing of goods and services, relied on mutual aid, and developed multi-functional skills. The combination of self-sufficiency with an openness to other cultures and an ability to accommodate innovations from other areas has shaped Alpine landscapes and resulted in the development of an extraordinary food heritage in Alpine areas. Supported by the growth of Alpine cities, hubs of technological and social innovations with a booming tourism and catering industry promoting critical consumption, this heritage contributes to the competitiveness and attractiveness of Alpine territories as sustainable settlements.',
          p3: 'Alpine Food Heritage is one of the most important markers of this particular (macro)regional identity. Being community-based, it creates strong links among very diverse people, reproduces common values, and embeds a certain quality of life. It is a mix of region-specific tangible (productive landscapes, outbuildings, crops, dishes, kitchen devices and utensils) and intangible aspects (farming, wine-growing, breeding, hunting, freshwater fishing and beekeeping traditions, cooking and conservation methods, recipes, eating customs, social connotations, family and community relationships, rituals and festivals). The mixture of diverse traditions has resulted in a versatile mixed food culture. Varieties of long-lasting bread, sour vegetables, cheese, smoked or salted meat and long-lasting meat products, Alpine herbs and fruits, and sweet dough delicacies are among the most renowned examples of dishes which, given the specific manners of their production and consumption, preserve Alpine cultural values and characterize the uniqueness of this region.'
        }
      },
      chapter4: {
        title: 'Alpine food heritage is at risk of losing its distinctiveness',
        text: {
          p1: 'Urban sprawl, mass tourism, heavy traffic, air and water pollution, intensified farming, and global warming have a negative effect on the quality of life of the inhabitants and threaten traditional ways of living in the Alps. Despite remaining the most densely settled mountains in the world, the Alps currently face depopulation and abandonment of higher-altitude areas, causing a decline in traditional farming lands and occupations as well as a loss of knowledge and skills, traditions, practices, and values shaping Alpine Food Heritage. The safeguarding of Alpine Food Heritage is thus essential to preserve the culture and identity of the inhabitants of the Alps, to re-establish a sustainable way of living that respects the fragile environment, to promote and preserve the quality of Alpine landscapes, and thereby to ensure sustainable development of the Alpine regions for the benefit of current and future generations.',
          p2: 'In 2003, UNESCO adopted the Convention for the Safeguarding of the Intangible Cultural Heritage, which supports communities, groups, and individuals in identifying and defining their intangible cultural heritage, and raises awareness about the need for its safeguarding. Alpine communities from Austria, Slovenia, Italy, Switzerland, Germany, and France thus jointly endeavour to convince their states for a serial nomination of Alpine Food Heritage on the UNESCO Representative List of the Intangible Cultural Heritage of Humanity.'
        }
      },
      chapter5: {
        title: 'Commit to Alpine food heritage safeguarding',
        text: {
          p1: 'Overcoming these challenges, supported by the inscription on the UNESCO Representative List of the Intangible Cultural Heritage of Humanity, can only be achieved through the active involvement of citizens, communities, associations, businesses, institutions, and authorities in the Alps and beyond, and their commitment to heritage safeguarding. Everyone can assume and share the responsibility for the future of Alpine Food Heritage.',
          uls: [{
            title: 'As farmers and food producers, we can:',
            lis: ['continue with the production of locally specific food, preserving vital rural landscapes and biodiversity while favouring local varieties of seeds, plant species, and animal breeds;', 'follow ecological principles in farming and food transportation to provide healthy food to consumers and contribute to environmental sustainability;', 'valorize the products by charging fair prices that respect the dignity of our work and highlight differences compared to mass-produced goods;', 'cooperate with local restaurants and tourism businesses in short supply chains to promote local food culture;', 'preserve, take pride in, and promote traditional farming practices, food conservation know-how, recipes, and cooking techniques, as well as dishes that constitute the basis of Alpine Food Heritage.']
          }, {
            title: 'As citizens of the Alps, we can:',
            lis: ['support Alpine farmers and artisan food producers by buying their crops and produce;', 'visit local markets to take advantage of the varieties of local products;', 'prepare Alpine dishes at home and transfer the knowledge to younger generations;', 'form or join local heritage communities, volunteering in activities aiming to preserve and promote Alpine Food Heritage;', 'encourage local institutions and authorities to support safeguarding of Alpine Food Heritage.']
          }, {
            title: 'As tourists in the Alps, we can:',
            lis: ['respect the natural environment to preserve biodiversity and the quality of rural landscapes;', 'ask Alpine restaurants to serve locally produced traditional food;', 'attend Alpine food festivals and other events to support local communities;', 'visit local museums to learn about Alpine food and other cultural heritage;', 'promote Alpine Food Heritage and food festivals by spreading the word to friends and communities worldwide.']
          }, {
            title: 'As cultural and educational institutions, we can engage in:',
            lis: ['safeguarding local Alpine Food Heritage through studies, documentation, analysis, and promotion;', 'fostering the transmission of Alpine Food Heritage by organizing forums and cultural events as well as by providing performative spaces;', 'improving common knowledge on Alpine Food Heritage by educating people about local traditions and their own potential for heritage safeguarding;', 'transmitting knowledge to younger generations;', 'supporting Alpine heritage communities by helping them recognize and valorise their food heritage and\n' + '              motivating them to take an active part in heritage activities;', 'assisting Alpine communities to preserve rural landscapes as their living space and the basis of local\n' + '              identity;', 'cooperating with similar institutions inside and outside the region or country in common actions\n' + '              addressing Alpine food heritage;', 'convincing the authorities on the need to safeguard Alpine food heritage and support heritage\n' + '              communities.']

          }, {
            title: 'As scientific institutions, we can engage in:',
            lis: ['researching Alpine Food Heritage, especially its effects on human health, cultural identity and a way of life, biodiversity, landscape preservation, and sustainable development;', 'studying connections between rural and urban Alpine areas to understand the rural-urban dynamics in food production and consumption;', 'cooperating with cultural, education, and tourism organizations as well as media to ensure better transmission of knowledge to the field;', 'collaborating with diverse scientific communities to provide transnational multidisciplinary insights into the importance of Alpine Food Heritage;', 'pressuring the states and the European Union to fund multidisciplinary research, transnational programs, and applied projects supporting the development of Alpine regions.']

          }, {
            title: 'As tourism organizations, we can',
            lis: ['promote traditional Alpine restaurants and festivals as tourist attractions; ', 'create thematic tourist packages focusing on Alpine farming and artisan food production, processing, preparation, or tasting while highlighting the relationship between the quality of food production and the quality of rural landscapes;', 'foster regional and transnational Alpine food routes or trails;', 'support local communities organizing food-related activities and events.']
          }, {
            title: 'As media, journalists and influencers, we can',
            lis: ['spread the word on the uniqueness of Alpine Food Heritage;', 'promote Alpine farmers and food producers, processors and retailers;', 'cooperate with local communities and cultural organizations to innovatively promote their activities;', 'inform local businesses and authorities about the potential of Alpine Food Heritage for regional identity, local economy, and sustainable development.']
          }, {
            title: 'As food processing businesses and retailers, we can',
            lis: ['buy and sell food produced in the Alpine area, supporting traditional farmers and food producers;', 'set fair prices for Alpine Food Heritage products;', 'use promotional strategies that highlight special characteristics of these products by telling their stories and educating the taste of consumers;', 'support initiatives such as territorial brands and local networks that promote Alpine Food Heritage;', 'respect the rights of heritage communities when branding the products or registering geographical indications.']
          }, {
            title: 'As restaurants and chefs, we can',
            lis: ['buy ingredients produced in the Alps to support local farmers and food producers;', 'contribute to the promotion of Alpine Food Heritage by offering dishes that are inspired by Alpine traditions, using authentic ingredients, and respecting the rhythm of the seasons;', 'learn traditional recipes from Alpine communities and acknowledge the role of tradition bearers;', 'support initiatives such as territorial brands and local networks that promote Alpine Food Heritage.']
          }, {
            title: 'As local and regional authorities, we can',
            lis: ['facilitate the access of Alpine communities, associations, institutions and businesses to know-how on food heritage preservation, transmission, and promotion;', 'adopt adequate measures to protect Alpine Food Heritage in our region and support local farmers, artisan food producers, and heritage communities in their endeavours to preserve and promote it;', 'actively support the network of actors aiming to inscribe Alpine Food Heritage on the UNESCO Representative List of the Intangible Cultural Heritage of Humanity and connect them to national authorities.']
          }, {
            title: 'As national authorities, we can',
            lis: ['work with local and regional authorities in the Alps to support safeguarding of Alpine Food Heritage and create sustainable ways for its use in the local economy;', 'adopt measures supporting sustainable development of Alpine regions in our country;', 'cooperate transnationally for the recognition of the Alpine Food Heritage as a common heritage worthy of safeguarding and holding a crucial role for sustainable development of the Alps;', 'support the nomination of Alpine Food Heritage on the UNESCO Representative List of the Intangible Cultural Heritage of Humanity and promote the endeavours of Alpine communities transnationally.']
          }]
        }
      },
      chapter6: {
        title: 'Our Vision',
        text: {
          p1: 'We, people who care about the future of the Alps, believe in the urgency of safeguarding Alpine Food Heritage for the identity, way of life, landscape, biodiversity, and sustainable development of the Alps. When we share responsibility, it is safeguarded more efficiently. ',
          p2: ''
        }
      }
    },
    privacyPolicy: [{
      title: 'CONFIDENTIALITY POLICIES',
      content: 'By visiting our website, you agree to the practices described in this privacy policy section called "Privacy Policy AlpFoodway".'
    }, {
      title: 'INFORMATION',
      content: 'AlpFoodway does not collect information when you fill out the petition signature form. The completed form is sent directly to our server as an e-mail. AlpFoodway uses your data only to interact with you, to provide you with the requested support and to locate the supporters of the initiative in an aggregate way. AlpFoodway will not use your address to send you periodic e-mails or for commercial purposes and will only use an aggregate user location. If at any time you wish us to delete your contact details regarding the signature of the petition, please send us an e-mail to <a href="mailto:info@alpfoodway.eu">info@alpfoodway.eu</a> and we will do so within fifteen working days.'
    }, {
      title: 'SHARED INFORMATION',
      content: 'AlpFoodway does not sell, exchange or otherwise transfer personally identifiable information to third parties. If AlpFoodway were to transfer personally identifiable information to third parties who assist us in the management of the web platform, AlpFoodway would do so only on the condition that these third parties agree to keep such information confidential. In addition, Alpfoodway will release certain personally identifiable information if you are obligated to do so, in compliance with the law or to protect the rights, security or property of our or other partners.'
    }, {
      title: 'LINK TO THIRD PARTIES',
      content: 'Exceptionally, at our discretion, we may publish third-party links on our website. These third-party sites have separate and independent privacy policies. Therefore AlpFoodway can not be held responsible for the content and activities of these linked sites. Any feedback or comments on these websites are welcome.'
    }, {
      title: 'COOKIES',
      content: 'AlpFoodway does not use any cookies on its site, but we cannot exclude that Google Analytics does so. Cookies are small files that a website, or its service provider, transfers to your computer\'s hard drive through your web browser (if you allow it). Cookies allow the site or systems of its service providers to recognize your browser and to acquire and remember certain information.'
    }, {
      title: 'CHANGES',
      content: 'Alpfoodway reserves the right to change its privacy policy at any time. The latest version will always be published online. \n' + 'For more information on our privacy policy, please contact us at <a href="mailto:info@alpfoodway.eu">info@alpfoodway.eu</a>.'
    }],
    contest: 'Contest',
    regulations: 'Read the complete regulation',
    winners: 'Winners',
    winnersList: undefined,
    contestOpening: 'The photographic contest will start on 23/04/2019',
    contestEnding: 'The photographic contest will end on 16/06/2019',
    contestClosing: 'The photographic contest has ended on 16/06/2019',
    regulationsItems: [{
      title: 'PHOTOGRAPHIC STORYTELLING CONTEST: “ALPINE FOOD HERITAGE STORIES”',
      content: 'AlpFoodway, an Interreg Alpine Space project, is organizing a storytelling photografic Contest named “Alpine Food Heritage Stories”, according to the procedures indicated in the present regulations.'
    }, {
      title: 'Theme',
      content: 'The Contest wants to describe the Alpine Food Heritage using photographic stories.The aim of the initiative is enlarging support to the Alpine Food Heritage’s safeguarding and to its candidature for the Representative List of the UNESCO World Intangible Cultural Heritage.' + 'All the storytelling projects should tell about Alpine Food Heritage including production practices, food processing and preserving practices, consumption rituals, know how and landscapes representing it. ' + 'A cultural and social heritage always grounded on the alpine communities “mountain life style”, exchanging food and services, managing common goods, transmitting practices and know how among generations.'
    }, {
      title: 'Terms and conditions',
      content: 'Starting from 13/05/2019 till 16/06/2019 you can post your visual stories on Instagram by using your public account.<br/><br/>To participate to the contest following rules must be followed:' + '<ul style="padding-left: 7%; padding-top: 2%">' + '<li>The post has to be composed by only 3 high quality photographs;</li>' + '<li>The post has to feature the hashtag #AlpFoodwayContest and @AlpFoodway_project must be tagged;</li>' + '<li>The posts has to be geo-localized;</li>' + '<li>In the description of the post only location and date where the 3 photographs were shot must be indicated, no other text.</li>' + '<li>Other hashtags can be added, but not more than 10 that should necessarily be strictly related to the pictures.;</li>' + '<li>Moreover, to let members of the jury having access to the post, it is essential that the account is not set up in private mode.</li>' + '</ul>' + '<p style="color: #c41c21; text-align: center;"><b>All published posts will be also visibile on the Contest section of the AlpFoodway platform <a href="https://www.alpfoodway.eu" target="_blank">www.alpfoodway.eu</a>.</p>'
    }, {
      title: 'Idoneità',
      content: 'Participants cannot be younger than 18 years old. AlpFoodway Partners staff cannot participate to the Contest.'
    }, {
      title: 'Declarations and guarantees',
      content: 'Participation to this Contest implies the unconditional acceptance of all regulations related. <br/><br/>' + 'Contents should be coherent with this Contest’s theme. With this reference, at the incontestable discretion of AlpFoodway partners, posts will be deleted if considered not proper or not respecting any right including, among others, infringement of copyright, registered trademarks, publicity right, intellectual property right of third parties and privacy right. Pictures should not contain information considered confidential, inappropriate, indecent, harmful,  defamatory, illegal or against the law.' + '<br/><br/>Each participant will have civil and penal responsibility for his/her pictures; Polo Poschiavo, lead partner of the AlpFoodway project and promoter of the Contest, will have no responsibility in any circumstance, neither in relation to people shown in pictures. Competitors should always inform all people shot in pictures and obtain their consent to distribution otherwise their posts will automatically be excluded by the Contest. The Contest’s organization will never be responsible for any eventual request of compensation raised by people shot in pictures used for participation to this Contest, neither by right owners that weren’t requested to release a signed consent form.' + '<br/><br/>In case of legal litigation, the authorized owner of the social media account used for the registration for the Contest will be considered the participant and should adapt to the present regulations. \n' + 'The “authorized account’s title holder” is the physical person assigned to the social media account or to the email address created by an Internet provider, by an online service provider or by any other responsible organization for e-mail addresses’ assignment for the domain associated to the e-mail address related to this Contest’s participation. Each participant could be requested to demonstrate of being an authorized account’s title holder.'
    }, {
      title: 'Property rights and pictures availability ',
      content: 'When participants decide to post their pictures with the hashtag #AlpFoodwayContest related to participation to this Contest, they automatically authorize their usage, publication and dissemination (by any technological mean, in any format and by any channel) by AlpFoodway project partners only for the aims related to AlpFoodway project’s and contest’s promotion, with no obligation of a previous authorization’s request.'
    }, {
      title: 'Awards',
      content: 'The contest doesn’t grant prize money. \n' + 'The awards as recognition of personal credits of the three best participants will be:' + '<ul>' + '<li>Only the best participant will also win the free participation to the “Alpfoodway” Media Trip with internationally renowned journalists and photographers. The Media trip will start from the 3rd of July 2019 in Le Chatelard (Savoie, France) and will end on the 9th of July 2019 in Edolo (Valcamonica, Italy). Intermediate stops will be: Aosta Valley (Italy),  Cantons Valais and Graubünden (Switzerland);</li>' + '<li>Publication of the best pictures on the AlpFoodway’s website and social media;</li>' + '</ul>' + 'All awarded works can also be included in the UNESCO Candidature Dossier for the nomination of the Alpine Food Heritage to the Representative List of the UNESCO World Intangible Cultural Heritage.'
    }, {
      title: 'Jury and communications to winners',
      content: 'All works will be evaluated by a qualified Jury composed by a selected group of AlpFoodway project partners. The Jury will evaluate all works and will choose at its incontestable discretion the three best works on the basis of the following elements: ' + '<ul>' + '<li>50% coherence with the proposed theme;</li>' + '<li>25% originality and creativity;</li>' + '<li>25% number of expressed preferences on Instagram (likes).</li>' + '</ul>' + 'Please consider that only participants that reached minimum 100 likes in total with their three pictures will be evaluated. The Jury will evaluate posts starting from the first 100 participants that reached 100 likes minimum in chronological order of arrival.<br/><br/>' + 'The winner and the worthy authors will be informed by the organization by June 24, 2019.<br/><br/>' + 'If necessary, it will be requested to participants to send all the consent forms/ authorizations of all third parties showed in the pictures.<br/><br/>' + 'The winners’list will be available on<a href="https://www.alpfoodway.eu" target="_blank">www.alpfoodway.eu</a>' + '<br/><br/>' + '<h6 style="color: #c41c21;">Useful links:</h6>' + '<ul>' + '<li><a href="https://www.alpine-space.eu/projects/alpfoodway/en/home" target="_blank">www.alpine-space.eu/projects/alpfoodway/en/home</a></li>' + '<li><a href="https://www.alpfoodway.eu" target="_blank">www.alpfoodway.eu</a></li>' + '<li><a href="https://www.intagiblesearch.eu">www.intagiblesearch.eu</a></li>' + '</ul>'
    }],
    youtubeGallery: 'Video',
    inventoryMap: 'Inventory Map',
    becomeSupporter: 'Become a supporter',
    gallery: 'ICH Values'
  },
  German: {
    italianPartners: 'ITALIENISCHE PARTNER',
    swissPartners: 'SCHWEIZER PARTNER',
    alpFoodWayDescription: '',
    englishLanguage: 'ENGLISCH',
    italianLanguage: 'ITALIENISCH',
    germanLanguage: 'DEUTSCH',
    frenchLanguage: 'FRANZÖSISCH',
    slovenianLanguage: 'SLOVENISCH',
    home: 'Home',
    events: 'Events',
    pastEvents: undefined,
    socials: 'Soziale Netzwerke',
    news: 'News',
    supporters: 'Unterstützer',
    signPetition: 'Petition Unterschreiben',
    socialWall: 'Social Wall',
    loadMore: 'Mehr',
    captionTitleSign: 'Petition für die Aufnahme in die UNESCO Repräsentative Liste des immateriellen Kulturerbes der Menschheit',
    captionText: {
      p1: 'Das Erbe der Alpinen Essenskultur ist ein spezifisches Zusammenspiel aus nachhaltiger Produktion und Konsumpraktiken, Wissen und Fertigkeiten, Kulturlandschaften und lokal hergestelltem traditionellen Essen in den Alpenregionen. Es basiert auf den Commons, gemeinsamen Gütern und Dienstleistungen, und auf gemeinschaftlicher Zusammenarbeit. Wir, die Menschen, die sich Gedanken über die Zukunft der Alpen machen, befürworten die Bewahrung des Erbes der Alpinen Essenskultur und dessen Aufnahme in die UNESCO Repräsentative Liste des immateriellen Kulturerbes der Menschheit, denn es: ',
      p2: 'Bitte lesen Sie die Charta und entdecken Sie, in welcher Form Sie sich in den Erhalt des Erbes der Alpinen Essenskultur einbringen können. Unterstützen Sie die Multinationale Nominierung des Erbes der Alpinen Essenskultur für die UNESCO Repräsentative Liste des immateriellen Kulturerbes der Menschheit, indem Sie die Petition unterzeichnen.',
      reasons: ['stellt die Basis der Alpinen kulturellen Identität und Lebensweisen dar,', 'trägt zur Resilienz der Alpinen Gemeinschaften bei,', 'motiviert Menschen, in den ländlichen Alpenregionen zu leben,', 'bewahrt Kulturlandschaften und Biodiversität,', 'fördert die Nachhaltigkeit der Alpen,', 'und stärkt die Attraktivität der Alpenregionen.']
    },
    peopleHaveSigned: 'Personen die schon unterschrieben haben',
    mainSupporters: 'partner',
    otherSupporters: 'Unterstützer',
    supportersPosition: 'Entdecke woher unsere Unterstützer herkommen',
    haveSigned: 'Personen die die Petition schon unterschrieben haben',
    statistics: 'Statistik',
    read: 'Lese',
    theCarta: 'Die Charta',
    theCartaRound: 'Die Charta Des Alpinen Esskulturerbes',
    sign: 'Unterschreibe',
    thePetition: 'Die Petition',
    thePetitionRound: 'Die AlpFoodwayUNESCO Petition',
    share: 'Teile',
    ourCampaign: 'Unsere Kampagne',
    signs: 'Unterschriften',
    socialContents: 'Soziale Inhalte',
    insertName: 'Name',
    insertSurname: 'Nachname',
    insertCity: 'Stadt',
    insertEmail: 'email Adresse',
    updatesAboutPetition: 'Ich möchte über die Petition am laufenden gehalten werden',
    confirmationPrivacyStatementPT1: 'Ich bestätige die',
    confirmationPrivacyStatementPT2: ' Datenschutzerklärung gelesen zu haben',
    alreadyUsedEmail: 'Diese email Adresse hat die Petition schon unterschrieben',
    thankYouTitle: 'Danke für die Unterschrift',
    thankYouSubtitle: 'Helfe uns die Petition auf deine lieblings soziale Netzwerke zu teilen',
    maybeLater: 'Villeicht später',
    noCitiesFound: 'Keine Stadt gefunden',
    contentLoading: 'Die Inhalte dieser Seite werden geladen',
    contentEmpty: 'Es gibt zur Zeit keine Inhalte für diese Seite',
    close: 'Schliesse',
    thanksForSharing: 'Danke fürs Teilen, gehe zurück zur Plattform',
    whySign: 'Warum Unterschreiben?',
    insertYourData: 'Fülle das Formular aus',
    letsGetTo: 'Gehe zu',
    inventory: 'Inventar',
    carouselTitles: undefined,
    carouselSubtitles: undefined,
    readMore: 'Lese mehr',
    others: 'Andere',
    joinUs: undefined,
    discover: 'Entdecken',
    privacyPolicy: undefined,
    chartaContent: {
      generalTitle: 'Die Charta Des Alpinen Esskulturerbes',
      catchPhrase: 'Auch wir sind dafür verantwortlich, das Alpine Esskulturerbe zu erhalten.',
      chapter1: {
        title: 'Präambel',
        text: 'Wir, die Menschen, die sich Gedanken um die Zukunft der Alpen machen, befürworten die Bewahrung des Alpinen Esskulturerbes und dessen Aufnahme in die UNESCO Repräsentative Liste des immateriellen Kulturerbes der Menschheit.\n\nWir verstehen das Alpine Esskulturerbe als nachhaltige Praktiken der Erzeugung und des Verzehrs, als Wissen und Fertigkeiten, als produktive Landschaften und traditionelle Lebensmittel, die im Alpenraum entstanden sind durch die Angewiesenheit auf Allmenden, gemeinsame Güter und Dienstleistungen, sowie auf gegenseitige Hilfe.\n\nWir glauben, dieses Kulturerbe ist für die Zukunft der Alpen von enormer Wichtigkeit, denn es',
        purposes: ['stellt die Basis der Alpinen kulturellen Identität und Lebensweise dar,', 'trägt zur Resilienz der Alpinen Gemeinschaften bei,', 'motiviert Menschen, in den ländlichen Alpenregionen zu leben,', 'erhält die produktiven Landschaften und Biodiversität,', 'fördert die Nachhaltigkeit der Alpen,', 'und stärkt die Attraktivität der Alpenregionen.']
      },
      chapter2: {
        title: 'Das Ziel',
        text: 'Die Charta des Alpinen Esskulturerbes ist ein partizipatives und gemeinsam getragenes Dokument, das alle Bürger, Vereine, Unternehmen und Institutionen dazu aufruft, ihrer Verantwortung nachzukommen das Alpine Esskulturerbe zu bewahren und die Nominierung für die UNESCO Repräsentative Liste des immateriellen Kulturerbes der Menschheit zu unterstützen. '
      },
      chapter3: {
        title: 'Das Alpine Esskulturerbe',
        text: {
          p1: 'Als eines der größten Gebirge Europas durchziehen die Alpen Österreich, Slowenien, Italien, die Schweiz, Liechtenstein, Deutschland, Frankreich und Monaco. Diese Berge im Herzen Europas werden charakterisiert durch hohe, pyramidenförmige Gipfel, durch von Gletschern geformten Tälern und Seen, sowie durch schnell fließenden Flüsse. Verbunden mit einzigartigen Bedingungen des Klimas und der Bodenbeschaffenheiten, die von Höhe und Sonnenexposition abhängen, entsteht durch diese Merkmale eine außergewöhnliche Biodiversität, die genährt wurde durch den Ackerbau und die Beweidung durch Menschen, die hier seit dem Paläolithikum ansässig waren. ',
          p2: 'Durch das Leben in peripheren Gegenden mit unvorteilhaften Wetterverhältnissen, spärlichem Land für Ackerbau und verstreuten Siedlungen haben die Alpinen Gemeinschaften im Lauf der Jahrhunderte spezifische Lebensstrategien entwickelt und diese durch die Weitergabe des Wissens und des Lebensstils an die jüngeren Generationen erhalten können. In diesen Gemeinschaften wurde regional produziert und konsumiert, saisonale Wanderschaft auf die Hochalmen und zurück ins Tal betrieben, die Felder im Einklang mit der Natur bestellt, die Winter durch Transhumanz und Konservierungstechniken überstanden, und die Ressourcen nachhaltig für die Selbstversorgung genutzt. Sie waren darauf angewiesen Güter und Dienstleistungen zu teilen, haben sich auf gegenseitige Hilfeleistungen verlassen und vielseitige Fähigkeiten entwickelt. Die Kombination aus Selbstsuffizienz, Offenheit gegenüber anderen Kulturen und der Fähigkeit, Innovationen aus anderen Gegenden aufzugreifen, hat die Alpine Landschaft geformt und zu der Entwicklung eines außergewöhnlichen Erbes der Esskultur im Alpenraum geführt. Zusammen mit dem Wachstum der Alpinen Städte zu Zentren der technologischen und sozialen Innovation mit florierendem Tourismus und Gaststättengewerbe, die kritischen Konsum fördern, trägt dieses Kulturerbe entscheidend zur Wettbewerbsfähigkeit und Attraktivität des Alpenraums als nachhaltigem Lebensraum bei.  ',
          p3: 'Das Alpine Esskulturerbe ist eines der wichtigsten Merkmale dieser besonderen (makro-)regionalen Identität. Durch die Verankerung in der Gemeinschaft knüpft es eine starke Verbindung zwischen sehr unterschiedlichen Menschen, gibt gemeinsame Werte wieder und schafft eine besondere Lebensqualität. Es ist eine regionalspezifische Mischung materieller (produktive Landschaften, Wirtschaftsgebäude, Feldfrüchte, Gerichte, Küchengerätschaft) und immaterieller Aspekte (Traditionen des Acker- und Weinbaus, der Tierzucht, der Jagd, der Süßwasserfischerei und der Imkerei, Arten der Zubereitung und Konservierung, Rezepte, Essgewohnheiten, soziale Konnotationen, Beziehungen innerhalb der Familien und Gemeinschaften, Feste und Rituale). Das Zusammentreffen dieser unterschiedlichen Traditionen führte zu einer sehr versatilen Ess- und Lebensmittelkultur. Verschiedene Arten von lange haltbarem Brot, sauer eingelegte Gemüse, Käse, geräucherte oder eingesalzene Fleisch- und Wurstprodukte, Alpine Kräuter und Obstsorten, sowie Mehlspeisen und süßes Gebäck zählen zu den bekanntesten Spezialitäten, die durch ihre spezifische Art der Herstellung und die Gewohnheiten und Bräuche zu ihrem Verzehr die kulturellen Werte der Alpen erhalten und die Einzigartigkeit dieser Region charakterisieren. '
        }
      },
      chapter4: {
        title: 'Das Alpine Esskulturerbe ist in Gefahr, seine Unverwechselbarkeit zu verlieren',
        text: {
          p1: 'Zersiedelung, Massentourismus, starker Verkehr, Luft- und Wasserverschmutzung, die Intensivierung der Landwirtschaft und der Klimawandel wirken sich negativ auf die Lebensqualität der Menschen in den Alpen aus und bedrohen traditionelle Lebensweisen. Obwohl sie nach wie vor die am dichtesten besiedelten Berge der Welt sind, erleben die Alpen gerade Entvölkerung und die Aufgabe der hochgelegenen Gebiete, was zu einer Verminderung der traditionellen Ackerbauflächen und Berufe führt und zu einem Verlust des Wissens, der Fähigkeiten, der Traditionen, Bräuche und Werte, die das Alpine Kulturerbe ausmachen. Die Bewahrung des Alpinen Esskulturerbes ist deshalb essentiell, um die Kultur und die Identität der Alpinen Bevölkerung zu erhalten, um eine nachhaltige Lebensweise wiederherzustellen, die die empfindliche Umwelt respektiert, um die Qualität der Alpinen Landschaften zu fördern und zu bewahren und um dadurch eine nachhaltige Entwicklung der Alpinen Regionen für die jetzt lebenden und zukünftigen Generationen sicherzustellen. ',
          p2: 'Im Jahr 2003 hat die UNESCO-Generalkonferenz das Übereinkommen zur Erhaltung des Immateriellen Kulturerbes verabschiedet, das Gemeinschaften, Gruppen und Individuen dabei unterstützt, ihr immaterielles Kulturerbe zu identifizieren und zu benennen und das Bewusstsein für seine Bewahrung zu stärken. Alpine Gemeinschaften aus Österreich, Slowenien, Italien, der Schweiz, Deutschland und Frankreich versuchen deshalb gemeinschaftlich die Staaten zu einer seriellen Nominierung Alpinen Esskulturerbes für die UNESCO Repräsentative Liste des immateriellen Kulturerbes der Menschheit zu bewegen.'
        }
      },
      chapter5: {
        title: 'Verpflichten Sie sich, das Alpine Esskulturerbe zu erhalten',
        text: {
          p1: 'Diese Herausforderungen können, unterstützt durch die Aufnahme auf die UNESCO Repräsentative Liste des immateriellen Kulturerbes der Menschheit, nur bewältigt werden durch die aktive Beteiligung der Bürger, Gemeinschaften, Vereine, Unternehmen, Institutionen und Behörden in den Alpen und darüber hinaus und deren Eigenverpflichtung, zur Bewahrung des Kulturerbes beizutragen. Ein jeder kann Verantwortung für die Zukunft des Alpinen Esskulturerbes übernehmen und teilen.',
          uls: [{
            title: 'Als Landwirte und Lebensmittelhersteller können wir:',
            lis: ['weiterhin regionalspezifische Lebensmittel herstellen, die die lebendigen Kulturlandschaften und ihre Biodiversität erhalten, indem wir lokale Arten von Saatgut, Nutzpflanzen und Nutztierrassen bevorzugen;', 'ökologischen Prinzipien der Landwirtschaft und des Lebensmitteltransports folgen, um dem Verbraucher gesunde Lebensmittel zur Verfügung zu stellen und zum Schutz der Umwelt beitragen;', 'unsere Produkte in Wert setzen, indem wir faire Preise verlangen, die die Würde unserer Arbeit respektieren und den Unterschied zu massengefertigten Produkten verdeutlichen;', 'mit lokalen Restaurants und Tourismusunternehmen in regionalen Wertschöpfungsketten zusammenarbeiten um die regionale Essenskultur zu fördern;', 'die traditionellen Anbaumethoden, Konservierungsmethoden, Garmethoden und die Gerichte, die die Basis des Alpinen Esskulturerbes in den Alpen ausmachen mit Stolz bewahren und fördern.']
          }, {
            title: 'Als Bürger der Alpen können wir:',
            lis: ['die Landwirte und Lebensmittelhersteller in den Alpen unterstützen, indem wir ihre Ernten und Produkte kaufen;', 'regionale Märkte besuchen, um regionale Produkte erwerben zu können;', 'Alpine Gerichte zu Hause zubereiten und das Wissen auf die jüngeren Generationen übertragen;', 'regionalen Kulturerbe-Gemeinschaften beitreten oder solche gründen, um uns ehrenamtlich an der Bewahrung und Förderung des Alpinen Esskulturerbes beteiligen;', 'Einrichtungen und Behörden in unserer Region ermutigen, die Bewahrung des Alpinen Esskulturerbes zu unterstützen.']
          }, {
            title: 'Als Touristen in den Alpen können wir :',
            lis: ['die Natur respektieren, um die Biodiversität und Qualität der Kulturlandschaften zu erhalten;', 'Restaurants in den Alpen dazu anhalten, lokal produzierte, traditionelle Lebensmittel zu servieren;', 'An Festivals zu Alpinen Lebensmitteln und andere Veranstaltungen teilnehmen, um die regionalen Gemeinschaften zu unterstützen;', 'Lokale Museen besuchen, um uns über Alpine Lebensmittel und anderes Kulturerbe zu informieren;', 'das Alpine Esskulturerbe und die zugehörigen Veranstaltungen fördern, indem wir Freunden und anderen Gemeinschaften auf der ganzen Welt davon erzählen.']
          }, {
            title: 'Als Bildungs- und Kultureinrichtungen können wir uns daran beteiligen:',
            lis: ['das Alpine Esskulturerbe durch Studien, Dokumentation, Analyse und Förderung zu bewahren;', 'die Weitergabe des Alpine Esskulturerbes durch die Organisation von Foren und Kulturveranstaltungen sowie die Bereitstellungen von geeigneten Räumlichkeiten zu unterstützen;', 'das Allgemeinwissen über das Alpine Esskulturerbe durch Bildungsangebote zu lokalen Traditionen und die Möglichkeiten der Bewahrung von Kulturerbe zu fördern;', 'das Wissen an die jüngeren Generationen weiterzugeben;', 'Gemeinschaften in den Alpen darin zu unterstützen, ihr Kulturerbe zu erkennen, in Wert zu setzen und aktiv daran teilzuhaben;', 'Alpinen Gemeinschaften zu helfen die Kulturlandschaften als Lebensraum und Basis der regionalen Identität zu erhalten;', 'mit anderen Institutionen innerhalb und außerhalb unserer Region und unseres Landes an gemeinsamen Aktionen zum Alpinen Esskulturerbe zusammenzuarbeiten;', 'die Behörden von der Notwendigkeit zu überzeugen, das Alpine Esskulturerbe zu bewahren und die Gemeinschaften darin zu unterstützen.']
          }, {
            title: 'Als wissenschaftliche Einrichtungen können wir uns daran beteiligen,:',
            lis: ['das Alpine Esskulturerbe zu erforschen, insbesondere seine Wirkung auf die menschliche Gesundheit, kulturelle Identität und Lebensweise, Biodiversität, Landschaftserhaltung und nachhaltige Entwicklung;', 'mehr über die Verbindungen zwischen ländlichen Gebieten und Ballungsräumen in den Alpen zu lernen, um die ländlich-urbane Dynamik der Herstellung und des Konsums von Lebensmitteln zu verstehen; ', 'mit Kultur-, Bildungs- und Tourismusorganisationen sowie den Medien zu kooperieren, um eine verbesserte Weitergabe von Wissen in diesem Feld zu gewährleisten;', 'mit unterschiedlichen wissenschaftlichen Gemeinschaften zusammenzuarbeiten, um transnationale, multidisziplinäre Einsichten über die Bedeutung des Alpinen Esskulturerbes zu gewinnen;', 'die Staaten und die Europäische Union unter Druck zu setzen, multidisziplinäre Programme und Projekte zur Forschung und Umsetzung zu finanzieren, die die Entwicklung der Alpenregionen unterstützen.']
          }, {
            title: 'Als Tourismus Organisationen können wir:',
            lis: ['traditionelle Alpine Restaurants und Festivals als touristische Attraktionen bewerben;', 'authentische touristische Angebote zu Alpiner Landwirtschaft und handwerklich gefertigten Lebensmitteln (und ihrer Herstellung, Verarbeitung, Verwendung in der Küche und Verkostung) erstellen und dabei die Beziehung zwischen der Qualität der Lebensmittelherstellung und der Schönheit der Kulturlandschaft vermitteln;', 'regionale und transnationale thematische Routen und Wanderwege fördern;', 'regionale Gemeinschaften bei der Organisation von lebensmittelbezogenen Festivals und Aktivitäten unterstützen.']
          }, {
            title: 'Als Medien, Journalisten und Influencer können wir:',
            lis: ['die Einzigartigkeit des Alpinen Esskulturerbes verbreiten;', 'die Anbauer und Hersteller, Verarbeiter und Händler von Alpinen Lebensmittel promoten;', 'mit regionalen Gemeinschaften und Kulturorganisationen zusammenarbeiten, um ihre Aktivitäten auf innovative Weise zu bewerben;', 'Regionale Unternehmen und Behörden über das Potential des Alpinen Esskulturerbes für die regionale Identität, für regionale Wertschöpfung und für nachhaltige Entwicklung informieren.']
          }, {
            title: 'Als Verarbeiter und Händler von Lebensmitteln können wir:',
            lis: ['Lebensmittel kaufen, die im Alpenraum produziert wurden, um traditionelle Bergbauern und Produzenten zu unterstützen;', 'faire Preise für Produkte des Alpinen Esskulturerbes setzen;', 'mit unseren Werbestrategien die besonderen Eigenschaften dieser Produkte herausstellen, indem wir ihre Geschichten erzählen und zur Bildung der Konsumenten beitragen;', 'lokale Initiativen wie regionale Marken und Netzwerke unterstützen;', 'die Rechte der Trägergemeinschaften des Kulturerbes bei der Bezeichnung von Produkten und der Beantragung von Schutzsiegeln respektieren. ']
          }, {
            title: 'Als Restaurants und Köche können wir:',
            lis: ['Zutaten aus den Alpen kaufen, um lokale Landwirte und Hersteller zu unterstützen;', 'zur Förderung des Alpinen Esskulturerbes beitragen, indem wir Gerichte anbieten, die von Alpinen Traditionen inspiriert sind, authentische Zutaten enthalten und den Rhythmus der Jahreszeiten respektieren;', 'traditionelle Rezepte von den Alpinen Gemeinschaften erlernen und die Rolle der Traditionsträger anerkennen;', 'Initiativen wie regionale Marken und Netzwerke zur Förderung des Alpinen Esskulturerbes unterstützen. ']
          }, {
            title: 'Als Behörden auf Gemeinde- und Regionalebene können wir:',
            lis: ['Alpinen Gemeinschaften, Vereinen, Institutionen und Unternehmen den Zugang zu Knowhow über die Bewahrung, Weitergabe und Förderung von Kulturerbe ermöglichen;', 'geeignete Maßnahmen ergreifen, um das Alpine Esskulturerbe in unserer Region zu schützen und die Landwirte, handwerklichen Hersteller und Trägergemeinschaften in ihrem Bemühen unterstützen, es zu bewahren und zu fördern;', 'das Netzwerk der Akteure, das versucht das Alpine Esskulturerbe auf die UNESCO Repräsentative Liste des immateriellen Kulturerbes der Menschheit zu heben aktiv unterstützen und mit den nationalen Behörden in Verbindung setzen.']
          }, {
            title: 'Als staatliche Behörden der höheren Ebenen können wir:',
            lis: ['mit Behörden auf Gemeinde- und Regionalebene in den Alpen zusammenarbeiten um das Alpine Esskulturerbe in den Alpen zu bewahren und nachhaltige Arten der Nutzung zu schaffen, um regionale Wertschöpfung zu generieren;', 'Maßnahmen zur nachhaltigen Entwicklung der Alpinen Regionen in unserem Land ergreifen;', 'transnational kooperieren für die Anerkennung des Alpinen Esskulturerbes als gemeinschaftliches Kulturerbe, das es wert ist erhalten zu werden und eine zentrale Rolle für die nachhaltige Entwicklung des Alpenraums einnimmt;', 'die Nominierung Alpinen Esskulturerbes für die UNESCO Repräsentative Liste des immateriellen Kulturerbes der Menschheit unterstützen und die Bemühungen der Alpinen Gemeinschaften transnational fördern.']
          }]
        }
      },
      chapter6: {
        title: '',
        text: {
          p1: 'Wir, die Menschen, die sich Gedanken über die Zukunft der Alpen machen, glauben an die Dringlichkeit der Bewahrung des Alpinen Esskulturerbes für die Identität, die Lebensweise, die Landschaft, die Biodiversität und die nachhaltige Entwicklung der Alpen. Indem wir die Verantwortung dafür teilen, wird es effizienter bewahrt.',
          p2: ''
        }
      }
    },
    contest: 'Contest',
    winnersList: undefined,
    regulations: 'Lesen Sie die komplette Regelung',
    winners: 'Gewinner',
    contestOpening: 'Der Fotowettbewerb beginnt am 23/04/2019',
    contestEnding: 'Der Fotowettbewerb endet am 16/06/2019',
    contestClosing: 'Der Fotowettbewerb ist am 16/06/2019 zu Ende gegangen',
    regulationsItems: [{
      title: 'FOTOGRAFISCHER STORYTELLING KONTEST: “GESCHICHTEN DER ALPINEN ESSKULTUR”',
      content: 'AlpFoodway, ein Interreg Alpine Space Projekt, organisiert einen fotografischen Storytelling Wettbewerb names “Geschichten der Alpinen Esskultur” mit den folgenden Bedingungen:'
    }, {
      title: 'Thema',
      content: 'In diesem Wettbewerb soll das Erbe der Alpinen Esskultur mit fotografischem Storytelling dargestellt werden. Das Ziel der Initiative ist es, Unterstützung für den Erhalt des Erbes der Alpinen Esskultur und für dessen Kandidatur für die Repräsentative UNESCO Liste des immateriellen Kulturerbes der Menschheit zu gewinnen. ' + 'Die Storytelling Projekte sollen sich deshalb auf das Erbe der Alpinen Esskultur beziehen wie den Herstellungsmethoden, Praktiken der Weiterverarbeitung und dem Haltbarmachen von Lebensmitteln, Ritualen und Essgewohnheiten, Wissen und Landschaften, die dieses repräsentieren. ' + 'Als kulturelles und soziales Erbe basiert es stets auf dem „Alpinen Lebensstil“ von Gemeinschaften, dem Austausch von Lebensmitteln und Dienstleistungen, dem Management von Gemeingütern und der Weitergabe von Wissen und Fertigkeiten zwischen den Generationen. '
    }, {
      title: 'Teilnahmebedingungen',
      content: 'Vom 13/05/2019 bis zum 16/06/2019 können visuelle Stories mit einem öffentlichen Account auf Instagram gepostet werden.<br/><br/>Um am Wettbewerb teilzunehmen, müssen dabei folgende Bedingungen erfüllt werden:' + '<ul style="padding-left: 7%; padding-top: 2%">' + '<li>Der Post muss aus 3 hochqualitativen Bildern bestehen;</li>' + '<li>Der Post muss den Hashtag #AlpFoodwayContest verwenden und @AlpFoodway_project markieren;</li>' + '<li>Der Post muss geo-lokalisiert sein („Ort hinzufügen“);</li>' + '<li>In der Beschreibung des Posts dürfen nur der Ort und das Datum, an dem die 3 Bilder aufgenommen wurden angegeben werden, kein zusätzlicher Text..</li>' + '<li>Andere Hashtags können verwendet werden, jedoch nicht mehr als 10, und sie müssen einen direkten Bezug zu den Bildern haben;</li>' + '<li>Um durch die Jury-Mitglieder bewertet werden zu können, darf der Account nicht auf Privatmodus gestellt sein.</li>' + '</ul>' + '<p style="color: #c41c21; text-align: center;"><b>Alle veröffentlichten Posts werden auf der Contest Section der AlpFoodway Plattform <a href="https://www.alpfoodway.eu" target="_blank">www.alpfoodway.eu</a> zu sehen sein.</p>'
    }, {
      title: 'Teilnahmeberechtigung',
      content: 'Teilnehmer müssen mindestens 18 Jahre alt sein. Mitarbeiter der Partnerorganisationen des AlpFoodway Projekts sind von der Teilnahme ausgeschlossen.'
    }, {
      title: 'Declarations and guarantees',
      content: 'Participation to this Contest implies the unconditional acceptance of all regulations related. <br/><br/>' + 'Contents should be coherent with this Contest’s theme. With this reference, at the incontestable discretion of AlpFoodway partners, posts will be deleted if considered not proper or not respecting any right including, among others, infringement of copyright, registered trademarks, publicity right, intellectual property right of third parties and privacy right. Pictures should not contain information considered confidential, inappropriate, indecent, harmful,  defamatory, illegal or against the law.' + '<br/><br/>Each participant will have civil and penal responsibility for his/her pictures; Polo Poschiavo, lead partner of the AlpFoodway project and promoter of the Contest, will have no responsibility in any circumstance, neither in relation to people shown in pictures. Competitors should always inform all people shot in pictures and obtain their consent to distribution otherwise their posts will automatically be excluded by the Contest. The Contest’s organization will never be responsible for any eventual request of compensation raised by people shot in pictures used for participation to this Contest, neither by right owners that weren’t requested to release a signed consent form.' + '<br/><br/>In case of legal litigation, the authorized owner of the social media account used for the registration for the Contest will be considered the participant and should adapt to the present regulations. \n' + 'The “authorized account’s title holder” is the physical person assigned to the social media account or to the email address created by an Internet provider, by an online service provider or by any other responsible organization for e-mail addresses’ assignment for the domain associated to the e-mail address related to this Contest’s participation. Each participant could be requested to demonstrate of being an authorized account’s title holder.'
    }, {
      title: 'Property rights and pictures availability ',
      content: 'When participants decide to post their pictures with the hashtag #AlpFoodwayContest related to participation to this Contest, they automatically authorize their usage, publication and dissemination (by any technological mean, in any format and by any channel) by AlpFoodway project partners only for the aims related to AlpFoodway project’s and contest’s promotion, with no obligation of a previous authorization’s request.'
    }, {
      title: 'Preise',
      content: 'In diesem Wettbewerb werden keine Geldpreise vergeben.' + 'Die drei besten Bilder und Beiträge werden auf der Website und den Social Media von AlpFoodway veröffentlicht und gewürdigt.' + '<ul>' + '<li>Der Sieger des ersten Preises gewinnt die kostenlose Teilnahme am „AlpFoodway Media Trip“ mit international anerkannten Journalisten und Fotografen. Der Media Trip beginnt am 03. Juli 2019 in Le Chatelard (Savoie, Frankreich) und endet am 09. Juli 2019 in Edolo (Valcamonica, Italien). Zwischenstops sind: Das Aostatal (Italien) und die Kantone Wallis und Graubünden (Schweiz);</li>' + '</ul>' + 'Alle ausgezeichneten Beiträge können auch in dem Dossier der Kandidatur für die Nominierung des Erbes der Alpinen Esskultur auf die Repräsentative UNESCO Liste des immateriellen Kulturerbes der Menschheit inkludiert werden. '
    }, {
      title: 'Jury und Benachrichtigung der Gewinner',
      content: 'Alle Beiträge werden von einer qualifizierten Jury bewertet, die aus ausgesuchten AlpFoodway Projektpartnern zusammengestellt wird. Die Jury wird alle Beiträge evaluieren und durch ihr unanfechtbares Ermessen die drei besten Beiträge auf Basis des folgenden Bewertungsmaßstabs auszeichnen:' + '<ul>' + '<li>50% Stimmigkeit mit dem gestellten Thema;</li>' + '<li>25% Originalität und Kreativität;</li>' + '<li>25% Anzahl der auf Instagram erreichten "likes".</li>' + '</ul>' + 'Nur Beiträge, die insgesamt min. 100 „likes“ mit den drei Bildern erzielen, werden bewertet. Die Jury wird die Bewertung an den ersten 100 Teilnehmern, die mindestens 100 „likes“ mit ihrem Beitrag erreicht haben in chronologischer Reihenfolge der Erscheinung vornehmen. \n<br/><br/>' + 'Der Gewinner wird am 24. Juni 2019 durch die Organisatoren benachrichtigt.<br/><br/>' + 'Falls notwendig, werden die Teilnehmer gebeten die Einverständniserklärungen aller in den Beiträgen abgebildeten Dritten Parteien einzusenden. <br/><br/>' + 'Die Liste der besten Beiträge wird auf <a href="https://www.alpfoodway.eu" target="_blank">www.alpfoodway.eu</a>  einsehbar sein' + '<br/><br/>' + '<h6 style="color: #c41c21;">Hilfreiche Links:</h6>' + '<ul>' + '<li><a href="https://www.alpine-space.eu/projects/alpfoodway/en/home" target="_blank">www.alpine-space.eu/projects/alpfoodway/en/home</a></li>' + '<li><a href="https://www.alpfoodway.eu" target="_blank">www.alpfoodway.eu</a></li>' + '<li><a href="https://www.intagiblesearch.eu">www.intagiblesearch.eu</a></li>' + '</ul>'
    }],
    youtubeGallery: 'Video',
    inventoryMap: 'Bestandsübersicht',
    becomeSupporter: 'Werden Sie Unterstützer',
    gallery: 'ICH Werte'
  },
  French: {
    italianPartners: 'PARTNER ITALIEN',
    swissPartners: 'PARTENERS SUISSES',
    alpFoodWayDescription: '',
    englishLanguage: 'ANGLAIS',
    italianLanguage: 'ITALIEN',
    germanLanguage: 'ALLEMAND',
    frenchLanguage: 'FRANÇAIS',
    slovenianLanguage: 'SLOVENE',
    home: 'Home',
    events: 'Événements',
    pastEvents: undefined,
    socials: 'Réseaux Sociaux',
    news: 'News',
    supporters: 'Supporteurs',
    signPetition: 'Signer la Pétition',
    socialWall: 'Social Wall',
    loadMore: 'Plus',
    captionTitleSign: 'Pétition pour l’inscription sur la Liste Représentative du Patrimoine Culturel Immatériel de l’Humanité de l’UNESCO',
    captionText: {
      p1: 'Le Patrimoine Alimentaire Alpin regroupe des pratiques de production et de consommation durables, des connaissances et des compétences, des paysages productifs et la cuisine traditionnelle locale venant des régions alpines. Il s\'appuie sur les biens communs, le partage de biens et services et le soutien mutuel. Nous, populations qui nous nous soucions du futur des Alpes, voulons sauvegarder le Patrimoine Alimentaire Alpin par le biais d\'une inscription multinationale sur la liste représentative du Patrimoine Culturel Immatériel de l’Humanité de l’UNESCO car',
      p2: 'Lisez la Charte, découvrez comment vous pouvez participer à la sauvegarde du Patrimoine Alimentaire Alpin et soutenez l\'inscription multinationale du Patrimoine Alimentaire Alpin sur la liste représentative du Patrimoine Culturel Immatériel de l’Humanité de l’UNESCO en signant la Pétition.',
      reasons: ['il constitue la base de l\'identité culturelle alpine et du mode de vie alpin,', 'il contribue à la résilience des communautés alpines,', 'il encourage les populations à vivre dans les zones rurales des Alpes,', 'il préserve des paysages productifs et la biodiversité,', 'il est fondamental pour la durabilité des Alpes,', 'il renforce l\'attractivité des régions alpines.']
    },
    peopleHaveSigned: 'Personnes qui ont déjà signé',
    mainSupporters: 'partners',
    otherSupporters: 'Supporteurs',
    supportersPosition: 'Découvre d\'où nos supporteurs viennent',
    haveSigned: 'Personnes qui ont déjà signé la Pétition',
    statistics: 'Statistiques',
    read: 'Lire',
    theCarta: 'La Charte',
    theCartaRound: 'Charte du Patrimoine Alimentaire Alpin',
    sign: 'Signer',
    thePetition: 'La Pétition',
    thePetitionRound: 'La Pétition AlpFoodwayUNESCO',
    share: '',
    ourCampaign: 'Notre campagne',
    signs: 'Signatures',
    socialContents: 'Contents Sociaux',
    insertName: 'Nom',
    insertSurname: 'Surnom',
    insertCity: 'Ville',
    insertEmail: 'couriel',
    updatesAboutPetition: 'Je désire recevoir des mises à jour sur la Pétition',
    confirmationPrivacyStatementPT1: 'Je confirme avoir lu',
    confirmationPrivacyStatementPT2: ' l\'information sur le traitement des données',
    alreadyUsedEmail: 'Ce couriel a déjà signé la Pétition',
    thankYouTitle: 'Merci d\'avoir signé',
    thankYouSubtitle: 'Aide nous à partager la Pétition sur tes réseaux sociaux préférés',
    maybeLater: 'Peut-être plus tard',
    noCitiesFound: 'Aucune ville trouvée',
    contentLoading: 'Les contenus de cette page viennent chargées',
    contentEmpty: 'En ce moment il n\'y a pas de contenus pour cette page',
    close: 'Ferme',
    thanksForSharing: 'Merci d\'avoir partagé, retourne à la plateforme',
    whySign: 'Pourquoi signer?',
    insertYourData: 'Entrez vos coordonnées',
    letsGetTo: 'Vas',
    inventory: 'Inventaire',
    carouselTitles: undefined,
    carouselSubtitles: undefined,
    readMore: 'Lis Plus',
    others: 'Autres',
    joinUs: undefined,
    discover: 'Découvrir',
    privacyPolicy: undefined,
    chartaContent: {
      generalTitle: 'Charte du Patrimoine Alimentaire Alpin',
      catchPhrase: 'Préserver le Patrimoine alimentaire alpin est aussi notre responsabilité.',
      chapter1: {
        title: 'Préambule',
        text: 'Nous, populations qui avons à coeur l’avenir des Alpes, nous souhaitons sauvegarder le Patrimoine alimentaire alpin dans un esprit de responsabilité partagée, à travers une démarche de candidature pour inscription sur la Liste Représentative du Patrimoine Culturel Immatériel de l’Humanité de l’UNESCO.\n\n' + 'Le Patrimoine alimentaire alpin comprend, dans notre vision, l’ensemble des pratiques de production et de consommation durables, ainsi que les connaissances et compétences, les paysages productifs et les cuisines traditionnelles des régions alpines. Ce patrimoine porte en soi et contribue à transmettre les valeurs des biens communs, les valeurs de partage de biens et services et du soutien mutuel.\n\n' + 'Nous pensons qu’il est crucial pour le futur des Alpes car :',
        purposes: ['il constitue la base de l\'identité culturelle alpine et du mode de vie alpin,', 'il contribue à la résilience des communautés alpines,', 'il encourage les populations à vivre dans les zones rurales des Alpes,', 'il préserve des paysages productifs et la biodiversité,', 'il est fondamental pour la durabilité des Alpes,', 'il renforce l\'attractivité des régions alpines.']
      },
      chapter2: {
        title: 'Le but',
        text: 'La Charte du Patrimoine alimentaire alpin est un document participatif qui appelle tout citoyen, toute association, entreprise, institution et toute autorité à assumer la responsabilité de la sauvegarde du Patrimoine Alimentaire Alpin et à soutenir son inscription sur la Liste Représentative du Patrimoine culturel immatériel de l’Humanité de l’UNESCO.'
      },
      chapter3: {
        title: 'Le Patrimoine alimentaire alpin',
        text: {
          p1: 'Les Alpes sont l’une des plus grandes chaînes de montagnes d’Europe, couvrant l’Autriche, la Slovénie, l’Italie, la Suisse, le Liechtenstein, l’Allemagne, la France et Monaco. Communément considérées comme le cœur de l’Europe, elles se caractérisent par de hauts sommets, des vallées glaciaires, des lacs et des rivières à débit rapide. Ces caractéristiques, associées à des conditions climatiques et géologiques uniques dépendant de l\'altitude et du soleil, créent une biodiversité extraordinaire, nourrie par les activités pastorales et agricoles des humains qui s\'y sont installés dès le Paléolithique. Après des siècles de vie dans ces régions périphériques, confrontées à des conditions climatiques difficiles, à des terres agricoles rares et à des habitats dispersés, les communautés alpines ont élaboré des stratégies de subsistance spécifiques et sont parvenues à les maintenir grâce à la transmission à travers les générations de leur savoir et de leur mode de vie.',
          p2: 'Ces communautés ont produit et consommé localement, ont migré au fil de saison entre les plaines et les montagnes, ont pratiqué une agriculture en harmonie avec la nature, en s’appuyant sur la transhumance et la conservation des aliments. Elles utilisent de manière durable les ressources naturelles, en cherchant à assurer leur subsistance, tout en faisant un usage parcimonieux des ressources matérielles. Leur survie a été étroitement liée au partage des biens et des services, à l’entraide et au développement de capacités multifonctionnelles. La combinaison de l\'autosuffisance avec l\'ouverture à d\'autres cultures et une habilité à s\'adapter aux innovations venant d’ailleurs a façonné les paysages alpins et permis de développer un patrimoine alimentaire extraordinaire. \n' + 'Soutenu par la croissance des villes alpines, plaque tournante des innovations technologiques et sociales, avec un secteur du tourisme en plein essor et un secteur de la restauration promouvant une consommation responsable, ce patrimoine contribue à la compétitivité et à l\'attractivité des territoires alpins en tant que territoires durables. ',
          p3: 'Le Patrimoine alimentaire alpin est l’un des marqueurs les plus importants de l’identité (macro)régionale des Alpes. Etant fondé sur les communautés, il a créé des liens forts entre des personnes très diverses, participant au maintien et à la transmission de valeurs communes et favorisant une qualité de vie. Il combine des éléments du patrimoine matériel spécifiques à la région (paysages productifs, bâtiments typiques, cultures, plats, appareils et ustensiles de cuisine) à d’autres éléments immatériels (agriculture, viticulture, élevage, chasse, pêche en eau douce et traditions apicoles, méthodes de cuisson et de conservation, recettes, coutumes alimentaires, normes sociales, relations familiales et communautaires, rituels et fêtes). \n' + 'La rencontre de diverses traditions a amené au développement d’une culture alimentaire variée et en permanente adaptation. Les variétés de pain de longue conservation, de légumes savoureux, de fromages, de viandes fumées ou salées et de produits à base de viande de longue garde, d\'herbes et de fruits alpins, de mets sucrés sont parmi les exemples les plus renommés de plats qui, compte tenu de leur production et consommation, participent à la transmission des valeurs culturelles alpines, donnant à cette région des caractères propres.'
        }
      },
      chapter4: {
        title: 'Le Patrimoine alimentaire alpin risque de perdre ses caractères distinctifs',
        text: {
          p1: 'L’urbanisation, le tourisme de masse, l’augmentation de la circulation, la pollution de l\'air et des eaux, l\'intensification de l\'agriculture et le réchauffement de la planète ont un impact négatif sur la qualité de la vie des habitants et menacent les modes de vie traditionnels des Alpes. Bien qu\'elles restent les montagnes les plus densément peuplées du monde, les Alpes sont actuellement confrontées à un dépeuplement et à l\'abandon des zones d\'altitude, provoquant un déclin des terres et des occupations agricoles traditionnelles, ainsi qu\'une perte des connaissances et des compétences, des traditions, des pratiques et des valeurs qui façonnent le Patrimoine alimentaire alpin. La sauvegarde du Patrimoine alimentaire alpin est donc essentielle pour préserver la culture et l\'identité des habitants des Alpes, pour rétablir un mode de vie durable et respectueux d’un environnement fragile, promouvoir et préserver la qualité des paysages alpins et, de ce fait, assurer un développement durable des régions alpines au profit des générations actuelles et futures.',
          p2: 'En 2003, l’UNESCO a adopté la Convention pour la sauvegarde du patrimoine culturel immatériel qui soutient les communautés, groupes et individus dans leurs efforts pour identifier et définir leur patrimoine culturel immatériel, en sensibilisant l’opinion publique à la nécessité de le transmettre. Les communautés alpines d\'Autriche, de Slovénie, d\'Italie, de Suisse, d\'Allemagne et de France s\'efforcent donc conjointement de convaincre leurs États d\'inscrire de façon multinationale le Patrimoine alimentaire alpin sur la Liste représentative du patrimoine culturel immatériel de l\'humanité de l\'UNESCO.'
        }
      },
      chapter5: {
        title: 'S\'engager pour la sauvegarde du Patrimoine alimentaire alpin',
        text: {
          p1: 'Pour surmonter ces défis, la participation active des citoyens, des communautés, des associations, des entreprises, des institutions et des autorités des régions alpines et avoisinantes est centrale, tout comme leur engagement en faveur de la sauvegarde du patrimoine et l\'inscription sur la Liste représentative du patrimoine mondial de l\'humanité de l\'UNESCO. Dans cette perspective, chacun et chacune peut assumer et partager la responsabilité de l\'avenir du Patrimoine alimentaire alpin.',
          uls: [{
            title: 'En tant qu\'agriculteurs et producteurs de denrées alimentaires, nous pouvons:',
            lis: ['poursuivre la production d\'aliments spécifiques aux régions concernées, préserver les paysages ruraux et la biodiversité tout en privilégiant les variétés locales de semences, d\'espèces végétales et de races animales;', 'respecter les principes écologiques en vigueur dans l\'agriculture et le transport des aliments afin de fournir aux consommateurs des aliments sains et contribuer à la durabilité de l\'environnement;', 'valoriser les produits en fixant des prix équitables qui respectent la dignité de notre travail et mettent en exergue les différences par rapport à la production de masse;', 'coopérer avec les restaurants locaux et les entreprises touristiques  par le biais de circuits d\'approvisionnement courts afin de promouvoir la culture alimentaire locale;', 'préserver, promouvoir et être fier des pratiques agricoles traditionnelles, du savoir-faire en matière de conservation des aliments, des recettes et des techniques de cuisson, ainsi que des plats qui constituent la base du Patrimoine alimentaire alpin.']
          }, {
            title: 'En tant que citoyens des Alpes, nous pouvons:',
            lis: ['soutenir les agriculteurs alpins et les producteurs d\'aliments artisanaux en achetant leurs produits;', 'nous rendre dans les marchés locaux afin de profiter de la variété des produits locaux;', 'préparer des plats alpins à la maison et transmettre ce savoir aux jeunes générations;', 'former ou rejoindre des communautés patrimoniales locales, participer bénévolement à des activités visant à préserver et à promouvoir le Patrimoine alimentaire alpin;', 'encourager les institutions et les autorités locales à soutenir la sauvegarde du Patrimoine alimentaire alpin.']
          }, {
            title: 'En tant que touristes dans les Alpes, nous pouvons:',
            lis: ['respecter l\'environnement pour préserver la biodiversité et la qualité des paysages ruraux;', 'demander aux restaurants alpins de servir des plats traditionnels produits localement;', 'participer à des fêtes gastronomiques alpines et à d\'autres événements pour soutenir les communautés locales;', 'visiter les musées locaux pour mieux connaitre la culture alimentaire alpine et, plus largement le patrimoine culturel régional;', 'promouvoir le Patrimoine alimentaire alpin et les fêtes gastronomiques en le faisant connaitre à nos amis et en relayant l’information le plus largement possible.']
          }, {
            title: 'En tant qu’institutions culturelles et éducatives, nous pouvons nous engager à:',
            lis: ['sauvegarder le Patrimoine alimentaire alpin local à travers des mesures d’étude, d’analyse, de documentation et de valorisation;', 'favoriser la transmission du Patrimoine alimentaire alpin en organisant des forums et des manifestations culturelles ainsi qu\'en fournissant des espaces de performance/démonstration ;', 'améliorer la connaissance générale du Patrimoine alimentaire alpin en enseignant aux citoyens les traditions locales et en les rendant conscients de leur propre potentiel de sauvegarde du patrimoine;', 'transmettre les savoirs aux jeunes générations;', 'soutenir les communautés porteuses du patrimoine alpin en les aidant à reconnaître et à valoriser leur patrimoine alimentaire et en les incitant à participer activement aux activités consacrées à ce dernier;', 'aider les communautés alpines à préserver les paysages ruraux en tant qu\'espace de vie et en tant que fondement de l\'identité locale;', 'coopérer avec des institutions similaires à l\'intérieur et à l\'extérieur de la région ou du pays dans le cadre d’actions communes concernant le Patrimoine alimentaire alpin;', 'convaincre les autorités de la nécessité de sauvegarder le Patrimoine alimentaire alpin et de soutenir les communautés concernées.']
          }, {
            title: 'En tant qu\'institutions scientifiques, nous pouvons nous engager à:',
            lis: ['faire des recherches sur le Patrimoine alimentaire alpin, notamment ses effets sur : la santé humaine, l\'identité culturelle et le mode de vie, la biodiversité, la préservation du paysage et le développement durable;', 'étudier les liens entre les zones alpines rurales et les zones urbaines pour comprendre la dynamique qui organise la production et la consommation alimentaire entre les deux;', 'coopérer avec les organisations culturelles, éducatives et touristiques ainsi que les médias pour assurer une meilleure transmission des connaissances émanant du terrain;', 'collaborer avec les communautés scientifiques afin de fournir des informations multidisciplinaires transnationales relative à l\'importance du Patrimoine alimentaire alpin;', 'faire pression sur les États et l\'Union européenne pour qu\'ils financent des projets de recherche multidisciplinaires et appliqués ou des projets soutenant le développement des régions alpines.']
          }, {
            title: 'En tant qu’organisations touristiques, nous pouvons:',
            lis: ['promouvoir les restaurants traditionnels alpins ainsi que les fêtes ou festivals relatifs au Patrimoine alimentaire alpin;', 'créer des offres touristiques thématiques axées sur l\'agriculture alpine et la production, la transformation, la préparation ou la dégustation d\'aliments artisanaux, tout en soulignant le lien qui existe entre la qualité de la production alimentaire et la qualité des paysages ruraux;', 'favoriser les itinéraires ou parcours alimentaires alpins régionaux et transnationaux;', 'soutenir les communautés locales dans l\'organisation d\'activités et d\'événements liés à l\'alimentation.']
          }, {
            title: 'En tant que médias, journalistes et influenceurs, nous pouvons:',
            lis: ['diffuser un message qui met en avant le caractère unique du Patrimoine alimentaire alpin;', 'promouvoir les agriculteurs, les producteurs, les transformateurs et les détaillants (de produits alimentaires alpins);', 'coopérer avec les communautés locales et les organisations culturelles pour promouvoir leurs activités de manière innovante;', 'informer les entreprises et les autorités locales du potentiel du Patrimoine alimentaire alpin pour l\'identité régionale, l\'économie locale et le développement durable.']
          }, {
            title: 'En tant qu\'entreprises de transformation alimentaire et détaillants nous pouvons:',
            lis: ['acheter et vendre des aliments produits dans les Alpes, en soutenant les agriculteurs et les producteurs d\'aliments traditionnels;', 'contribuer à fixer des prix équitables pour les produits faisant partie du Patrimoine alimentaire alpin;', 'utiliser des stratégies promotionnelles qui mettent en valeur les caractéristiques particulières de ces produits en racontant leurs histoires et en éduquant le goût des consommateurs;', 'soutenir des initiatives telles que les marques territoriales et les réseaux locaux qui promeuvent le Patrimoine alimentaire alpin;', 'respecter les droits des communautés patrimoniales lors de la valorisation des produits ou de l\'enregistrement des indications géographiques.']
          }, {
            title: 'En tant que restaurateurs et chefs, nous pouvons:',
            lis: ['acheter des ingrédients produits dans les Alpes pour aider les agriculteurs et les producteurs d\'aliments locaux;', 'contribuer à la promotion du Patrimoine alimentaire alpin en proposant des plats inspirés des traditions alpines, à partir d\'ingrédients authentiques et respectant le rythme des saisons;', 'apprendre des recettes traditionnelles des communautés alpines et reconnaître le rôle des détenteurs de la tradition;', 'soutenir des initiatives telles que les marques territoriales et les réseaux locaux qui promeuvent le Patrimoine alimentaire alpin.']
          }, {
            title: 'En tant qu\'autorités locales et régionales, nous pouvons:',
            lis: ['faciliter l\'accès des communautés alpines, des associations, des institutions et des entreprises au savoir-faire en matière de conservation, de transmission et de promotion du patrimoine alimentaire régional;', 'adopter des mesures appropriées pour protéger le Patrimoine alimentaire alpin dans notre région et soutenir les agriculteurs locaux, les producteurs d\'aliments artisanaux et les communautés porteuses du patrimoine alimentaire dans leurs efforts pour le préserver et le promouvoir;', 'soutenir activement le réseau d\'acteurs visant à inscrire le Patrimoine alimentaire alpin sur la liste représentative du patrimoine culturel immatériel de l\'humanité de l\'UNESCO et aider à les mettre en relation avec les autorités nationales.']
          }, {
            title: 'En tant qu\'autorités nationales, nous pouvons:',
            lis: ['coopérer avec les autorités locales et régionales alpines pour soutenir la sauvegarde du Patrimoine alimentaire alpin et créer des solutions durables pour son utilisation dans l\'économie locale;', 'adopter des mesures en faveur du développement durable des régions alpines de notre pays;', 'coopérer de façon transnationale pour la reconnaissance du Patrimoine alimentaire alpin en tant que patrimoine commun digne de sauvegarde et porteur d’un rôle crucial pour le développement durable des Alpes;', 'soutenir la proposition d\'inscription du Patrimoine alimentaire alpin sur la liste représentative du patrimoine culturel immatériel de l\'humanité de l\'UNESCO et promouvoir les efforts transnationaux des communautés alpines.']
          }]
        }
      },
      chapter6: {
        title: '',
        text: {
          p1: 'En tant que personnes soucieuses de l\'avenir des Alpes, nous croyons en l\'urgence de préserver le Patrimoine alimentaire alpin pour l\'identité, le mode de vie, les paysages, la biodiversité et le développement durable des Alpes. Lorsque nous partageons la responsabilité, celle-ci est sauvegardée plus efficacement.',
          p2: ''
        }
      }
    },
    contest: 'Contest',
    regulations: 'Lire le règlement complet\n',
    winners: 'Gagnants',
    winnersList: undefined,
    contestOpening: 'Le concours photo débutera le 23/04/2019',
    contestEnding: 'Le concours photo se termine le 16/06/2019',
    contestClosing: 'Le concours de photographie s\'est terminé le 16/06/2019',
    regulationsItems: [{
      title: 'Concours de storytelling photographique: "Histoires de patrimoine alimentaire alpin"',
      content: 'AlpFoodway, un projet Interreg Alpine Space, organise un concours de storytelling photographique appelé “Histoires de patrimoine alimentaire alpin”. Il est régi par les procédures et le règlement suivants.'
    }, {
      title: 'Thème',
      content: 'Le concours a pour objectif de décrire le patrimoine alimentaire alpin par le biais de narrations photographiques. Le but de cette initiative est de renforcer et d’élargir le soutien à la sauvegarde du patrimoine alimentaire alpin ainsi que sa candidature à la liste représentative du Patrimoine culturel immatériel de l’UNESCO.\n' + '        Tous les projets de storytelling proposés doivent traiter du patrimoine alimentaire alpin, que ce soit au niveau des pratiques de production, des pratiques de transformation ou de préservation alimentaires, des rituels de consommation, du savoir-faire ou des paysages liés à l’alimentation.\n' + '  Le patrimoine culturel et social mis en avant doit toujours être ancré dans le style de vie montagnard des communautés alpines, l’échange de nourriture et de services, la gestion des biens communs, la transmission des pratiques et de savoir-faire d’une génération à l’autre.'
    }, {
      title: 'Termes et conditions',
      content: 'Du 13/05/2019 au 16/06/2019 vous pouvez poster vos histoires visuelles sur Instagram en utilisant votre compte public.<br/><br/>Pour participer au concours, les règles suivantes doivent être respectées:' + '<ul style="padding-left: 10%; padding-top: 2%">' + '<li>Le post doit être composé uniquement de trois photos de haute qualité;</li>' + '<li>Le post doit comprendre le hashtag #AlpFoodwayContest et la mention @AlpFoodway_project doit être indiquée également;</li>' + '<li>Le post doit être géolocalisé;</li>' + '<li>La description du post doit indiquer uniquement la localisation et la date des trois photos, sans aucun autre texte.</li>' + '<li>D’autres hashtags peuvent être ajoutés, le nombre maximal étant de dix. Ces hashtags doivent être nécessairement strictement reliés aux photos;</li>' + '<li>De plus, afin de permettre aux membres du jury d’avoir accès au post, il est essentiel que le compte ne soit pas configuré en mode privé.</li>' + '</ul>' + '<p style="color: #c41c21; text-align: center;"><b>Tous les posts publiés seront également visibles sur la section concours de la platforme AlpFoodway <a href="https://www.alpfoodway.eu" target="_blank">www.alpfoodway.eu</a>.</p>'
    }, {
      title: 'Conditions d’admission',
      content: 'Les participant.e.s doivent avoir au minimum 18 ans. Les membres du projet AlpFoodway ne peuvent pas participer au concours.'
    }, {
      title: 'Declarations and guarantees',
      content: 'Participation to this Contest implies the unconditional acceptance of all regulations related.<br/><br/>' + 'Contents should be coherent with this Contest’s theme. With this reference, at the incontestable discretion of AlpFoodway partners, posts will be deleted if considered not proper or not respecting any right including, among others, infringement of copyright, registered trademarks, publicity right, intellectual property right of third parts and privacy right. Pictures should not contain information considered confidential, inappropriate, indecent, harmful,  defamatory, illegal or against the law.' + '<br/><br/>Each participant will have civil and penal responsibility for his/her pictures; Polo Poschiavo, lead partner of the AlpFoodway project and promoter of the Contest, will have no responsibility in any circumstance, neither in relation to people shown in pictures. Competitors should always inform all people shot in pictures and obtain their consent to distribution otherwise their posts will automatically be excluded by the Contest. The Contest’s organization will never be responsible for any eventual request of compensation raised by people shot in pictures used for participation to this Contest, neither by right owners that weren’t requested to release a signed consent form.' + '<br/><br/>In case of legal litigation, the authorized owner of the social media account used for the  registration for the Contest will be considered the participant and should adapt to the present regulations. \n' + 'The "authorized account’s title holder" is the physical person assigned to the social media account or to the email address created by an Internet provider, by an online service provider or by any other responsible organization for e-mail addresses’ assignment for the domain associated to the e-mail address related to this Contest’s participation. Each participant could be requested to demonstrate of being an authorized account’s title holder.'
    }, {
      title: 'Property rights and pictures availability',
      content: 'When participants decide to post their pictures with the hashtag #AlpFoodwayContest related to participation to this Contest, they automatically authorize their usage, publication and dissemination (by any technological mean, in any format and by any channel) by AlpFoodway project partners only for the aims related to AlpFoodway project’s and contest’s promotion, with no obligation of a previous authorization’s request.'
    }, {
      title: 'Prix',
      content: 'Le concours n’accorde pas de prix sous forme d’argent. Les récompenses des trois meilleur.e.s participant.e.s seront:' + '<ul>' + '<li>Pour le.la meilleur.e participant.e, une participation gratuite au "Alpfoodway" Media Trip avec des journalistes et photographes reconnu.e.s internationalement. Le Media Trip commencera le 3 juillet 2019 à Le Chatelard (Savoie, France) et se terminera le 9 juillet 2019 à Edolo (Valcamonica, Italie). Les étapes intermédiaires seront : Vallée d’Aoste (Italie), Cantons du Valais et des Grisons (Suisse).' + '<li>Une publication des meilleures photos des trois gagnant.e.s sur le site internet et les réseaux sociaux d’AlpFoodway;</li>' + '</ul>' + 'Toutes les œuvres primées peuvent également être incluses dans le dossier de candidature de l\'UNESCO pour la proposition d\'inscription du patrimoine alimentaire alpin sur la Liste représentative du patrimoine culturel immatériel mondial de l\'UNESCO.'
    }, {
      title: 'Jury et communications avec les gagnant.e.s',
      content: 'Tous les travaux seront évalués par un jury qualifié composé d\'un groupe sélectionné de partenaires du projet AlpFoodway. Le jury évaluera tous les travaux et choisira, à son entière et indiscutable discrétion, les trois meilleurs travaux sur la base des éléments suivants:' + '<ul>' + '<li> 50% de l’évaluation sera basée sur la cohérence avec le thème proposé;</li>' + '<li>25% de l’évaluation sera basée sur l\'originalité et la créativité;</li>' + '<li>25% de l’évaluation sera basée sur le nombre de préférences exprimées sur Instagram (nombre de « j\'aime »).</li>' + '</ul>' + 'Veuillez noter que seul.e.s les participant.e.s ayant atteint au minimum 100 «j\'aime» avec leurs trois photos seront évalué.e.s. Le jury évaluera les publications à partir des 100 premiers participant.e.s ayant atteint le minimum de 100 likes dans l\'ordre chronologique d\'arrivée.<br/><br/>' + 'Le.la gagnant.e et les auteur.e.s retenu.e.s seront informés par l\'organisation d\'ici le 24 juin 2019.<br/><br/>' + 'Si nécessaire, il sera demandé aux participant.e.s d\'envoyer tous les formulaires de consentement / d’autorisation de toutes les tierces parties apparaissant sur les images.<br/><br/>' + 'La liste des gagnant.e.s sera disponible sur <a href="https://www.alpfoodway.eu" target="_blank">www.alpfoodway.eu</a>' + '<br/><br/>' + '<h6 style="color: #c41c21;">Liens utiles:</h6>' + '<ul>' + '<li><a href="https://www.alpine-space.eu/projects/alpfoodway/en/home" target="_blank">www.alpine-space.eu/projects/alpfoodway/en/home</a></li>' + '<li><a href="https://www.alpfoodway.eu" target="_blank">www.alpfoodway.eu</a></li>' + '<li><a href="https://www.intagiblesearch.eu">www.intagiblesearch.eu</a></li>' + '</ul>'
    }],
    youtubeGallery: 'Vidéo',
    inventoryMap: 'Carte d\'inventaire',
    becomeSupporter: 'Devenir supporter',
    gallery: 'ICH Valeurs'
  },
  Slovenian: {
    italianPartners: 'ITALIJANSKI PARTNERJI',
    swissPartners: 'ŠVICARSKI PARTNERJI',
    alpFoodWayDescription: 'Interdisciplinarni, transnacionalni in participativni pristop k dediščini alpske prehrane',
    englishLanguage: 'ANGLEŠČINA',
    italianLanguage: 'ITALIJANŠČINA',
    germanLanguage: 'NEMŠČINA',
    frenchLanguage: 'FRANCOŠČINA',
    slovenianLanguage: 'SLOVENŠČINA',
    home: 'Domov',
    events: 'Dogodki',
    pastEvents: undefined,
    socials: 'Družbena omrežja',
    news: 'Novice',
    supporters: 'Podporniki',
    signPetition: 'Podpiši peticijo',
    socialWall: 'Spletni zid',
    loadMore: 'Več',
    captionTitleSign: 'Peticija za nominacijo alpske prehranske dediščine na Unescov Reprezentativni seznam nesnovne kulturne dediščine človeštva',
    captionText: {
      p1: 'Alpska prehranska dediščina je skupek vzdržnih načinov pridelave in uživanja hrane, znanj in veščin, pridelovalnih krajin in tradicionalne hrane, pridelane v alpskih regijah z zanašanjem na skupno dobro, skupne dobrine in usluge ter na vzajemno pomoč. Ljudje, ki nam je mar za prihodnost Alp, želimo varovati alpsko prehransko dediščino tudi z vpisom na Unescov Reprezentativni seznam nesnovne kulturne dediščine človeštva, saj:',
      p2: 'Preberite Listino alpske prehranske dediščine, odkrijte, kako lahko prispevate k njenemu varovanju, in s podpisom peticije podprite njeno multinacionalno nominacijo za vpis na Unescov Reprezentativni seznam nesnovne kulturne dediščine človeštva.',
      reasons: ['je osnova alpske kulturne identitete in načina življenja,', 'pripomore k trdoživosti alpskih skupnosti,', 'motivira ljudi za življenje na alpskih ruralnih območjih,', 'ohranja pridelovalne krajine in biotsko raznovrstnost,', 'podpira vzdržnost Alp in,', 'povečuje privlačnost alpskih regij.']
    },
    peopleHaveSigned: 'Podpisniki',
    mainSupporters: 'partnerji',
    otherSupporters: 'Podporniki',
    supportersPosition: 'Odkrij, od kod so naši podporniki',
    haveSigned: 'Podpisniki peticije',
    statistics: 'Statistika',
    read: 'Preberi',
    theCarta: 'Listina',
    theCartaRound: 'Listina Alpske Prehranske Dediščine',
    sign: 'Podpiši',
    thePetition: 'Peticija',
    thePetitionRound: 'Peticija AlpFoodwayUNESCO',
    share: 'Deli',
    ourCampaign: 'Naša kampanja',
    signs: 'Podpisi',
    socialContents: 'Družbene vsebine',
    insertName: 'Ime',
    insertSurname: 'Priimek',
    insertCity: 'Kraj',
    insertEmail: 'e-naslov',
    updatesAboutPetition: 'Želim prejemati novice o peticiji',
    confirmationPrivacyStatementPT1: 'Potrjujem, da sem prebral/a',
    confirmationPrivacyStatementPT2: ' Informacije o obdelavi osebnih podatkov',
    alreadyUsedEmail: 'Oseba s tem e-naslovom je že podpisala peticijo',
    thankYouTitle: 'Hvala za vaš podpis.',
    thankYouSubtitle: 'Pomagajte nam pri promociji peticije na vaših najljubših družbenih omrežjih.',
    maybeLater: 'Morda pozneje',
    noCitiesFound: 'Kraja ni mogoče najti',
    contentLoading: 'Nalagamo vsebino strani',
    contentEmpty: 'Trenutno na spletni strani ni nobene razpoložljive vsebine',
    close: 'Zapri',
    thanksForSharing: 'Hvala za sodelovanje, nazaj na platformo',
    whySign: 'Zakaj podpisati?',
    insertYourData: 'Vnesi podatke v obrazec',
    letsGetTo: 'Pojdimo na',
    inventory: 'Popis',
    carouselTitles: ['#AlpFoodway', 'Vzpostavitev trajnostnega razvojnega modela', 'Ozaveščanje za oblikovanje mreže', 'Mapiranje in izpopolnjenena inventarizacija', 'Povezovanje prehranske dediščine', 'Priprava in promocija listine'],
    carouselSubtitles: ['Interdisciplinarni, transnacionalni in participativni pristop k dediščini alpske prehrane', 'za obrobna gorska območja', 'alpskih dediščinskih skupnosti', 'dediščine alpske prehrane', 'z inovativnimi tržnimi in upravljavskimi orodji', 'alpske prehranske dediščine'],
    readMore: 'Preberi Več',
    others: 'Drugi',
    joinUs: undefined,
    discover: 'Odkrijte',
    privacyPolicy: undefined,
    chartaContent: {
      generalTitle: 'Listina Alpske Prehranske Dediščine',
      catchPhrase: 'Ohranjanje alpske prehranske dediščine je tudi naša odgovornost.',
      chapter1: {
        title: 'Preambula',
        text: 'Mi, ljudje, ki nam je mar za prihodnost Alp, se zavzemamo za varovanje alpske prehranske dediščine, tako da prevzemamo soodgovornost zanjo in si prizadevamo za njeno nominacijo za vpis na Unescov Reprezentativni seznam nesnovne kulturne dediščine človeštva.\n\n' + 'Alpsko prehransko dediščino razumemo kot skupek vzdržnih načinov pridelave in uživanja hrane, znanj in veščin, pridelovalnih krajin in tradicionalne hrane, pridelane v alpskih regijah z zanašanjem na skupno dobro, skupne dobrine in usluge ter na vzajemno pomoč. \n\n' + 'Verjamemo, da je alpska prehranske dediščina ključnega pomena za prihodnost Alp, saj:',
        purposes: ['je osnova alpske kulturne identitete in načina življenja,', 'pripomore k trdoživosti alpskih skupnosti,', 'motivira ljudi za življenje na alpskih podeželskih območjih,', 'ohranja pridelovalne krajine in biotsko raznovrstnost,', 'podpira vzdržnost Alp in ', 'povečuje privlačnost alpskih regij. ']
      },
      chapter2: {
        title: 'Namen',
        text: 'Listina o alpski prehranski dediščini je participativni in skupni dokument, ki vse državljane, združenja, podjetja, ustanove in oblasti poziva, naj prevzamejo soodgovornost za varovanje alpske prehranske dediščine in podprejo njeno nominacijo za vpis na Unescov Reprezentativni seznam nesnovne kulturne dediščine človeštva.'
      },
      chapter3: {
        title: 'Alpska prehranska dediščina',
        text: {
          p1: 'Alpe so ena največjih gorskih verig v Evropi, ki prečijo Avstrijo, Slovenijo, Italijo, Švico, Lihtenštajn, Nemčijo, Francijo in Monako. Imenujejo jih tudi gorsko srce Evrope. Zanje so značilni visoki piramidasti vrhovi, ledeniške doline in jezera ter deroče reke. Te značilnosti ob izjemnih podnebnih in talnih razmerah, ki so odvisne od nadmorske višine in izpostavljenosti soncu, soustvarjajo izjemno biotsko raznovrstnost; s kmetijstvom in pašništvom jo negujejo tudi ljudje, ki so se tu naselili že v paleolitiku.',
          p2: 'Alpske skupnosti so v stoletjih življenja na teh obrobnih območjih z neugodnimi vremenskimi razmerami, redkimi kmetijskimi zemljišči in razpršenimi naselji razvile posebne preživetvene načine ter jih uspele do danes ohranjati s prenosom znanj in načina življenja na naslednje generacije. Skupnosti so lokalno pridelovale in uživale hrano, se sezonsko selile z nižjih na višja območja in nazaj, kmetovale skladno z naravo, se opirale na transhumanco in shranjevanje živil, vzdržno uporabljale naravne vire, si prizadevale za samooskrbo in skrbno porabljale materialne dobrine. Odvisne so bile od skupne rabe dobrin in uslug, opirale so se na medsebojno pomoč in razvile vsestransko uporabne veščine. Kombinacija samozadostnosti z odprtostjo do drugih kultur in sposobnostjo prilagajanja inovacijam z drugih območij je oblikovala alpske krajine in pripeljala do razvoja enkratne alpske prehranske dediščine. Ta kulturna dediščina, ki jo podpirajo rastoča alpska mesta, središča tehnoloških in družbenih inovacij s cvetočim turizmom in gostinstvom, ki spodbujata kritično porabo, prispeva h konkurenčnosti in privlačnosti alpskih območij kot vzdržno naravnanih krajev.',
          p3: 'Alpska prehranska dediščina je eden od najpomembnejših označevalcev te posebne (makro)regionalne identitete. Ker temelji na skupnosti, ustvarja močne vezi med zelo različnimi ljudmi, poustvarja skupne vrednote in uteleša določeno kakovost življenja. Je zmes regionalno značilnih snovnih (pridelovalne krajine, gospodarska poslopja, pridelki, jedi, kuhinjske naprave in pripomočki) in nesnovnih vidikov prehranjevanja (kmetijsko, vinogradniško, živinorejsko, lovsko, sladkovodno ribiško in čebelarsko izročilo, načini kuhanja in konzerviranja hrane, recepti, prehranjevalne navade, družbeni pomeni, družinski in skupnostni odnosi, šege in festivali). Srečanje različnih tradicij je ustvarilo izjemno raznovrstno kulturo prehrane. Različice dolgotrajnega kruha, vložene zelenjave, sira, prekajenega ali nasoljenega mesa in trajnih mesnih izdelkov, alpskih zelišč in plodov ter sladkih pekovskih izdelkov sodijo med najbolj znane primere jedi, ki ob upoštevanju specifičnih načinov pridelave in uživanja hrane ohranjajo alpske kulturne vrednote in poosebljajo enkratnost tega območja.'
        }
      },
      chapter4: {
        title: 'Alpska prehranska dediščina izgublja svoje posebnosti',
        text: {
          p1: 'Širjenje mestnih območij, množični turizem, gost promet, onesnažena zrak in voda, intenzivno kmetijstvo in globalno segrevanje negativno vplivajo na kakovost življenja prebivalcev in ogrožajo tradicionalne načine življenja v Alpah. Čeprav ostajajo najgosteje poseljeno gorovje na svetu, se Alpe trenutno spoprijemajo z izseljevanjem in opuščanjem višinskih naselij, ki povzročata krčenje kmetijskih zemljišč, opuščanje tradicionalnih poklicev ter upad znanja in spretnosti, navad, praks in vrednot, ki so sooblikovale alpsko prehransko dediščino. Varovanje te dediščine je zato bistveno za ohranitev kulture in identitete prebivalcev Alp, za vnovično vzpostavitev vzdržnega načina življenja, ki upošteva krhko okolje, za spodbujanje in ohranjanje kakovosti alpskih krajin in s tem za zagotavljanje vzdržnega razvoja alpskih območij v dobrobit sedanjih in prihodnjih generacij.',
          p2: 'Unesco je leta 2003 sprejel Konvencijo o varstvu nesnovne kulturne dediščine, ki podpira skupnosti, skupine in posameznike pri prepoznavanju in opredeljevanju njihove nesnovne kulturne dediščine ter krepi zavest o potrebi po njenem varovanju. Alpske skupnosti iz Avstrije, Slovenije, Italije, Švice, Nemčije in Francije si tako skupaj prizadevajo prepričati države, naj podprejo serijsko nominacijo za vpis alpske prehranske dediščine na Unescov Reprezentativni seznam nesnovne kulturne dediščine človeštva.'
        }
      },
      chapter5: {
        title: 'Odločimo se za varovanje alpske prehranske dediščine',
        text: {
          p1: 'Premagovanje omenjenih izzivov, podprto z vpisom te dediščine na Unescov Reprezentativni seznam nesnovne kulturne dediščine človeštva, je mogoče le z dejavnim vključevanjem državljanov, skupnosti, združenj, podjetij, ustanov in oblasti v Alpah in zunaj njih ter z njihovo zavezo k varovanju dediščine. Vsak lahko prevzame soodgovornost za prihodnost alpske prehranske dediščine.',
          uls: [{
            title: 'Kot kmetje in proizvajalci hrane lahko:',
            lis: ['nadaljujemo s pridelavo lokalno značilne hrane ter z ohranjanjem vitalnih podeželskih krajin in biotske raznovrstnosti; pri tem lahko spodbujamo uporabo lokalnih semen, rastlinskih vrst in živalskih pasem;', 'upoštevamo ekološka načela v kmetijstvu in transportu hrane ter tako porabnikom zagotovimo zdravo hrano in prispevamo k okoljski vzdržnosti;', 'ovrednotimo pridelke in izdelke z obračunavanjem poštenih cen, ki spoštujejo dostojanstvo našega dela in poudarjajo razločke z množično pridelano in predelano hrano;', 'sodelujemo z lokalnimi restavracijami in turističnimi podjetji v kratkih dobavnih verigah ter s tem spodbujamo lokalno kulturo prehranjevanja;', 'ponosno ohranjamo in predstavljamo tradicionalne kmetijske prakse, znanje o konzerviranju hrane, recepte in kuharske tehnike ter jedi, ki so značilne za alpsko prehransko dediščino.']
          }, {
            title: 'Kot državljani Alp lahko:',
            lis: ['podpiramo alpske kmete in male proizvajalce hrane s kupovanjem njihovih pridelkov in izdelkov;', 'obiskujemo lokalne tržnice in tako kar najbolje izkoristimo raznovrstno lokalno ponudbo;', 'doma pripravljamo alpske jedi in prenašamo znanje na mlajše generacije;', 'oblikujemo lokalne dediščinske skupnosti ali se jim pridružimo ter prostovoljno sodelujemo pri dejavnostih, katerih cilja sta ohranjanje in promocija alpske prehranske dediščine;', 'spodbujamo lokalne ustanove in oblasti, naj podprejo varovanje alpske prehranske dediščine.']
          }, {
            title: 'Kot turisti v Alpah lahko:',
            lis: ['spoštujemo naravno okolje in tako prispevamo k ohranitvi biotske raznovrstnosti in kakovosti podeželskih krajin;', 'prosimo alpske restavracije, naj nam postrežejo lokalno pridelano tradicionalno hrano;', 'se udeležujemo alpskih festivalov hrane in drugih dogodkov ter tako podpiramo lokalne skupnosti;', 'obiskujemo lokalne muzeje in tako izvemo več o alpski hrani in drugi kulturni dediščini;', 'prispevamo k promociji alpske prehranske dediščine in festivalov z obveščanjem prijateljev in skupnosti po vsem svetu o njunih značilnostih in pomenu.']
          }, {
            title: 'Kot kulturne in izobraževalne ustanove lahko:',
            lis: ['varujemo lokalno alpsko prehransko dediščino, tako da jo preučujemo, dokumentiramo, analiziramo in javno predstavljamo;', 'spodbujamo prenos alpske prehranske dediščine z organizacijo forumov in kulturnih dogodkov ter zagotavljanjem predstavitvenih prostorov;', 'izboljšamo splošno znanje o alpski hrani z izobraževanjem ljudi o lokalnih navadah in njihovih možnostih za varovanje dediščine;', 'posredujemo znanje mlajšim generacijam;', 'podpiramo alpske dediščinske skupnosti, tako da jim pomagamo prepoznati in ovrednotiti njihovo prehransko dediščino ter jih spodbujamo k aktivnemu sodelovanju v dediščinskih dejavnostih;', 'pomagamo alpskim skupnostim ohranjati podeželske krajine kot njihov življenjski prostor in osnovo lokalne identitete;', 'sodelujemo s sorodnimi ustanovami na svojem območju ali v državi in zunaj nje v skupnih akcijah, ki zadevajo alpsko prehransko dediščino;', 'prepričujemo oblasti, da je treba varovati alpsko prehransko dediščino in podpirati dediščinske skupnosti.']
          }, {
            title: 'Kot znanstvene ustanove lahko:',
            lis: ['raziskujemo alpsko prehransko dediščino, zlasti njene učinke na zdravje ljudi, kulturno identiteto in način življenja, biotsko raznovrstnost, ohranjanje krajine in vzdržni razvoj;', 'preučujemo povezave med podeželskimi in mestnimi alpskimi območji, da bi razumeli ruralno-urbano dinamiko pridelave in porabe hrane;', 'sodelujemo s kulturnimi, izobraževalnimi in turističnimi organizacijami ter mediji, da bi zagotovili boljši prenos znanja na teren;', 'sodelujemo z različnimi znanstvenimi skupnostmi, da bi zagotovili transnacionalne večdisciplinarne uvide v pomen alpske prehranske dediščine;', 'spodbujamo države in Evropsko unijo, da financirajo večdisciplinarne raziskave, transnacionalne programe in uporabne projekte, ki podpirajo razvoj alpskih regij.']
          }, {
            title: 'Kot turistične organizacije lahko:',
            lis: ['oglašujemo tradicionalne alpske restavracije in festivale kot turistične zanimivosti;', 'oblikujemo tematske turistične pakete, osredinjene na pridelavo, predelavo, pripravo ali okušanje hrane alpskih kmetov, obrtnikov in rokodelcev, pri čemer lahko poudarjamo vez med kakovostjo pridelave hrane in kakovostjo podeželskih krajin;', 'spodbujamo nastajanje regionalnih in transnacionalnih poti oziroma cest za promocijo alpske prehrane;', 'podpiramo lokalne skupnosti, ki organizirajo dejavnosti in dogodke, povezane s prehrano.']
          }, {
            title: 'Kot mediji, novinarji in vplivneži lahko:',
            lis: ['poudarjamo enkratnost alpske prehranske dediščine;', 'opozarjamo na kmete in druge proizvajalce hrane v Alpah, njene predelovalce in trgovce na drobno;', 'sodelujemo z lokalnimi skupnostmi in kulturnimi organizacijami pri inovativni promociji njihovih dejavnosti;', 'obveščamo lokalna podjetja in oblasti o potencialih alpske prehranske dediščine za krepitev regionalne identitete, lokalnega gospodarstva in vzdržnega razvoja.']
          }, {
            title: 'Kot podjetja za predelavo hrane in trgovci na drobno lahko:',
            lis: ['kupujemo in prodajamo živila, pridelana na območju Alp, ter tako podpiramo tradicionalne kmete in druge proizvajalce hrane;', 'določamo poštene cene za izdelke alpske prehranske dediščine;', 'uporabljamo promocijske strategije, kot so pripovedovanje zgodb in izobraževanje o okusih, ter tako opozarjamo na posebne značilnosti teh izdelkov;', 'podpiramo pobude za geografsko označevanje in lokalne mreže, ki opozarjajo na alpsko prehransko dediščino;', 'spoštujemo pravice dediščinskih skupnosti ob oglaševanju izdelkov z blagovno znamko ali ob registraciji geografskih označb.']
          }, {
            title: 'Kot restavracije in kuharski mojstri lahko:',
            lis: ['kupujemo sestavine, pridelane v Alpah, ter s tem podpiramo lokalne kmete in proizvajalce hrane;', 'prispevamo k promociji alpske prehranske dediščine s ponudbo jedi, ki jih navdihuje alpsko izročilo, so narejene iz domačih sestavin in spoštujejo ritem letnih časov;', 'spoznavamo tradicionalne recepte alpskih skupnosti in priznavamo vlogo nosilcev tradicije;', 'podpiramo pobude za geografsko označevanje in lokalne mreže, ki opozarjajo na alpsko prehransko dediščino.']
          }, {
            title: 'Kot lokalne in regionalne oblasti lahko:',
            lis: ['olajšamo dostop alpskih skupnosti, združenj, ustanov in podjetij do znanja o ohranjanju, prenosu in promociji prehranske dediščine;', 'sprejmemo ustrezne ukrepe za varovanje alpske prehranske dediščine na svojem območju ter podpiramo lokalne kmete, male proizvajalce in dediščinske skupnosti v njihovih prizadevanjih za njeno ohranjanje in promocijo;', 'dejavno podpiramo mrežo akterjev, ki si prizadevajo za vpis alpske prehranske dediščine na Unescov Reprezentativni seznam nesnovne kulturne dediščine človeštva, in jih povezujemo z državnimi oblastmi.']
          }, {
            title: 'Kot državni organi lahko:',
            lis: ['sodelujemo z lokalnimi in regionalnimi oblastmi v Alpah pri varovanju alpske prehranske dediščine in ustvarjanju vzdržnih načinov za njeno uporabo v lokalnem gospodarstvu;', 'sprejmemo ukrepe, ki podpirajo vzdržen razvoj alpskih območij v naši državi;', 'sodelujemo z organi drugih držav za priznanje alpske prehranske dediščine kot skupne dediščine, ki je vredna varovanja in ima osrednji pomen za vzdržni razvoj Alp;', 'podpremo nominacijo alpske prehranske dediščine za vpis na Unescov Reprezentativni seznam nesnovne kulturne dediščine človeštva ter poskrbimo za transnacionalno promocijo prizadevanj alpskih skupnosti.']
          }]
        }
      },
      chapter6: {
        title: '',
        text: {
          p1: 'Mi, ljudje, ki nam je mar za prihodnost Alp, verjamemo, da je varovanje alpske prehranske dediščine nujno za ohranjanje identitete, življenjskega sloga, krajine, biotske raznovrstnosti in vzdržnega razvoja Alp. Ko prevzamemo soodgovornost, jo lahko učinkoviteje varujemo.',
          p2: ''
        }
      }
    },
    contest: 'Contest',
    regulations: 'Preberite celoten predpis',
    winners: 'Zmagovalci',
    contestOpening: 'Fotografski natečaj se bo začel 23/4/2019',
    contestEnding: 'Fotografski natečaj se bo končal 16/6/2019',
    contestClosing: 'Fotografsko tekmovanje se je končalo 16/06/2019',
    winnersList: undefined,
    regulationsItems: [{
      title: 'NATEČAJ FOTOGRAFSKIH ZGODB: "ZGODBE ALPSKE PREHRANSKE DEDIŠČINE"',
      content: 'AlpFoodway, projekt programa Interreg Alpine Space, organizira natečaj fotografskih zgodb "Zgodbe alpske prehranske dediščine" skladno s pogoji, ki so navedeni v tem pravilniku.'
    }, {
      title: 'TEMA',
      content: 'Z natečajem želimo pridobiti fotografije, ki prikazujejo zgodbe alpske prehranske dediščine. Cilj pobude je dodatno podpreti varovanje prehranske dediščine v Alpah in njeno nominacijo za vpis na Unescov Reprezentativni seznam nesnovne kulturne dediščine človeštva.\n' + '        Vsa predložena dela naj prikazujejo zgodbe o alpski prehranski dediščini. V središču so lahko pridelovalne prakse, postopki predelave in konzerviranja hrane, šege ob uživanju hrane, znanja in veščine ter pokrajina, kjer ta dediščina živi.\n' + '          Ta kulturna dediščina temelji na “gorskem življenjskem slogu” alpskih skupnosti, izmenjavi hrane in storitev, upravljanju skupnih dobrin ter prenosu praks in znanj med generacijami.'
    }, {
      title: 'POGOJI IN PRAVILA',
      content: 'Od 13/5/2019 do 16/6/2019 lahko svoje vizualne zgodbe objavljate pod svojim javnim profilom na Instagramu.<br/><br/>Za sodelovanje v natečaju je treba upoštevati naslednja pravila:' + '<ul style="padding-left: 10%; padding-top: 2%">' + '<li>Objava mora biti sestavljena le iz 3 fotografij visoke kakovostni;</li>' + '<li>V objavi morate uporabiti ključnik (hešteg) #AlpFoodwayContest in označiti stran projekta @AlpFoodway_project;</li>' + '<li>Objava mora biti geografsko umeščena;</li>' + '<li>V opisu objave je treba navesti samo kraj in datum treh posnetih fotografij, drugega besedila ne smete dodajati.</li>' + '<li>Dodajate lahko še druge ključnike (heštege), ki so neposredno povezani s fotografijami, vendar ne več kot 10;</li>' + '<li>Da bodo imeli člani žirije dostop do objave, je nujno, da je vaš profil dostopen javnosti (ni označen kot zaseben).</li>' + '</ul>' + '<p style="color: #c41c21; text-align: center;"><b>Vse objave bodo vidne tudi na zavihku “Natečaj” na spletni strani projekta AlpFoodway <a href="https://www.alpfoodway.eu" target="_blank">www.alpfoodway.eu</a>.</p>'
    }, {
      title: 'UPRAVIČENOST',
      content: 'Udeleženci ne smejo biti mlajši od 18 let. Partnerji projekta AlpFoodway ne morejo sodelovati na natečaju.'
    }, {
      title: 'Declarations and guarantees',
      content: 'Participation to this Contest implies the unconditional acceptance of all regulations related.<br/><br/>' + 'Contents should be coherent with this Contest’s theme. With this reference, at the incontestable discretion of AlpFoodway partners, posts will be deleted if considered not proper or not respecting any right including, among others, infringement of copyright, registered trademarks, publicity right, intellectual property right of third parts and privacy right. Pictures should not contain information considered confidential, inappropriate, indecent, harmful,  defamatory, illegal or against the law.' + '<br/><br/>Each participant will have civil and penal responsibility for his/her pictures; Polo Poschiavo, lead partner of the AlpFoodway project and promoter of the Contest, will have no responsibility in any circumstance, neither in relation to people shown in pictures. Competitors should always inform all people shot in pictures and obtain their consent to distribution otherwise their posts will automatically be excluded by the Contest. The Contest’s organization will never be responsible for any eventual request of compensation raised by people shot in pictures used for participation to this Contest, neither by right owners that weren’t requested to release a signed consent form.' + '<br/><br/>In case of legal litigation, the authorized owner of the social media account used for the  registration for the Contest will be considered the participant and should adapt to the present regulations. \n' + 'The "authorized account’s title holder" is the physical person assigned to the social media account or to the email address created by an Internet provider, by an online service provider or by any other responsible organization for e-mail addresses’ assignment for the domain associated to the e-mail address related to this Contest’s participation. Each participant could be requested to demonstrate of being an authorized account’s title holder.'
    }, {
      title: 'Property rights and pictures availability',
      content: 'When participants decide to post their pictures with the hashtag #AlpFoodwayContest related to participation to this Contest, they automatically authorize their usage, publication and dissemination (by any technological mean, in any format and by any channel) by AlpFoodway project partners only for the aims related to AlpFoodway project’s and contest’s promotion, with no obligation of a previous authorization’s request.'
    }, {
      title: 'NAGRADE',
      content: 'Nagrada za najboljše natečajne zgodbe ni denarna. Nagrada kot priznanje osebnega dosežka treh najboljših udeležencev bo:' + '<ul>' + '<li>Samo najboljši udeleženec se bo brezplačno udeležil medijskega izleta »Alpfoodway« z mednarodno priznanimi novinarji in fotografi. Izlet se bo začel 3. julija 2019 v Le Chatelardu (Savoja, Francija) in se končal 9. julija 2019 v Edolu (dolina Camonica, Italija). Vmesni postanki bodo: dolina Aosta (Italija) ter kantona Valais in Graubünden (Švica).' + '<li>Objava najboljših fotografij na spletni strani AlpFoodway in družbenih omrežjih;</li>' + '</ul>' + 'Vsa nagrajena dela so lahko vključena tudi v dosje kandidature za nominacijo alpske prehranske dediščine za Unescov Reprezentativni seznam nesnovne kulturne dediščine človeštva.'
    }, {
      title: 'KOMISIJA IN RAZGLASITEV ZMAGOVALCEV ',
      content: 'Vsa dela bo ocenila strokovna komisija, ki bo sestavljena iz izbranih članov partnerskih organizacij projekta AlpFoodway. Komisija bo ocenila vsa dela in po lastni presoji izbrala tri najboljša na podlagi naslednjih elementov:' + '<ul>' + '<li> 50 % ocene: skladnost s predlagano temo;</li>' + '<li>25 %: izvirnost in ustvarjalnost;</li>' + '<li>25 %: število všečkov na Instagramu.</li>' + '</ul>' + 'Prosimo, upoštevajte dejstvo, da bodo ocenjeni samo udeleženci, katerih tri predložene fotografije bodo skupaj dosegle najmanj 100 všečkov. Komisija bo ocenjevala objave prvih 100 udeležencev, ki bodo dosegli minimalno 100 všečkov, po kronološkem vrstnem redu objav. <br/><br/>' + 'Zmagovalca in zaslužne avtorje bo organizator o rezultatih natečaja obvestil do 24. junija 2019.<br/><br/>' + 'Udeleženci bodo po potrebi naprošeni, naj pošljejo vse obrazce za soglasje/avtorizacijo, s katerimi ljudje na fotografijah privolijo v objavo.<br/><br/>' + 'Seznam zmagovalcev bo na voljo na <a href="https://www.alpfoodway.eu" target="_blank">www.alpfoodway.eu</a>' + '<br/><br/>' + '<h6 style="color: #c41c21;">Koristne povezave:</h6>' + '<ul>' + '<li><a href="https://www.alpine-space.eu/projects/alpfoodway/en/home" target="_blank">www.alpine-space.eu/projects/alpfoodway/en/home</a></li>' + '<li><a href="https://www.alpfoodway.eu" target="_blank">www.alpfoodway.eu</a></li>' + '<li><a href="https://www.intagiblesearch.eu">www.intagiblesearch.eu</a></li>' + '</ul>'
    }],
    youtubeGallery: 'Video',
    inventoryMap: 'Zemljevid inventarja',
    becomeSupporter: 'Postani podpornik',
    gallery: 'ICH Vrednote'
  }
});

/***/ }),

/***/ "E/lr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-signForm"},[_c('div',{staticClass:"title-container"},[_c('h1',[_vm._v(_vm._s(_vm.activeLanguage.insertYourData))])]),_vm._v(" "),_c('b-container',{class:[{'shrink-form': _vm.$store.getters.isMobileValue}, 'signatureForm'],attrs:{"fluid":""}},[_c('b-row',{key:"textName",staticClass:"my-3"},[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-input',{attrs:{"type":"text","state":_vm.isValidName,"placeholder":_vm.activeLanguage.insertName},model:{value:(_vm.petitionName),callback:function ($$v) {_vm.petitionName=$$v},expression:"petitionName"}})],1)],1),_vm._v(" "),_c('b-row',{key:"textSurname",staticClass:"my-3"},[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-input',{attrs:{"type":"text","state":_vm.isValidSurname,"placeholder":_vm.activeLanguage.insertSurname},model:{value:(_vm.petitionSurname),callback:function ($$v) {_vm.petitionSurname=$$v},expression:"petitionSurname"}})],1)],1),_vm._v(" "),_c('b-row',{key:"textCityName",staticClass:"my-3"},[_c('b-col',{attrs:{"sm":"12"}},[_c('multiselect',{attrs:{"id":"ajax","label":"name","track-by":"name","placeholder":_vm.activeLanguage.insertCity,"open-direction":"bottom","options":_vm.matchedCities,"searchable":true,"loading":_vm.isLoading,"internal-search":false,"clear-on-select":true,"close-on-select":true,"options-limit":15,"limit":15,"max-height":200,"preserveSearch":true,"show-no-results":true,"custom-label":_vm.nameWithIcon},on:{"search-change":_vm.matchCityName},model:{value:(_vm.petitionCity),callback:function ($$v) {_vm.petitionCity=$$v},expression:"petitionCity"}},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v("Oops! No elements found.")])])],1)],1),_vm._v(" "),_c('b-row',{key:"email",staticClass:"my-3"},[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-input',{attrs:{"type":"email","state":_vm.isValidEmail,"placeholder":_vm.activeLanguage.insertEmail,"id":"emailForm"},model:{value:(_vm.petitionEmail),callback:function ($$v) {_vm.petitionEmail=$$v},expression:"petitionEmail"}}),_vm._v(" "),_c('b-tooltip',{ref:"tooltipEmail",attrs:{"target":"emailForm","disabled":_vm.isDisabledTooltip,"title":_vm.activeLanguage.alreadyUsedEmail}})],1)],1),_vm._v(" "),_c('b-row',{key:"receiveUpdates",staticClass:"my-1"},[_c('b-col',{staticClass:"checkbox-align",attrs:{"sm":"12"}},[_c('b-form-checkbox',{attrs:{"id":"registerForUpdatesCheckbox"},model:{value:(_vm.updatesAboutPetitionStatus),callback:function ($$v) {_vm.updatesAboutPetitionStatus=$$v},expression:"updatesAboutPetitionStatus"}},[_c('p',{staticClass:"checkbox-text"},[_vm._v("\n            "+_vm._s(_vm.activeLanguage.updatesAboutPetition)+"\n          ")])])],1)],1),_vm._v(" "),_c('b-row',{key:"privacyStatement",staticClass:"my-1"},[_c('b-col',{staticClass:"checkbox-align",attrs:{"sm":"12"}},[_c('b-form-checkbox',{attrs:{"id":"privacyStatementCheckbox"},model:{value:(_vm.confirmationPrivacyStatementStatus),callback:function ($$v) {_vm.confirmationPrivacyStatementStatus=$$v},expression:"confirmationPrivacyStatementStatus"}},[_c('p',{staticClass:"checkbox-text"},[_vm._v("\n            "+_vm._s(_vm.activeLanguage.confirmationPrivacyStatementPT1)),_c('a',{staticClass:"privacyStatementLink",attrs:{"target":"_blank"},on:{"click":_vm.openPrivacyPolicyModal}},[_vm._v(_vm._s(_vm.activeLanguage.confirmationPrivacyStatementPT2))])])])],1)],1),_vm._v(" "),_c('b-row',{key:"submitButton",staticClass:"my-3 button-align"},[_c('b-col',{attrs:{"sm":"12"}},[_c('b-button',{attrs:{"id":"signButton","disabled":!_vm.areInformationReady},on:{"click":_vm.submitRequest}},[_vm._v("\n          "+_vm._s(_vm.activeLanguage.signPetition)+"\n        ")])],1)],1)],1),_vm._v(" "),_c('privacy-policy-modal',{ref:"privacyPolicyModal"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E06P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E35V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E4zC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EEWV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CountdownTimer__ = __webpack_require__("fr9p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CountdownHeader__ = __webpack_require__("IfwW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CountdownFooter__ = __webpack_require__("btNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__footerComponents_MainFooter__ = __webpack_require__("eue+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CountdownPanel',
  components: { MainFooter: __WEBPACK_IMPORTED_MODULE_3__footerComponents_MainFooter__["a" /* default */], CountdownFooter: __WEBPACK_IMPORTED_MODULE_2__CountdownFooter__["a" /* default */], CountdownHeader: __WEBPACK_IMPORTED_MODULE_1__CountdownHeader__["a" /* default */], CountdownTimer: __WEBPACK_IMPORTED_MODULE_0__CountdownTimer__["a" /* default */] },
  data: function data() {
    return {
      currentBg: 0
    };
  },

  props: {
    default: {
      type: Object
    }
  },
  methods: {
    handleCurrentView: function handleCurrentView() {
      this.$store.commit('setCurrentView', this.default);
    },
    changeBackground: function changeBackground() {
      document.getElementById('f-backgroundImage').className = 'image_bg' + this.currentBg;
      this.currentBg = (this.currentBg + 1) % 6;
    }
  },
  mounted: function mounted() {
    this.handleCurrentView();
    document.getElementsByTagName('head')[0].removeChild(document.getElementById('mobile-meta-tag'));
    var meta = document.createElement('meta');
    meta.name = 'viewport';
    meta.content = 'width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=0';
    meta.id = 'mobile-meta-tag-counter';
    document.getElementsByTagName('head')[0].appendChild(meta);
    // this.changeBackground()
    // let self = this
    // setInterval(function () {
    //   self.changeBackground()
    // }, 5000)
  },
  updated: function updated() {
    this.handleCurrentView();
  }
});

/***/ }),

/***/ "ES+L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ES82":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-privacyPolicyModal"},[_c('b-modal',{ref:"privacyPolicyModal",attrs:{"id":"privacyPolicyModal","centered":"","no-footer":"","size":"lg","title":"Privacy Policy AlpFoodway"}},[_vm._l((_vm.activeLanguage.privacyPolicy),function(sect,index){return [_c('h3',{key:index},[_vm._v(_vm._s(sect.title))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(sect.content)}})]}),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-button',{staticClass:"button-style float-right",on:{"click":_vm.hideModal}},[_vm._v(_vm._s(_vm.activeLanguage.close))])],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ETHD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-becomeSupporterModal"},[_c('b-modal',{ref:"becomeSupporterModal",attrs:{"id":"becomeSupporterModal","centered":"","size":"lg","title":_vm.activeLanguage.becomeSupporter}},[_c('p',{staticClass:"my-4 citation",attrs:{"id":"captionText"}},[_vm._v("\n      Contenuto\n    ")]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-button',{staticClass:"button-style-grey float-right",staticStyle:{"margin-left":"2%"},on:{"click":_vm.hideModal}},[_vm._v(_vm._s(_vm.activeLanguage.close)+"\n      ")]),_vm._v(" "),_c('b-button',{staticClass:"button-style float-right"},[_vm._v("Download")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EhIp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegulationsModal_vue__ = __webpack_require__("OPLx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_758e68ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegulationsModal_vue__ = __webpack_require__("gAhX");
function injectStyle (ssrContext) {
  __webpack_require__("3j9A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-758e68ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegulationsModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_758e68ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegulationsModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "F0Pn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LanguageHeader_vue__ = __webpack_require__("GVj/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_241f9580_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LanguageHeader_vue__ = __webpack_require__("tdpW");
function injectStyle (ssrContext) {
  __webpack_require__("rOPM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-241f9580"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LanguageHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_241f9580_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LanguageHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FB88":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-creditsModal"},[_c('b-modal',{ref:"creditsModal",attrs:{"id":"creditsModal","title":"Match Strategies Development Group for the #AlpFoodway Engagement Platform","size":"lg","hide-footer":""}},[_c('b-row',_vm._l((_vm.people),function(person,idx){return _c('b-col',{key:idx,staticClass:"personal-card"},[_c('b-img',{staticClass:"m-1",attrs:{"rounded":"circle","width":"90","height":"90","blank-color":"#777","alt":person.surname,"src":person.picture}}),_vm._v(" "),_c('div',[_c('span',{staticClass:"name-style"},[_vm._v(_vm._s(person.name))]),_vm._v(" "),_c('span',{staticClass:"surname-style"},[_vm._v(_vm._s(person.surname))])]),_vm._v(" "),_c('p',{staticClass:"title-style"},[_vm._v(_vm._s(person.title))]),_vm._v(" "),_c('b-row',{staticClass:"framed"},[_c('b-col',{staticClass:"button-style"},[_c('a',{attrs:{"href":person.linkedinProfile,"target":"_blank"}},[_c('div',{staticClass:"icon linkedin-icon mr-2"})])]),_vm._v(" "),_c('b-col',{staticClass:"button-style"},[_c('a',{attrs:{"href":person.emailContact}},[_c('div',{staticClass:"icon email-icon mr-2"})])])],1)],1)})),_vm._v(" "),_c('p',{staticClass:"adv-style"},[_vm._v("Visit our website:")]),_vm._v(" "),_c('div',[_c('a',{attrs:{"href":"http://www.matchstrategies.com"}},[_c('img',{staticClass:"logo-match",attrs:{"src":__webpack_require__("sOzK"),"alt":"Match Strategies"}})])]),_vm._v(" "),_c('a',{staticClass:"site-style",attrs:{"href":"http://www.matchstrategies.com"}},[_vm._v("www.matchstrategies.com")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FNo+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SocialsModal',
  computed: {
    activeLanguage: function activeLanguage() {
      return this.$translations[this.$store.getters.currentLanguageValue];
    }
  },
  methods: {
    showModal: function showModal() {
      this.$refs.SocialsModal.show();
    },
    hideModal: function hideModal() {
      this.$refs.SocialsModal.hide();
    }
  },
  mounted: function mounted() {
    document.getElementById('SocialsModal___BV_modal_header_').setAttribute('style', 'background-color: #c41c21 !important; color: white !important;');
    document.getElementById('SocialsModal___BV_modal_header_').lastChild.setAttribute('style', 'color: white !important;');
  }
});

/***/ }),

/***/ "GQI/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zrc-sazu.3ee27da.jpg";

/***/ }),

/***/ "GVj/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pagesComponents_socialsPageComponents_SocialWallPage__ = __webpack_require__("cxkx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SocialsModal__ = __webpack_require__("PCea");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LanguageHeader',
  components: { SocialsModal: __WEBPACK_IMPORTED_MODULE_1__SocialsModal__["a" /* default */] },
  data: function data() {
    return {
      isSmallWindow: false
    };
  },

  computed: {
    isItalianActive: function isItalianActive() {
      return this.$store.getters.currentLanguageValue === 'Italian';
    },
    isEnglishActive: function isEnglishActive() {
      return this.$store.getters.currentLanguageValue === 'English';
    },
    isGermanActive: function isGermanActive() {
      return this.$store.getters.currentLanguageValue === 'German';
    },
    isFrenchActive: function isFrenchActive() {
      return this.$store.getters.currentLanguageValue === 'French';
    },
    isSlovenianActive: function isSlovenianActive() {
      return this.$store.getters.currentLanguageValue === 'Slovenian';
    },
    activeLanguage: function activeLanguage() {
      return this.$translations[this.$store.getters.currentLanguageValue];
    },
    rightLengthItalianLanguage: function rightLengthItalianLanguage() {
      return this.getRightLengthLanguageName(this.activeLanguage.italianLanguage);
    },
    rightLengthEnglishLanguage: function rightLengthEnglishLanguage() {
      return this.getRightLengthLanguageName(this.activeLanguage.englishLanguage);
    },
    rightLengthGermanLanguage: function rightLengthGermanLanguage() {
      return this.getRightLengthLanguageName(this.activeLanguage.germanLanguage);
    },
    rightLengthFrenchLanguage: function rightLengthFrenchLanguage() {
      return this.getRightLengthLanguageName(this.activeLanguage.frenchLanguage);
    },
    rightLengthSlovenianLanguage: function rightLengthSlovenianLanguage() {
      return this.getRightLengthLanguageName(this.activeLanguage.slovenianLanguage);
    }
  },
  methods: {
    getRightLengthLanguageName: function getRightLengthLanguageName(languageName) {
      if (this.isSmallWindow) {
        return languageName.substring(0, 3);
      }
      return languageName;
    },
    checkWindowSize: function checkWindowSize() {
      if (!this.isSmallWindow && window.innerWidth < 1051) {
        this.isSmallWindow = true;
      } else if (this.isSmallWindow && window.innerWidth > 1051) {
        this.isSmallWindow = false;
      }
    },
    loadSocialWall: function loadSocialWall() {
      this.$store.commit('setCurrentView', __WEBPACK_IMPORTED_MODULE_0__pagesComponents_socialsPageComponents_SocialWallPage__["a" /* default */]);
      this.$router.push('/social-wall');
    },
    disappearBar: function disappearBar() {
      var header = document.getElementById('languageHeader');
      var sticky = header.offsetTop;
      if (window.pageYOffset > sticky) {
        header.classList.add('disappear');
      } else {
        header.classList.remove('disappear');
      }
    },
    loadSocialsModal: function loadSocialsModal() {
      this.$refs.SocialsModalExt.showModal();
    }
  },
  created: function created() {
    var self = this;
    this.checkWindowSize();
    window.addEventListener('resize', function () {
      self.checkWindowSize();
    });
  }
});

/***/ }),

/***/ "Gqxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GalleryPage'
});

/***/ }),

/***/ "GwGh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-newsPage"},[_c('div',{staticClass:"title-container"},[_c('h1',[_vm._v(_vm._s(_vm.activeLanguage.news))])]),_vm._v(" "),_c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.fetchNewsOnLoadMore),expression:"fetchNewsOnLoadMore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},[_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[(_vm.isLoadingContent)?_c('div',{key:"1"},[_c('p',{staticClass:"loading-subtitle"},[_vm._v(_vm._s(_vm.activeLanguage.contentLoading))]),_vm._v(" "),_c('grid-loader',{staticStyle:{"width":"100%"},attrs:{"loading":_vm.isLoadingContent,"color":"#c41c21","size":"40px"}})],1):(_vm.isEmptyContent)?_c('div',{key:"2"},[_c('p',{staticClass:"loading-subtitle"},[_vm._v(_vm._s(_vm.activeLanguage.contentEmpty))]),_vm._v(" "),_c('div',{staticClass:"empty-box"})]):_c('div',{key:"3",staticClass:"post-container"},[_c('div',{directives:[{name:"masonry",rawName:"v-masonry"}],class:_vm.getContainerClass,attrs:{"transition-duration":"0.3s","item-selector":".item","fit-width":true}},_vm._l((_vm.posts),function(post,index){return _c('div',{directives:[{name:"masonry-tile",rawName:"v-masonry-tile"}],key:index,staticClass:"item",class:[{'card-mobile': _vm.$store.getters.isMobileValue}]},[_c('news-article-card',{attrs:{"post-content":post}})],1)}))])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GzlF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomePage_vue__ = __webpack_require__("iHBW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52b28254_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomePage_vue__ = __webpack_require__("nFoH");
function injectStyle (ssrContext) {
  __webpack_require__("TogM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52b28254_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HBbu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alpfoodway_background16_resized.a9401b7.jpg";

/***/ }),

/***/ "HLWc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageContentPlaceholder_vue__ = __webpack_require__("6NYf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_162788ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageContentPlaceholder_vue__ = __webpack_require__("OQ21");
function injectStyle (ssrContext) {
  __webpack_require__("gFQ6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-162788ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageContentPlaceholder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_162788ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageContentPlaceholder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HPm8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignPetitionPage_vue__ = __webpack_require__("0EMm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b251290_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignPetitionPage_vue__ = __webpack_require__("8Wzx");
function injectStyle (ssrContext) {
  __webpack_require__("qci1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b251290"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignPetitionPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b251290_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignPetitionPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HSNJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CreditsModal',
  data: function data() {
    return {
      people: [{
        name: 'Calogero',
        surname: 'Amato',
        picture: 'data:image/jpeg;base64,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',
        title: 'Financial Strategist',
        linkedinProfile: 'https://www.linkedin.com/in/calogero-amato-341172120/',
        emailContact: 'mailto:calogero@matchstrategies.com'
      }, {
        name: 'Andrea',
        surname: 'Vicari',
        picture: 'https://i.ibb.co/Rb4MjX5/0.jpg',
        title: 'Software Developer',
        linkedinProfile: 'https://www.linkedin.com/in/andrea-vicari/',
        emailContact: 'mailto:andrea.vicari@matchstrategies.com'
      }, {
        name: 'Leonardo',
        surname: 'Iandiorio',
        title: 'Software Developer',
        picture: 'https://i.ibb.co/qgXVjGF/0-1.jpg',
        linkedinProfile: 'https://www.linkedin.com/in/leonardo-iandiorio/',
        emailContact: 'mailto:leonardo.iandiorio@matchstrategies.com'
      }]
    };
  },

  methods: {
    showModal: function showModal() {
      this.$refs.creditsModal.show();
    },
    hideModal: function hideModal() {
      this.$refs.creditsModal.hide();
    }
  },
  mounted: function mounted() {
    document.getElementById('creditsModal___BV_modal_header_').setAttribute('style', 'background-color: #c41c21 !important; color: white !important;');
    document.getElementById('creditsModal___BV_modal_header_').lastChild.setAttribute('style', 'color: white !important;');
  }
});

/***/ }),

/***/ "I8FQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-imagesCarousel"},[_c('h2',{staticClass:"title-container clickable",on:{"click":_vm.loadSignPetition}},[_vm._v("#AlpFoodwayUNESCO")]),_vm._v(" "),_c('b-carousel',{staticStyle:{"text-shadow":"1px 1px 2px #333"},attrs:{"id":"carousel1","controls":"","indicators":"","background":"#ababab","interval":4000,"img-width":"2048","img-height":"1040"},on:{"sliding-start":_vm.onSlideStart,"sliding-end":_vm.onSlideEnd}},[_vm._l((_vm.carouselImages),function(item,index){return [_c('b-carousel-slide',{key:index,attrs:{"img-src":_vm.imagePath(item),"img-alt":_vm.carouselImages[index]}},[_c('div',{class:[{'imageContent-mobile' : _vm.$store.getters.isMobileValue},'imageContent']},[_c('transition',{attrs:{"name":"slide-fade-right"}},[(_vm.hasTransitionEnded)?_c('div',{staticClass:"title"},[_c('a',{on:{"click":_vm.loadAboutUSModal}},[_c('p',[_vm._v("\n                "+_vm._s(_vm.generateCaption(index)))])])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade-left"}},[(_vm.hasTransitionEnded)?_c('div',{staticClass:"subtitle"},[_c('a',{on:{"click":_vm.loadAboutUSModal}},[_c('p',[_vm._v("\n                "+_vm._s(_vm.generateText(index)))])])]):_vm._e()])],1)])]})],2),_vm._v(" "),_c('about-us-modal',{ref:"aboutUsModalExt"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ID3B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__signPetitionPageComponents_SignPetitionPage__ = __webpack_require__("HPm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShareCampaignModal__ = __webpack_require__("BYKs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReadCartaModal__ = __webpack_require__("ORre");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_accordion__ = __webpack_require__("hqwk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_accordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_accordion__);
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_3_vue__["default"].component('vue-accordion', __WEBPACK_IMPORTED_MODULE_4_vue_accordion__["vueAccordion"]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CartaHeaderAccordion',
  components: { ReadCartaModal: __WEBPACK_IMPORTED_MODULE_2__ReadCartaModal__["a" /* default */], ShareCampaignModal: __WEBPACK_IMPORTED_MODULE_1__ShareCampaignModal__["a" /* default */] },
  data: function data() {
    return {
      items: null,
      styles: {
        // this will be bound to the style attribute of all `div`s inside the accordion
        div: {
          height: '300px'
        },
        // this will be bound to the style attribute of all `ul`s inside the accordion
        ul: {},
        // this will be bound to the style attribute of all `li`s inside the accordion
        li: {
          cursor: 'pointer',
          backgroundSize: 'cover'
        },
        // this will be bound to the style attribute of all `a`s inside the accordion
        a: {},
        // this will be bound to the style attribute of all `h2`s inside the accordion
        h2: {
          marginTop: '100px',
          opacity: 1,
          fontWeight: 'bold',
          fontSize: '2em',
          marginBottom: '0',
          paddingBottom: '1%',
          color: 'white'
        },
        // this will be bound to the style attribute of all `p`s inside the accordion
        p: {
          opacity: 1,
          fontSize: '1.4em',
          paddingBottom: '2%',
          fontWeight: 'bold',
          color: 'white'
        }
      }
    };
  },

  computed: {
    activeLanguage: function activeLanguage() {
      return this.$translations[this.$store.getters.currentLanguageValue];
    }
  },
  methods: {
    loadSignPetition: function loadSignPetition() {
      this.$store.commit('setCurrentView', __WEBPACK_IMPORTED_MODULE_0__signPetitionPageComponents_SignPetitionPage__["a" /* default */]);
      this.$router.push('/sign-petition');
    },
    loadShareCampaignModal: function loadShareCampaignModal() {
      this.$refs.shareCampaignModalExt.showModal();
    },
    loadReadCartaModal: function loadReadCartaModal() {
      this.$refs.readCartaModalExt.showModal();
    }
  },
  mounted: function mounted() {
    this.items = [{
      title: this.activeLanguage.read,
      text: this.activeLanguage.theCarta,
      url: '#',
      image: '../../../static/carta/read.jpg'
    }, {
      title: this.activeLanguage.sign,
      text: this.activeLanguage.thePetition,
      url: '#',
      image: '../../../static/carta/sign.jpg'
    }, {
      title: this.activeLanguage.share,
      text: this.activeLanguage.ourCampaign,
      url: '#',
      image: '../../../static/carta/share.jpg'
    }];
    var self = this;
    setTimeout(function () {
      var accordion = document.getElementsByClassName('vue-accordion')[0].getElementsByTagName('LI');
      accordion[0].getElementsByTagName('A')[0].removeAttribute('href');
      accordion[0].onclick = function () {
        self.loadReadCartaModal();
      };

      accordion[1].getElementsByTagName('A')[0].removeAttribute('href');
      accordion[1].onclick = function () {
        self.loadSignPetition();
      };

      accordion[2].getElementsByTagName('A')[0].removeAttribute('href');
      accordion[2].onclick = function () {
        self.loadShareCampaignModal();
      };
    }, 500);
  }
});

/***/ }),

/***/ "IHfH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/crepa.3c53986.jpg";

/***/ }),

/***/ "IJJN":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./NRP.jpg": "OKCu",
	"./bauges-park.jpg": "BCYe",
	"./brel.jpg": "jO9f",
	"./camonica-valley.jpg": "MOls",
	"./crepa.jpg": "IHfH",
	"./dislivelli-association.jpg": "SXGt",
	"./europe-logo.jpg": "7qbX",
	"./european-year.jpg": "6DkJ",
	"./european-year.png": "n//d",
	"./kedge-business-school.jpg": "6LGH",
	"./lombardy-region.jpg": "mw6x",
	"./munich-university-of-applied-sciences.jpg": "6A06",
	"./polo-poschiavo.jpg": "D3Vz",
	"./ragor.jpg": "djDa",
	"./rda.jpg": "k+oK",
	"./tsm.jpg": "YcFV",
	"./uibk.jpg": "7xEH",
	"./zrc-sazu.jpg": "y2RP"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "IJJN";

/***/ }),

/***/ "IfwW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountdownHeader_vue__ = __webpack_require__("kwnq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de6d3e1a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountdownHeader_vue__ = __webpack_require__("hgar");
function injectStyle (ssrContext) {
  __webpack_require__("8XxR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-de6d3e1a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountdownHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de6d3e1a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountdownHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J1JE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JGBB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-supportersPage"},[_c('div',{staticClass:"title-container"},[_c('h1',[_vm._v("#AlpFoodwayUNESCO "),_c('br'),_vm._v(_vm._s(_vm.activeLanguage.supportersPosition))])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":_vm.getMapClass}}),_vm._v(" "),_c('div',{staticClass:"title-container"},[_c('h1',[_vm._v("#AlpFoodway "+_vm._s(_vm.activeLanguage.mainSupporters))])]),_vm._v(" "),_c('main-supporters'),_vm._v(" "),_c('div',{staticClass:"title-container"},[_c('h1',[_vm._v(_vm._s(_vm.activeLanguage.otherSupporters))])]),_vm._v(" "),_c('other-supporters')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"progress"}},[_c('div',{attrs:{"id":"progress-bar"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JRwx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JyuJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-headers",attrs:{"id":"headersWrapper"}},[_c('language-header',{ref:"languageHeader"}),_vm._v(" "),_c('main-header',{ref:"mainHeader"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Klpr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyModal__ = __webpack_require__("wqwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SignForm',
  components: { PrivacyPolicyModal: __WEBPACK_IMPORTED_MODULE_1__PrivacyPolicyModal__["a" /* default */] },
  data: function data() {
    return {
      petitionName: '',
      petitionSurname: '',
      petitionCityName: '',
      petitionEmail: '',
      updatesAboutPetitionStatus: false,
      confirmationPrivacyStatementStatus: false,
      matchedCities: [],
      latitudeSelectedCity: '',
      longitudeSelectedCity: '',
      isCitySelected: null,
      emailAlreadyUsed: '',
      petitionCity: null,
      isLoading: false,
      previousRequest: null,
      currentLanguageCode: null,
      userNameList: ['andrea.vicari', 'leonardo.iandiorio', 'demo', 'andrea.vicari.backup'],
      userIdx: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['currentLanguageValue']), {
    activeLanguage: function activeLanguage() {
      return this.$translations[this.$store.getters.currentLanguageValue];
    },
    validNameRegex: function validNameRegex() {
      return (/^[^±!@£$%^&*_+§¡€#¢§¶•ªº«\\/<>?:;|=.,]{1,20}$/
      );
    },
    containNumber: function containNumber() {
      return (/\d/
      );
    },
    isValidName: function isValidName() {
      if (this.petitionName === '') {
        return null;
      }
      var re = this.validNameRegex;
      var reN = this.containNumber;
      if (re.test(this.petitionName) && !reN.test(this.petitionName)) {
        this.petitionName = this.toTitleCase(this.petitionName);
        return true;
      }
      return false;
    },
    isValidSurname: function isValidSurname() {
      if (this.petitionSurname === '') {
        return null;
      }
      var re = this.validNameRegex;
      var reN = this.containNumber;
      if (re.test(this.petitionSurname) && !reN.test(this.petitionSurname)) {
        this.petitionSurname = this.toTitleCase(this.petitionSurname);
        return true;
      }
      return false;
    },
    isValidEmail: function isValidEmail() {
      if (this.petitionEmail === '') {
        return null;
      }
      if (this.emailAlreadyUsed !== '' && this.petitionEmail !== this.emailAlreadyUsed) {
        this.$refs.tooltipEmail.$emit('close');
      }
      if (this.emailAlreadyUsed !== '' && this.petitionEmail === this.emailAlreadyUsed) {
        this.$refs.tooltipEmail.$emit('open');
      }
      var re = /^(([^<>()[\]\\.,;:\s@]+(\.[^<>()[\]\\.,;:\s@]+)*)|(.+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(this.petitionEmail) && this.petitionEmail !== this.emailAlreadyUsed;
    },
    areInformationReady: function areInformationReady() {
      return !!(this.isValidName && this.isValidSurname && this.isValidEmail && this.confirmationPrivacyStatementStatus && this.isCitySelected);
    },
    areSuggestionsPresent: function areSuggestionsPresent() {
      return this.matchedCities.length > 0;
    },
    isDisabledTooltip: function isDisabledTooltip() {
      if (this.petitionEmail === '') {
        return true;
      }
      return this.petitionEmail !== this.emailAlreadyUsed;
    }
  }),
  methods: {
    nameWithIcon: function nameWithIcon(_ref) {
      var name = _ref.name;

      return '\uD83D\uDCCD ' + name;
    },
    openPrivacyPolicyModal: function openPrivacyPolicyModal() {
      this.$refs.privacyPolicyModal.showModal();
    },
    toTitleCase: function toTitleCase(str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    isExistingName: function isExistingName(alternateNames, mainName, name) {
      var isPresent = false;
      var matchName = '';
      if (alternateNames) {
        alternateNames.forEach(function (altName) {
          var nameToCheck = altName.name.toLowerCase().replace(/’/g, ' ').replace(/'/g, ' ').replace(/-/g, ' ');
          if (nameToCheck.includes(name.replace(/’/g, ' ').replace(/'/g, ' ').replace(/-/g, ' '))) {
            isPresent = true;
            matchName = altName.name;
          }
        });
      }
      if (mainName && mainName.toLowerCase().replace(/’/g, ' ').replace(/'/g, ' ').replace(/-/g, ' ').includes(name.replace('\'', ' '))) {
        isPresent = true;
        matchName = mainName;
      }
      return [isPresent, matchName];
    },
    alreadyPresent: function alreadyPresent(cityName) {
      var isPresent = false;
      this.matchedCities.forEach(function (city) {
        if (city.name === cityName) {
          isPresent = true;
        }
      });
      return isPresent;
    },
    matchCityNameGeonames: function matchCityNameGeonames(formText) {
      var _this = this;

      if (formText.length > 0) {
        this.isLoading = true;
        var self = this;
        this.$http.get('https://secure.geonames.org/searchJSON?q=' + formText + '&maxRows=10&username=' + this.userNameList[this.userIdx] + '&style=FULL&lang=' + this.currentLanguageCode, {
          // use before callback
          before: function before(request) {
            // abort previous request, if exists
            if (self.previousRequest) {
              self.previousRequest.abort();
            }
            // set previous request on Vue instance
            self.previousRequest = request;
          }
        }).then(function (response) {
          if (response.status === 200) {
            var bodyRes = response.body.geonames;
            if (bodyRes) {
              for (var idx = 0; idx < bodyRes.length; idx++) {
                if (bodyRes[idx].fclName.includes('city, village')) {
                  var alternateNames = bodyRes[idx].alternateNames;
                  var mainName = bodyRes[idx].name;
                  var existingMatch = _this.isExistingName(alternateNames, mainName, formText.toLowerCase());
                  if (existingMatch[0]) {
                    if (!_this.alreadyPresent(bodyRes[idx].toponymName + ', ' + bodyRes[idx].adminName1 + ', ' + bodyRes[idx].countryName + ' (' + existingMatch[1] + ')')) {
                      self.matchedCities.push({
                        'name': bodyRes[idx].name + ', ' + bodyRes[idx].adminName1 + ', ' + bodyRes[idx].countryName + ' (' + existingMatch[1] + ')',
                        'latitude': bodyRes[idx].lat,
                        'longitude': bodyRes[idx].lng,
                        'img': 'geonames'
                      });
                    }
                  }
                }
                self.isLoading = false;
              }
            } else {
              _this.userIdx = (_this.userIdx + 1) % _this.userNameList.length;
              _this.matchCityNameGeonames(formText);
            }
          }
          self.isLoading = false;
        }).catch(function (err) {
          if (err.status >= 500) {
            console.log('Server-Related problem');
            self.isLoading = false;
          } else if (err.status === 400) {
            console.log('A bad request occurred');
            self.isLoading = false;
          } else if (err.status === 404) {
            console.log(err.body.message);
            self.isLoading = false;
          }
        });
      }
    },
    selectCity: function selectCity(city) {
      this.isCitySelected = true;
      this.petitionCityName = city.name;
      if (city.href) {
        this.retrieveLatLon(city.href);
      } else if (city.latitude && city.longitude) {
        this.latitudeSelectedCity = city.latitude;
        this.longitudeSelectedCity = city.longitude;
      }
      this.matchedCities = [];
    },
    matchCityName: function matchCityName(formText) {
      this.matchCityNameTeleport(formText);
    },
    matchCityNameTeleport: function matchCityNameTeleport(formText) {
      this.matchedCities = [];
      if (formText.length > 0) {
        this.isLoading = true;
        var self = this;
        this.$http.get('https://api.teleport.org/api/cities/?search=' + formText + '&limit=5', {
          // use before callback
          before: function before(request) {
            // abort previous request, if exists
            if (self.previousRequest) {
              self.previousRequest.abort();
            }
            // set previous request on Vue instance
            self.previousRequest = request;
          }
        }).then(function (response) {
          if (response.status === 200) {
            var bodyRes = response.body._embedded['city:search-results'];
            for (var idx in bodyRes) {
              var fullName = bodyRes[idx]['matching_full_name'];
              var cityLink = bodyRes[idx]['_links']['city:item']['href'];
              self.matchedCities.push({
                'name': fullName,
                'href': cityLink,
                'img': 'teleport'
              });
            }
            if (self.matchedCities.length < 5) {
              self.matchCityNameGeonames(formText);
            } else {
              self.isLoading = false;
            }
          }
        }).catch(function (err) {
          if (err.status >= 500) {
            console.log('Server-Related problem');
          } else if (err.status === 400) {
            console.log('A bad request occurred');
          } else if (err.status === 404) {
            console.log(err.body.message);
          }
        });
      }
    },
    retrieveLatLon: function retrieveLatLon(href) {
      var self = this;
      this.matchedCities = [];
      if (this.petitionCityName.length > 0) {
        this.$http.get(href).then(function (response) {
          if (response.status === 200) {
            var bodyRes = response.body.location.latlon;
            self.latitudeSelectedCity = bodyRes.latitude;
            self.longitudeSelectedCity = bodyRes.longitude;
          }
        }).catch(function (err) {
          if (err.status >= 500) {
            console.log('Server-Related problem');
          } else if (err.status === 400) {
            console.log('A bad request occurred');
          } else if (err.status === 404) {
            console.log(err.body.message);
          }
        });
      }
    },
    submitRequest: function submitRequest() {
      var _this2 = this;

      if (this.areInformationReady) {
        // let self = this
        this.$http.post(this.$PATH_NAME + 'petitions/', {
          'petitionSign': {
            'name': this.petitionName,
            'surname': this.petitionSurname,
            'email': this.petitionEmail,
            'wantsUpdates': this.updatesAboutPetitionStatus
          },
          'city': {
            'name': this.petitionCityName.replace(/ *\([^)]*\) */g, ''),
            'latitude': this.latitudeSelectedCity,
            'longitude': this.longitudeSelectedCity
          }
        }).then(function (response) {
          if (response.status === 200) {
            var petitionerName = _this2.petitionName;
            _this2.petitionSurname = '';
            _this2.petitionEmail = '';
            _this2.updatesAboutPetitionStatus = false;
            _this2.confirmationPrivacyStatementStatus = false;
            _this2.petitionName = '';
            _this2.petitionCityName = '';
            _this2.latitudeSelectedCity = '';
            _this2.longitudeSelectedCity = '';
            _this2.petitionCity = null;
            _this2.$emit('submittedSign', petitionerName);
          }
        }).catch(function (err) {
          if (err.status >= 500) {
            console.log('Server-Related problem');
          } else if (err.status === 400) {
            alert('You cannot sign more than 20 times from the same IP address');
            console.log('A bad request occurred');
          } else if (err.status === 404) {
            console.log(err.body.message);
          } else if (err.status === 409) {
            this.emailAlreadyUsed = this.petitionEmail;
            this.$refs.tooltipEmail.$emit('open');
          }
        });
      }
    },
    createStyles: function createStyles() {
      var styleInvalid = document.createElement('style');
      styleInvalid.type = 'text/css';
      styleInvalid.innerHTML = '.invalid-city-selector { border-color: #f04124 !important; }';
      document.getElementsByTagName('head')[0].appendChild(styleInvalid);
      var styleInvalidFocus = document.createElement('style');
      styleInvalidFocus.type = 'text/css';
      styleInvalidFocus.innerHTML = '.invalid-city-selector:focus-within  { box-shadow: 0 0 0 0.2rem rgba(220,53,69,.25) !important; }';
      document.getElementsByTagName('head')[0].appendChild(styleInvalidFocus);
      var styleInvalidActive = document.createElement('style');
      styleInvalidActive.type = 'text/css';
      styleInvalidActive.innerHTML = '.invalid-city-selector:active { box-shadow: 0 0 0 0.2rem rgba(220,53,69,.25) !important; }';
      document.getElementsByTagName('head')[0].appendChild(styleInvalidActive);

      var styleValid = document.createElement('style');
      styleValid.type = 'text/css';
      styleValid.innerHTML = '.valid-city-selector { border-color: #28a745; !important; }';
      document.getElementsByTagName('head')[0].appendChild(styleValid);
      var styleValidFocus = document.createElement('style');
      styleValidFocus.type = 'text/css';
      styleValidFocus.innerHTML = '.valid-city-selector:focus-within  { box-shadow: 0 0 0 0.2rem rgba(40,167,69,.25) !important; }';
      document.getElementsByTagName('head')[0].appendChild(styleValidFocus);
      var styleValidActive = document.createElement('style');
      styleValidActive.type = 'text/css';
      styleValidActive.innerHTML = '.valid-city-selector:active { box-shadow: 0 0 0 0.2rem rgba(40,167,69,.25) !important; }';
      document.getElementsByTagName('head')[0].appendChild(styleValidActive);

      var styleNeutral = document.createElement('style');
      styleNeutral.type = 'text/css';
      styleNeutral.innerHTML = '.neutral-city-selector { color: #495057; background-color: #fff; border: 1px solid #ced4da; border-radius: .25rem; transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out; }';
      document.getElementsByTagName('head')[0].appendChild(styleNeutral);
      var styleNeutralFocus = document.createElement('style');
      styleNeutralFocus.type = 'text/css';
      styleNeutralFocus.innerHTML = '.neutral-city-selector:focus-within  { border-color: #80bdff; box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25) !important; }';
      document.getElementsByTagName('head')[0].appendChild(styleNeutralFocus);
      var styleNeutralActive = document.createElement('style');
      styleNeutralActive.type = 'text/css';
      styleNeutralActive.innerHTML = '.neutral-city-selector:active { border-color: #80bdff; box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25) !important; }';
      document.getElementsByTagName('head')[0].appendChild(styleNeutralActive);

      this.neutralCitySelector();
    },
    invalidCitySelector: function invalidCitySelector() {
      document.getElementsByClassName('multiselect__tags')[0].classList.remove('neutral-city-selector');
      document.getElementsByClassName('multiselect__tags')[0].classList.remove('valid-city-selector');
      document.getElementsByClassName('multiselect__tags')[0].classList.add('invalid-city-selector');
    },
    validCitySelector: function validCitySelector() {
      document.getElementsByClassName('multiselect__tags')[0].classList.remove('neutral-city-selector');
      document.getElementsByClassName('multiselect__tags')[0].classList.remove('invalid-city-selector');
      document.getElementsByClassName('multiselect__tags')[0].classList.add('valid-city-selector');
    },
    neutralCitySelector: function neutralCitySelector() {
      document.getElementsByClassName('multiselect__tags')[0].classList.remove('valid-city-selector');
      document.getElementsByClassName('multiselect__tags')[0].classList.remove('invalid-city-selector');
      document.getElementsByClassName('multiselect__tags')[0].classList.add('neutral-city-selector');
    },
    switchToLanguage: function switchToLanguage() {
      switch (this.currentLanguageValue) {
        case 'Italian':
          this.currentLanguageCode = 'IT';
          break;
        case 'English':
          this.currentLanguageCode = 'EN';
          break;
        case 'French':
          this.currentLanguageCode = 'FR';
          break;
        case 'German':
          this.currentLanguageCode = 'DE';
          break;
        case 'Slovenian':
          this.currentLanguageCode = 'SL';
          break;
      }
    }
  },
  mounted: function mounted() {
    this.createStyles();
    this.switchToLanguage();
  },

  watch: {
    petitionCity: function petitionCity(city) {
      if (city) {
        this.selectCity(city);
      } else {
        this.isCitySelected = false;
        this.petitionCityName = '';
      }
    },
    isCitySelected: function isCitySelected(selectedValue) {
      if (selectedValue === true) {
        this.validCitySelector();
      } else if (selectedValue === false) {
        this.invalidCitySelector();
      } else if (selectedValue === null) {
        this.neutralCitySelector();
      }
    },
    currentLanguageValue: function currentLanguageValue(newVal) {
      this.switchToLanguage();
    }
  }
});

/***/ }),

/***/ "Kumg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialCard_vue__ = __webpack_require__("AcjR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65e02c72_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialCard_vue__ = __webpack_require__("inwJ");
function injectStyle (ssrContext) {
  __webpack_require__("MZqv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65e02c72"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65e02c72_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LDej":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignaturesCounter_vue__ = __webpack_require__("r7S6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d24475d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignaturesCounter_vue__ = __webpack_require__("yBR0");
function injectStyle (ssrContext) {
  __webpack_require__("PeyN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d24475d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignaturesCounter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d24475d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignaturesCounter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LPd/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/poster.2a0279e.jpg";

/***/ }),

/***/ "LZml":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lsmu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alpfoodway_background4_resized.67b458a.jpg";

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34028179_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("eQos");
function injectStyle (ssrContext) {
  __webpack_require__("jf0H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34028179_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MBgH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-supportersPage"},[_c('div',{staticClass:"title-container"},[_c('h1',[_vm._v(_vm._s(_vm.activeLanguage.inventoryMap))])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":_vm.getMapClass}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"progress"}},[_c('div',{attrs:{"id":"progress-bar"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MHDp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alpfoodway_background2_resized.a06abf0.jpg";

/***/ }),

/***/ "MOls":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/camonica-valley.5c8508a.jpg";

/***/ }),

/***/ "MYcH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/uibk.fdb9d06.jpg";

/***/ }),

/***/ "MZqv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MlWh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N/Zt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-cartaHeader"},[_c('h2',{staticClass:"title-container"},[_vm._v(_vm._s(_vm.activeLanguage.theCarta))]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"icon-wrapper"},[_c('div',{staticClass:"icon-container",on:{"click":_vm.loadReadCartaModal}},[_c('div',{staticClass:"read-icon icon"})])]),_vm._v(" "),_c('p',{staticClass:"counterStyle"},[_vm._v(_vm._s(_vm.activeLanguage.read))]),_vm._v(" "),_c('p',{staticClass:"counterSubStyle"},[_vm._v(_vm._s(_vm.activeLanguage.theCartaRound))])]),_vm._v(" "),_c('b-col',[_c('div',{staticClass:"icon-wrapper"},[_c('div',{staticClass:"icon-container",on:{"click":_vm.loadSignPetition}},[_c('div',{staticClass:"sign-petition-icon icon"})])]),_vm._v(" "),_c('p',{staticClass:"counterStyle"},[_vm._v(_vm._s(_vm.activeLanguage.sign))]),_vm._v(" "),_c('p',{staticClass:"counterSubStyle"},[_vm._v(_vm._s(_vm.activeLanguage.thePetitionRound))])]),_vm._v(" "),_c('b-col',[_c('div',{staticClass:"icon-wrapper"},[_c('div',{staticClass:"icon-container",on:{"click":_vm.loadDiscoverAlpFoodway}},[_c('div',{staticClass:"discover-icon icon"})])]),_vm._v(" "),_c('p',{staticClass:"counterStyle"},[_vm._v(_vm._s(_vm.activeLanguage.discover))]),_vm._v(" "),_c('p',{staticClass:"counterSubStyle"},[_vm._v("AlpFoodway")])]),_vm._v(" "),_c('read-carta-modal',{ref:"readCartaModalExt"}),_vm._v(" "),_c('share-campaign-modal',{ref:"shareCampaignModalExt"}),_vm._v(" "),(_vm.loadPdf)?_c('discover-alp-foodway',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadPdf),expression:"loadPdf"}],ref:"discoverAlpFoodway"}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N18m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'GridLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '15px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        width: this.size,
        height: this.size,
        margin: this.margin,
        borderRadius: this.radius
      }
    };
  },

  computed: {
    animationStyle: function animationStyle() {
      return {
        animationName: 'v-gridStretchDelay',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'ease',
        animationFillMode: 'both',
        display: 'inline-block'
      };
    },
    animationStyle1: function animationStyle1() {
      return {
        animationDelay: this.delay(),
        animationDuration: this.duration()
      };
    },
    animationStyle2: function animationStyle2() {
      return {
        animationDelay: this.delay(),
        animationDuration: this.duration()
      };
    },
    animationStyle3: function animationStyle3() {
      return {
        animationDelay: this.delay(),
        animationDuration: this.duration()
      };
    },
    animationStyle4: function animationStyle4() {
      return {
        animationDelay: this.delay(),
        animationDuration: this.duration()
      };
    },
    animationStyle5: function animationStyle5() {
      return {
        animationDelay: this.delay(),
        animationDuration: this.duration()
      };
    },
    animationStyle6: function animationStyle6() {
      return {
        animationDelay: this.delay(),
        animationDuration: this.duration()
      };
    },
    animationStyle7: function animationStyle7() {
      return {
        animationDelay: this.delay(),
        animationDuration: this.duration()
      };
    },
    animationStyle8: function animationStyle8() {
      return {
        animationDelay: this.delay(),
        animationDuration: this.duration()
      };
    },
    animationStyle9: function animationStyle9() {
      return {
        animationDelay: this.delay(),
        animationDuration: this.duration()
      };
    },
    containerStyle: function containerStyle() {
      return {
        width: parseFloat(this.size) * 3 + parseFloat(this.margin) * 6 + 'px',
        fontSize: 0
      };
    }
  },
  methods: {
    random: function random(value) {
      return Math.random() * value;
    },
    delay: function delay() {
      return this.random(100) / 100 - 0.2 + 's';
    },
    duration: function duration() {
      return this.random(100) / 100 + 0.6 + 's';
    }
  }
});

/***/ }),

/***/ "N4kB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__socialsPageComponents_SocialWallPage__ = __webpack_require__("cxkx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilComponents_SocialCard__ = __webpack_require__("Kumg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_masonry__ = __webpack_require__("w/U7");
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_masonry__["a" /* VueMasonryPlugin */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SocialWall',
  components: { SocialCard: __WEBPACK_IMPORTED_MODULE_1__utilComponents_SocialCard__["a" /* default */] },
  data: function data() {
    return {
      posts: [],
      areInformationOutdated: false,
      profilesToUpdate: [],
      isSmallWindow: false
    };
  },

  computed: {
    activeLanguage: function activeLanguage() {
      return this.$translations[this.$store.getters.currentLanguageValue];
    },
    arePostsPresent: function arePostsPresent() {
      return this.posts.length > 0;
    },
    getContainerClass: function getContainerClass() {
      return this.isSmallWindow ? 'post-container-mobile' : 'post-container';
    }
  },
  methods: {
    loadSocialWall: function loadSocialWall() {
      this.$store.commit('setCurrentView', __WEBPACK_IMPORTED_MODULE_0__socialsPageComponents_SocialWallPage__["a" /* default */]);
      this.$router.push('/social-wall');
    },
    fetchMostRecentPosts: function fetchMostRecentPosts() {
      var self = this;
      this.$http.get(this.$PATH_NAME + 'social/getHighlights/').then(function (response) {
        self.posts = response.body;
      });
    },
    handleOutDatedPost: function handleOutDatedPost(userScreenName) {
      this.areInformationOutdated = true;
      if (!this.profilesToUpdate) {
        this.profilesToUpdate = [];
      }
      if (!this.profilesToUpdate.includes(userScreenName)) {
        this.profilesToUpdate.push(userScreenName);
        console.log('Ask to update picture of ' + userScreenName);
      }
    },
    updateOutDatedPost: function updateOutDatedPost(userScreenName) {
      var self = this;
      this.$http.get(this.$PATH_NAME + '/social/updateProfileInformation/profile=' + userScreenName).then(function (response) {
        self.posts.forEach(function (post) {
          if (post.user.screenName === userScreenName) {
            post.user.profileImageUrl = response.body;
          }
        });
      }).catch(function (err) {
        this.handleError(err);
      });
    },
    checkWindowSize: function checkWindowSize() {
      if (!this.isSmallWindow && window.innerWidth < 1051) {
        this.isSmallWindow = true;
      } else if (this.isSmallWindow && window.innerWidth > 1051) {
        this.isSmallWindow = false;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.fetchMostRecentPosts();
    this.checkWindowSize();
    window.addEventListener('resize', function () {
      return _this.checkWindowSize();
    });
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__("Tqaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__("qb6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_moment__ = __webpack_require__("8AgW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_infinite_scroll__ = __webpack_require__("bqTm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_translations_translations__ = __webpack_require__("E+vS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_social_sharing__ = __webpack_require__("VK1f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_social_sharing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_social_sharing__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.














__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('multiselect', __WEBPACK_IMPORTED_MODULE_11_vue_multiselect___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_infinite_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_social_sharing___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$translations = __WEBPACK_IMPORTED_MODULE_10__assets_translations_translations__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_moment___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin({
  methods: {
    setItalianLanguage: function setItalianLanguage() {
      this.$router.push(this.getCurrentPage() + '/italian');
      this.$store.commit('setCurrentLanguage', 'Italian');
    },
    setEnglishLanguage: function setEnglishLanguage() {
      this.$router.push(this.getCurrentPage() + '/english');
      this.$store.commit('setCurrentLanguage', 'English');
    },
    setGermanLanguage: function setGermanLanguage() {
      this.$router.push(this.getCurrentPage() + '/german');
      this.$store.commit('setCurrentLanguage', 'German');
    },
    setFrenchLanguage: function setFrenchLanguage() {
      this.$router.push(this.getCurrentPage() + '/french');
      this.$store.commit('setCurrentLanguage', 'French');
    },
    setSlovenianLanguage: function setSlovenianLanguage() {
      this.$router.push(this.getCurrentPage() + '/slovenian');
      this.$store.commit('setCurrentLanguage', 'Slovenian');
    },
    getCurrentPage: function getCurrentPage() {
      switch (this.$store.getters.currentViewValue.name) {
        case 'HomePage':
          return '/home';
        case 'EventsPage':
          return '/events';
        case 'SocialWallPage':
          return '/social-wall';
        case 'ContestPage':
          return '/contest';
        case 'NewsPage':
          return '/news';
        case 'SupportersPage':
          return '/supporters';
        case 'SignPetitionPage':
          return '/sign-petition';
        case 'PaperPage':
          return '/paper';
        case 'VideosPage':
          return '/videos-gallery';
        case 'InventoryMapPage':
          return '/inventory-map';
        default:
          return '/home';
      }
    }
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$PATH_NAME = "https://api.alpfoodway.eu/" || 'https://localhost:8080/';
// Vue.prototype.$PATH_NAME = 'https://api.alpfoodway.eu/'

// console.log('Using API at ' + Vue.prototype.$PATH_NAME)

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */] }
});

/***/ }),

/***/ "O5be":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alpfoodway_background6_resized.1edc800.jpg";

/***/ }),

/***/ "OAz2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilComponents_NewsArticleCard__ = __webpack_require__("hLdN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_GridLoader_vue__ = __webpack_require__("A4IU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_masonry__ = __webpack_require__("w/U7");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_masonry__["a" /* VueMasonryPlugin */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NewsPage',
  components: { NewsArticleCard: __WEBPACK_IMPORTED_MODULE_1__utilComponents_NewsArticleCard__["a" /* default */], GridLoader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_GridLoader_vue__["a" /* default */] },
  data: function data() {
    return {
      isLoadingState: true,
      posts: [],
      newspapers: {},
      areLoadedNewsPapers: false,
      iconWrapper: 'icon-wrapper',
      isUpdatedVal: false,
      isSmallWindow: false
    };
  },

  methods: {
    changeNewspaperStatus: function changeNewspaperStatus(newspaper) {
      if (this.trueCounter() >= 1 && !this.newspapers[newspaper].active) {
        this.newspapers[newspaper].active = !this.newspapers[newspaper].active;
      } else if (this.trueCounter() > 1) {
        this.newspapers[newspaper].active = !this.newspapers[newspaper].active;
      } else {
        return;
      }

      this.isUpdatedVal = true;
      var self = this;
      setTimeout(function () {
        self.isUpdatedVal = false;
      }, 20);
      this.updateNews();
    },
    trueCounter: function trueCounter() {
      var trueCounter = 0;
      for (var key in __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.newspapers)) {
        if (this.newspapers[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.newspapers)[key]]) {
          trueCounter++;
        }
      }
      return trueCounter;
    },
    isLastOneSelected: function isLastOneSelected(item) {
      if (this.isUpdatedVal) {
        return this.isUpdatedVal && this.trueCounter() === 1 && this.newspapers[item].active;
      }
      return this.trueCounter() === 1 && this.newspapers[item].active;
    },
    isUpdatedValue: function isUpdatedValue(index) {
      if (this.isUpdatedVal) {
        return this.isUpdatedVal && this.newspapers[index].active;
      }
      return this.newspapers[index].active;
    },
    handleError: function handleError(err) {
      if (err.status >= 500) {
        console.log('Server-Related problem');
      } else if (err.status === 400) {
        console.log('A bad request occurred');
      } else if (err.status === 404) {
        console.log(err.body.message);
      }
    },
    enableLabel: function enableLabel(newspaper) {
      return 'Enable ' + newspaper;
    },
    disableLabel: function disableLabel(newspaper) {
      return 'Disable ' + newspaper;
    },
    getNewspapersString: function getNewspapersString() {
      var newspaparsString = '';
      for (var key in __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.newspapers)) {
        if (this.newspapers[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.newspapers)[key]].active) {
          newspaparsString += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.newspapers)[key] + ',';
        }
      }
      return newspaparsString.replace(/(^,)|(,$)/g, '');
    },
    updateNews: function updateNews() {
      this.isLoadingState = true;
      this.posts = [];
      var self = this;
      setTimeout(function () {
        self.fetchNewsOnLoad();
      }, 1);
    },
    fetchNewsOnLoad: function fetchNewsOnLoad() {
      var self = this;
      this.$http.get(this.$PATH_NAME + 'news/get20/' + this.getNewspapersString()).then(function (response) {
        if (response.status === 200) {
          self.posts = response.body;
        }
      }).catch(function (err) {
        this.handleError(err);
      }).finally(function () {
        this.isLoadingState = false;
      });
    },
    fetchNewsOnLoadMore: function fetchNewsOnLoadMore() {
      var self = this;
      if (this.posts[this.posts.length - 1]) {
        var lastId = this.posts[this.posts.length - 1].datePublished;
        this.$http.get(this.$PATH_NAME + 'news/get20&fromId=' + lastId + '/' + this.getNewspapersString()).then(function (response) {
          response.body.forEach(function (post) {
            self.posts.push(post);
          });
        }).catch(function (err) {
          this.handleError(err);
        });
      }
    },
    fetchNewspapers: function fetchNewspapers() {
      var _this = this;

      var self = this;
      this.$http.get(this.$PATH_NAME + 'news/getNewspapers').then(function (response) {
        response.body.forEach(function (newspaper) {
          self.newspapers[newspaper.newspaper] = { name: newspaper.newspaperName, active: true };
        });
        self.areLoadedNewsPapers = true;
      }).catch(function (err) {
        this.handleError(err);
      }).finally(function () {
        _this.fetchNewsOnLoad();
      });
    },
    checkWindowSize: function checkWindowSize() {
      if (!this.isSmallWindow && window.innerWidth < 1051) {
        this.isSmallWindow = true;
      } else if (this.isSmallWindow && window.innerWidth > 1051) {
        this.isSmallWindow = false;
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$store.commit('setCurrentView', this.default);
    this.fetchNewspapers();
    this.checkWindowSize();
    window.addEventListener('resize', function () {
      return _this2.checkWindowSize();
    });
  },

  computed: {
    activeLanguage: function activeLanguage() {
      return this.$translations[this.$store.getters.currentLanguageValue];
    },
    isLoadingContent: function isLoadingContent() {
      return this.isLoadingState;
    },
    isEmptyContent: function isEmptyContent() {
      return this.posts.length === 0 && !this.isLoadingState;
    },
    areMultipleNewspapers: function areMultipleNewspapers() {
      return this.areLoadedNewsPapers && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.newspapers).length > 1;
    },
    getContainerClass: function getContainerClass() {
      return this.isSmallWindow ? 'post-container-mobile' : 'post-container';
    }
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  props: {
    default: {
      type: Object
    }
  }
});

/***/ }),

/***/ "OCZh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OKCu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/NRP.c1668b7.jpg";

/***/ }),

/***/ "OPLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RegulationsModal',
  computed: {
    activeLanguage: function activeLanguage() {
      var currLang = this.$translations[this.$store.getters.currentLanguageValue];
      if (currLang.regulationsItems) {
        return this.$translations[this.$store.getters.currentLanguageValue];
      } else {
        return this.$translations['Italian'];
      }
    }
  },
  methods: {
    showModal: function showModal() {
      this.$refs.regulationsModal.show();
    },
    hideModal: function hideModal() {
      this.$refs.regulationsModal.hide();
    }
  },
  mounted: function mounted() {
    document.getElementById('regulationsModal___BV_modal_header_').setAttribute('style', 'background-color: #c41c21 !important; color: white !important;');
    document.getElementById('regulationsModal___BV_modal_header_').lastChild.setAttribute('style', 'color: white !important;');
  }
});

/***/ }),

/***/ "OQ21":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-pageContentPlaceholder"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ORre":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReadCartaModal_vue__ = __webpack_require__("6Owy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7890b703_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReadCartaModal_vue__ = __webpack_require__("udBC");
function injectStyle (ssrContext) {
  __webpack_require__("botx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7890b703"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReadCartaModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7890b703_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReadCartaModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Oimg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutUsModal_vue__ = __webpack_require__("uCeh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4280b2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutUsModal_vue__ = __webpack_require__("93d4");
function injectStyle (ssrContext) {
  __webpack_require__("LZml")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a4280b2c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutUsModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4280b2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutUsModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OtiY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DiscoverAlpFoodway_vue__ = __webpack_require__("2VY6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7140ac24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DiscoverAlpFoodway_vue__ = __webpack_require__("trBh");
function injectStyle (ssrContext) {
  __webpack_require__("47q3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7140ac24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DiscoverAlpFoodway_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7140ac24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DiscoverAlpFoodway_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PCea":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialsModal_vue__ = __webpack_require__("FNo+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e9a2cb8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialsModal_vue__ = __webpack_require__("aW+R");
function injectStyle (ssrContext) {
  __webpack_require__("q3Pw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e9a2cb8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialsModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e9a2cb8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialsModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PM1B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainSupporters_vue__ = __webpack_require__("Q2Bf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_467e6e84_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainSupporters_vue__ = __webpack_require__("0kkJ");
function injectStyle (ssrContext) {
  __webpack_require__("qgrV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-467e6e84"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainSupporters_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_467e6e84_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainSupporters_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PeyN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PkLM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GalleryPage_vue__ = __webpack_require__("Gqxr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cf04000_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GalleryPage_vue__ = __webpack_require__("XtNF");
function injectStyle (ssrContext) {
  __webpack_require__("w8Xv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3cf04000"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GalleryPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cf04000_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GalleryPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Pl2d":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alpfoodway_background17_resized.77f9ad0.jpg";

/***/ }),

/***/ "PqoU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pagesComponents_signPetitionPageComponents_SignPetitionPage__ = __webpack_require__("HPm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AboutUsModal__ = __webpack_require__("Oimg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ImagesCarousel',
  components: { AboutUsModal: __WEBPACK_IMPORTED_MODULE_1__AboutUsModal__["a" /* default */] },
  data: function data() {
    return {
      carouselImages: ['alpfoodway_background1', 'alpfoodway_background2', 'alpfoodway_background3', 'alpfoodway_background4', 'alpfoodway_background5', 'alpfoodway_background6'],
      carouselVideos: ['s8AWxn-_3l0', '41wV7L8WYG0', 'HNyJwLD4kxU', 'h_7KwqL79as', 'n-qOHBF2YW4'],
      slide: 0,
      hasTransitionEnded: false
    };
  },

  methods: {
    loadAboutUSModal: function loadAboutUSModal() {
      this.$refs.aboutUsModalExt.showModal();
    },
    imagePath: function imagePath(imageName) {
      return __webpack_require__("pzmR")("./" + imageName + '_resized.jpg');
    },
    getYoutubeLink: function getYoutubeLink(videoId) {
      return 'https://www.youtube.com/embed/' + videoId;
    },
    loadSignPetition: function loadSignPetition() {
      this.$store.commit('setCurrentView', __WEBPACK_IMPORTED_MODULE_0__pagesComponents_signPetitionPageComponents_SignPetitionPage__["a" /* default */]);
      this.$router.push('/sign-petition');
    },
    onSlideStart: function onSlideStart(slide) {
      this.hasTransitionEnded = false;
    },
    onSlideEnd: function onSlideEnd(slide) {
      this.hasTransitionEnded = true;
    },
    generateCaption: function generateCaption(slideNumber) {
      return this.activeLanguage.carouselTitles[slideNumber];
    },
    generateText: function generateText(slideNumber) {
      return this.activeLanguage.carouselSubtitles[slideNumber];
    }
  },
  computed: {
    activeLanguage: function activeLanguage() {
      var currLang = this.$translations[this.$store.getters.currentLanguageValue];
      if (currLang.carouselTitles) {
        return this.$translations[this.$store.getters.currentLanguageValue];
      } else {
        return this.$translations['English'];
      }
    }
  },
  mounted: function mounted() {
    this.hasTransitionEnded = true;
  }
});

/***/ }),

/***/ "Q2Bf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MainSupporters',
  data: function data() {
    return {
      supporters: []
    };
  },

  methods: {
    imagePath: function imagePath(imageName) {
      return __webpack_require__("B9Mr")("./" + imageName);
    },
    loadMainSupporters: function loadMainSupporters() {
      var self = this;
      this.$http.get(this.$PATH_NAME + 'partners/main/').then(function (response) {
        if (response.status === 200) {
          self.supporters = response.body;
        }
      }).catch(function (err) {
        this.handleError(err);
      });
    },
    handleError: function handleError(err) {
      if (err.status >= 500) {
        console.log('Server-Related problem');
      } else if (err.status === 400) {
        console.log('A bad request occurred');
      } else if (err.status === 404) {
        console.log(err.body.message);
      }
    }
  },
  mounted: function mounted() {
    this.loadMainSupporters();
  }
});

/***/ }),

/***/ "Q3+l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q5nK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NewsArticleCard',
  data: function data() {
    return {
      iconStyle: 'icon icon-verified',
      imageUrl: '',
      link: '',
      newspaper: '',
      title: '',
      datePublished: '',
      description: '',
      id: '',
      name: '',
      isSmallWindow: false
    };
  },

  props: {
    postContent: {
      type: Object
    }
  },
  computed: {
    newsUrl: function newsUrl() {
      return this.link;
    },
    createdAtMoment: function createdAtMoment() {
      if (this.datePublished) {
        var s = this.$moment(this.datePublished);
        if (s.isValid()) {
          return s;
        }
      }
      return this.$moment();
    },
    giveClassFromType: function giveClassFromType() {
      return 'icon ' + this.newspaper;
    },
    getBodyClass: function getBodyClass() {
      return this.isSmallWindow ? 'row post-body' : 'post-body';
    },
    getCardClass: function getCardClass() {
      return this.isSmallWindow ? 'post-card-mobile' : 'post-card';
    }
  },
  methods: {
    initializeFields: function initializeFields() {
      this.imageUrl = this.postContent.imageUrl;
      this.link = this.postContent.link;
      this.newspaper = this.postContent.newspaper;
      this.title = this.postContent.title;
      this.datePublished = this.postContent.datePublished;
      this.description = this.postContent.description;
      this.id = this.postContent.id;
      this.name = this.postContent.newspaperName;
    },
    checkWindowSize: function checkWindowSize() {
      if (!this.isSmallWindow && window.innerWidth < 1051) {
        this.isSmallWindow = true;
      } else if (this.isSmallWindow && window.innerWidth > 1051) {
        this.isSmallWindow = false;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.initializeFields();
    this.checkWindowSize();
    window.addEventListener('resize', function () {
      return _this.checkWindowSize();
    });
  }
});

/***/ }),

/***/ "Q8/9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-countdownFooter container"},[_c('div',{staticClass:"embed-frame"},[_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","controls":"","poster":"poster.png","src":"https://www.youtube.com/embed/s8AWxn-_3l0?rel=0","allowfullscreen":""}})],1),_vm._v(" "),_c('b-container',[_c('b-row',{staticClass:"social-top"},[_c('b-col',{staticClass:"column"},[_c('a',{staticClass:"facebook social-circle",attrs:{"href":"https://www.facebook.com/alpfoodway/"}},[_vm._v("Facebook")]),_vm._v(" "),_c('span',[_vm._v("Like Us")])]),_vm._v(" "),_c('b-col',{staticClass:"column"},[_c('a',{staticClass:"instagram social-circle",attrs:{"href":"https://www.instagram.com/alpfoodway_project/"}},[_vm._v("Instagram")]),_vm._v(" "),_c('span',[_vm._v("Follow Us")])]),_vm._v(" "),_c('b-col',{staticClass:"column"},[_c('a',{staticClass:"twitter social-circle",attrs:{"href":"http://twitter.com/AlpFoodway"}},[_vm._v("Twitter")]),_vm._v(" "),_c('span',[_vm._v("Follow Us")])])],1),_vm._v(" "),_c('b-row',{staticClass:"social-bottom"},[_c('b-col',{staticClass:"column"},[_c('a',{staticClass:"linkedin social-circle",attrs:{"href":"https://www.linkedin.com/in/alpfoodway-project-alpine-space-88a362139/"}},[_vm._v("Linkedin")]),_vm._v(" "),_c('span',[_vm._v("Connect With Us")])]),_vm._v(" "),_c('b-col',{staticClass:"column"},[_c('a',{staticClass:"youtube social-circle",attrs:{"href":"https://www.youtube.com/channel/UCwctGbI6DSxE_peLz2wRmMQ"}},[_vm._v("Email")]),_vm._v(" "),_c('span',[_vm._v("Subscribe To Us")])]),_vm._v(" "),_c('b-col',{staticClass:"column"},[_c('a',{staticClass:"mail social-circle",attrs:{"href":"mailto:cassiano.luminati@polo-poschiavo.ch"}},[_vm._v("Email")]),_vm._v(" "),_c('span',[_vm._v("Contact Us")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QFP8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.arePostsPresent),expression:"arePostsPresent"}],staticClass:"f-contest"},[_c('h2',{staticClass:"title-container clickable",on:{"click":_vm.loadContest}},[_vm._v("Contest"),_c('br'),_vm._v("\"Alpine Food Heritage Stories\"")]),_vm._v(" "),(_vm.activeLanguage.winnersList && _vm.activeLanguage.winnersList.length > 0)?_c('b-row',{staticClass:"justify-content-md-center section",attrs:{"align-h":"center"}},[_c('b-col',[_c('div',{staticClass:"icon-wrapper"},[_c('div',{staticClass:"icon-container",on:{"click":_vm.loadWinners}},[_c('div',{staticClass:"contest-icon icon"})])]),_vm._v(" "),_c('p',{staticClass:"counterStyle"},[_vm._v(_vm._s(_vm.activeLanguage.winners))])]),_vm._v(" "),_c('winners-modal',{ref:"winnersModal"})],1):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"justify-content-md-center section",attrs:{"align-h":"center"}},[_c('b-col',[(new Date() >= new Date('4/23/2019 13:00:00'))?[(new Date() >= new Date('6/16/2019 23:55:00'))?_c('div',[_c('p',{staticClass:"loading-subtitle"},[_vm._v(_vm._s(_vm.activeLanguage.contestClosing))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"post-container"},[_c('div',{directives:[{name:"masonry",rawName:"v-masonry"}],class:_vm.getContainerClass,attrs:{"fit-width":true,"item-selector":".item","transition-duration":"0.3s"}},_vm._l((_vm.posts),function(post,index){return _c('div',{directives:[{name:"masonry-tile",rawName:"v-masonry-tile"}],key:index,staticClass:"item",class:[{'card-mobile': _vm.$store.getters.isMobileValue}]},[_c('social-card',{attrs:{"post-content":post}})],1)}))])]:[_c('div',[_c('p',{staticClass:"loading-subtitle"},[_vm._v(_vm._s(_vm.activeLanguage.contestOpening))]),_vm._v(" "),_c('div',{staticClass:"contest-photo"})])]],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QXzP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"target":"_blank","href":_vm.eventUrl}},[_c('div',{staticClass:"f-eventCard embeddedPost-post"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 postAuthor text-left"},[_c('div',{staticClass:"row"},[_c('span',{staticClass:"col-4 postAuthor-name identity-name day"},[_vm._v("\n            "+_vm._s(_vm._f("moment")(_vm.createdAtMoment,'DD'))+"\n          ")]),_vm._v(" "),_c('span',{staticClass:"col-8 postAuthor-name identity-name align-self-center"},[_vm._v("\n                "+_vm._s(_vm._f("moment")(_vm.createdAtMoment,'MMMM \'YY'))+"\n              ")])]),_vm._v(" "),_c('a',{staticClass:"u-linkBlend u-url customisable-highlight long-permalink"},[_c('p',{staticClass:"dt-updated post-alert",attrs:{"title":"Time posted"}},[_vm._v("\n                "+_vm._s(_vm.city)+"\n              ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-3 post-brand"},[[_c('a',[(_vm.country !== '-')?_c('div',{staticClass:"icon country",attrs:{"aria-label":"Country","title":"Country"}},[_c('p',{attrs:{"id":"country-code"}},[_vm._v(_vm._s(_vm.country))])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:_vm.giveClassFromType,attrs:{"aria-label":"type","title":_vm.type}})])]],2)]),_vm._v(" "),_c('div',{staticClass:"row post-body"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"identity-name"},[_c('span',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('p',{staticClass:"post-text text-justify",attrs:{"dir":"ltr"}},[_vm._v(_vm._s(_vm.description))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R+iC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alpfoodway_background3_resized.4e1391e.jpg";

/***/ }),

/***/ "R2yG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImagesCarousel_vue__ = __webpack_require__("PqoU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0400786_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImagesCarousel_vue__ = __webpack_require__("I8FQ");
function injectStyle (ssrContext) {
  __webpack_require__("Q3+l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e0400786"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImagesCarousel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0400786_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImagesCarousel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RJcO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cassiano.b84d2f6.jpg";

/***/ }),

/***/ "RL8R":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alpfoodway_background12_resized.f5dd5a6.jpg";

/***/ }),

/***/ "SXGt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dislivelli-association.17c1eb3.jpg";

/***/ }),

/***/ "SfCl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OtherSupporters',
  data: function data() {
    return {
      supporters: []
    };
  },

  methods: {
    imagePath: function imagePath(imageName) {
      return __webpack_require__("d9Uk")("./" + imageName);
    },
    loadMainSupporters: function loadMainSupporters() {
      var self = this;
      this.$http.get(this.$PATH_NAME + 'partners/other/').then(function (response) {
        if (response.status === 200) {
          self.supporters = response.body;
        }
      }).catch(function (err) {
        this.handleError(err);
      });
    },
    handleError: function handleError(err) {
      if (err.status >= 500) {
        console.log('Server-Related problem');
      } else if (err.status === 400) {
        console.log('A bad request occurred');
      } else if (err.status === 404) {
        console.log(err.body.message);
      }
    }
  },
  mounted: function mounted() {
    this.loadMainSupporters();
  }
});

/***/ }),

/***/ "SqBM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainSupporters__ = __webpack_require__("PM1B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OtherSupporters__ = __webpack_require__("mKQ9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_leaflet__ = __webpack_require__("nrd6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_leaflet_dist_images_marker_icon_png__ = __webpack_require__("TJ5S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_leaflet_dist_images_marker_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_leaflet_dist_images_marker_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_leaflet_dist_images_marker_shadow_png__ = __webpack_require__("wkq0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_leaflet_dist_images_marker_shadow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_leaflet_dist_images_marker_shadow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BecomeSupporterModal__ = __webpack_require__("f2Ls");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__webpack_require__("0J91");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SupportersPage',
  components: {
    BecomeSupporterModal: __WEBPACK_IMPORTED_MODULE_6__BecomeSupporterModal__["a" /* default */],
    OtherSupporters: __WEBPACK_IMPORTED_MODULE_2__OtherSupporters__["a" /* default */],
    MainSupporters: __WEBPACK_IMPORTED_MODULE_1__MainSupporters__["a" /* default */]
  },
  computed: {
    activeLanguage: function activeLanguage() {
      return this.$translations[this.$store.getters.currentLanguageValue];
    },
    getMapClass: function getMapClass() {
      return this.isSmallWindow ? 'map-mobile' : 'map';
    }
  },
  props: {
    default: {
      type: Object
    }
  },
  data: function data() {
    return {
      isSmallWindow: false
    };
  },

  methods: {
    loadBecomeSupporterModal: function loadBecomeSupporterModal() {
      this.$refs.becomeSupporterModalExt.showModal();
    },
    loadSupporters: function loadSupporters() {
      var tiles = void 0,
          latlng = void 0;
      // tiles = L.tileLayer('https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}{r}.png', {
      //   maxZoom: 13,
      //   minZoom: 2,
      //   attribution: '<a href="https://wikimediafoundation.org/wiki/Maps_Terms_of_Use">Wikimedia</a>'
      // })
      // tiles = L.tileLayer('https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png', {
      //   maxZoom: 13,
      //   minZoom: 2,
      //   attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="http://cartodb.com/attributions">CartoDB</a>'
      // })
      tiles = __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}', {
        maxZoom: 13,
        minZoom: 2,
        continuousWorld: true,
        attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community'
      });
      latlng = __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.latLng(19.638534, -39.399043);
      var map = __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.map('map', { center: latlng, zoom: 2.2, layers: [tiles], worldCopyJump: true });
      map.scrollWheelZoom.disable();
      map.on('click', function () {
        if (map.scrollWheelZoom.enabled()) {
          map.scrollWheelZoom.disable();
        } else {
          map.scrollWheelZoom.enable();
        }
      });
      var markers = __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.markerClusterGroup({
        chunkedLoading: true,
        iconCreateFunction: function iconCreateFunction(cluster) {
          var markers = cluster.getAllChildMarkers();
          var n = 0;
          for (var i = 0; i < markers.length; i++) {
            n += markers[i].petitions;
          }
          var size = n.toString().length;
          var xy = 0;
          var className = '';
          var divClass = '';
          var spanStyle = '';
          if (size === 1) {
            xy = 30;
            className = 'clusterIcon-1';
            divClass = 'divClass-1';
            spanStyle = '20px';
          } else if (size <= 4) {
            xy = 40;
            className = 'clusterIcon-4';
            divClass = 'divClass-4';
            spanStyle = '30px';
          } else if (size <= 5) {
            xy = 50;
            className = 'clusterIcon-6';
            divClass = 'divClass-6';
            spanStyle = '40px';
          } else if (size <= 10) {
            xy = 60;
            className = 'clusterIcon-10';
            divClass = 'divClass-10';
            spanStyle = '50px';
          } else if (size > 10) {
            xy = 70;
            className = 'clusterIcon-10';
            divClass = 'divClass-10';
            spanStyle = '60px';
          }
          return __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.divIcon({
            html: '<div class="' + divClass + '"> <span style="line-height: ' + spanStyle + '">' + n + '</span></div>',
            iconSize: __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.point(xy, xy),
            className: className
          });
        },
        // spiderfyOnMaxZoom: false,
        singleMarkerMode: true,
        chunkProgress: this.updateProgressBar
      });
      var markerList = [];
      this.$http.get(this.$PATH_NAME + 'petitions/cities/countAggregate').then(function (response) {
        var res = response.body;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(res).forEach(function (key, index) {
          if (res[key].latitude && res[key].longitude) {
            var title = res[key].signatures;
            var marker = __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.marker(__WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.latLng(res[key].latitude, res[key].longitude));
            var icon = __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.icon({ iconUrl: __WEBPACK_IMPORTED_MODULE_4_leaflet_dist_images_marker_icon_png___default.a, shadowUrl: __WEBPACK_IMPORTED_MODULE_5_leaflet_dist_images_marker_shadow_png___default.a });
            marker.setIcon(icon);
            marker.petitions = title;
            marker.on('mouseover', function () {
              marker.bindPopup(key).openPopup();
            });
            marker.on('click', function (a) {
              var latlng = __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.latLng(a.latlng.lat, a.latlng.lng);
              map.setZoomAround(latlng, 9);
            });
            markerList.push(marker);
          }
        });
      }).catch(function (err) {
        if (err.status >= 500) {
          console.log('Server-Related problem');
        } else if (err.status === 400) {
          console.log('A bad request occurred');
        } else if (err.status === 404) {
          console.log(err.body.message);
        }
      }).finally(function () {
        markers.addLayers(markerList);
        map.addLayer(markers);
      });
      document.getElementsByClassName('leaflet-top')[0].setAttribute('style', 'z-index: 974 !important;');
      document.getElementsByClassName('leaflet-bottom')[0].setAttribute('style', 'z-index: 974 !important;');
      document.getElementsByClassName('leaflet-bottom')[1].setAttribute('style', 'z-index: 974 !important;');
    },
    updateProgressBar: function updateProgressBar(processed, total, elapsed, layersArray) {
      var progress = document.getElementById('progress');
      var progressBar = document.getElementById('progress-bar');
      if (elapsed > 1000) {
        // if it takes more than a second to load, display the progress bar:
        progress.style.display = 'block';
        progressBar.style.width = Math.round(processed / total * 100) + '%';
      }

      if (processed === total) {
        // all markers processed - hide the progress bar:
        progress.style.display = 'none';
      }
    },
    checkWindowSize: function checkWindowSize() {
      if (!this.isSmallWindow && window.innerWidth < 1051) {
        this.isSmallWindow = true;
      } else if (this.isSmallWindow && window.innerWidth > 1051) {
        this.isSmallWindow = false;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.commit('setCurrentView', this.default);
    this.loadSupporters();
    this.checkWindowSize();
    window.addEventListener('resize', function () {
      return _this.checkWindowSize();
    });
  }
});

/***/ }),

/***/ "TJ5S":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII="

/***/ }),

/***/ "TogM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tzsc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShareCampaignModal',
  data: function data() {
    return {
      headerClass: 'modal-header-class'
    };
  },

  computed: {
    activeLanguage: function activeLanguage() {
      return this.$translations[this.$store.getters.currentLanguageValue];
    },
    modalTitle: function modalTitle() {
      return this.activeLanguage.share + ' ' + this.activeLanguage.ourCampaign;
    }
  },
  methods: {
    showModal: function showModal() {
      this.$refs.shareCampaignModal.show();
    },
    hideModal: function hideModal() {
      this.$refs.shareCampaignModal.hide();
    }
  },
  mounted: function mounted() {
    document.getElementById('shareCampaignModal___BV_modal_header_').setAttribute('style', 'background-color: #c41c21 !important; color: white !important;');
    document.getElementById('shareCampaignModal___BV_modal_header_').lastChild.setAttribute('style', 'color: white !important;');
  }
});

/***/ }),

/***/ "U+M1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilComponents_CreditsModal__ = __webpack_require__("AmSj");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mainFooter',
  components: { CreditsModal: __WEBPACK_IMPORTED_MODULE_0__utilComponents_CreditsModal__["a" /* default */] },
  data: function data() {
    return {
      partnersLogoSmall: ['lombardy-region.jpg', 'brel.jpg', 'camonica-valley.jpg', 'tsm.jpg', 'dislivelli-association.jpg', 'crepa.jpg', 'kedge-business-school.jpg', 'bauges-park.jpg', 'ragor.jpg', 'rda.jpg', 'munich-university-of-applied-sciences.jpg', 'uibk.jpg'],
      partnersLink: 'http://www.alpine-space.eu/projects/alpfoodway/en/about/partners/',
      isSmallWindow: false
    };
  },

  computed: {
    activeLanguage: function activeLanguage() {
      return this.$translations[this.$store.getters.currentLanguageValue];
    }
  },
  methods: {
    imagePath: function imagePath(imageName) {
      return __webpack_require__("IJJN")("./" + imageName);
    },
    getTooltipName: function getTooltipName(name) {
      switch (name) {
        case 'lombardy-region':
          return 'Ethnographic and Social History Archive – D.G. Culture, Lombardy Region';
        case 'brel':
          return 'Autonomous Region of Aosta Valley - Department for Education and Culture';
        case 'camonica-valley':
          return 'Mountain Community of Camonica Valley';
        case 'tsm':
          return 'Trentino School of Management';
        case 'dislivelli-association':
          return 'Dislivelli Association';
        case 'crepa':
          return 'Regional Center of Alpine Population Studies';
        case 'kedge-business-school':
          return 'Kedge Business School';
        case 'bauges-park':
          return 'Bauges Regional Natural Park';
        case 'ragor':
          return 'Development Agency for Upper Gorenjska';
        case 'rda':
          return 'Regional Development Agency of Northern Primorska Ltd. Nova Gorica';
        case 'munich-university-of-applied-sciences':
          return 'Munich University of Applied Sciences';
        case 'uibk':
          return 'University of Innsbruck';
        default:
          return '';
      }
    },
    openCreditsModal: function openCreditsModal() {
      this.$refs.creditsModal.showModal();
    },
    checkWindowSize: function checkWindowSize() {
      if (!this.isSmallWindow && window.innerWidth < 1051) {
        this.isSmallWindow = true;
      } else if (this.isSmallWindow && window.innerWidth > 1051) {
        this.isSmallWindow = false;
      }
    }
  },
  created: function created() {
    var self = this;
    this.checkWindowSize();
    window.addEventListener('resize', function () {
      self.checkWindowSize();
    });
  }
});

/***/ }),

/***/ "U7Oc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilComponents_SocialCard__ = __webpack_require__("Kumg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_GridLoader_vue__ = __webpack_require__("A4IU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_masonry__ = __webpack_require__("w/U7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilComponents_VideoCard__ = __webpack_require__("cjDp");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_masonry__["a" /* VueMasonryPlugin */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VideosPage',
  components: { VideoCard: __WEBPACK_IMPORTED_MODULE_4__utilComponents_VideoCard__["a" /* default */], SocialCard: __WEBPACK_IMPORTED_MODULE_0__utilComponents_SocialCard__["a" /* default */], GridLoader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_GridLoader_vue__["a" /* default */] },
  props: {
    default: {
      type: Object
    }
  },
  data: function data() {
    return {
      posts: [],
      socialFilter: { 'Twitter': true, 'Instagram': true },
      userFilter: { 'AlpFoodway': true, 'Others': true },
      isLoadingState: true,
      areInformationOutdated: false,
      profilesToUpdate: [],
      iconWrapper: 'icon-wrapper',
      isSmallWindow: false
    };
  },

  computed: {
    activeLanguage: function activeLanguage() {
      return this.$translations[this.$store.getters.currentLanguageValue];
    },
    isLoadingContent: function isLoadingContent() {
      return this.isLoadingState;
    },
    isEmptyContent: function isEmptyContent() {
      return this.posts.length === 0 && !this.isLoadingState;
    },
    getContainerClass: function getContainerClass() {
      return this.isSmallWindow ? 'post-container-mobile' : 'post-container';
    }
  },
  methods: {
    fetchVideosOnLoad: function fetchVideosOnLoad() {
      var self = this;
      this.$http.get(this.$PATH_NAME + 'videos/get20').then(function (response) {
        if (response.status === 200) {
          self.posts = response.body;
          // setInterval(function () {
          //   self.pollNewPosts()
          // }, 3000)
        }
      }).catch(function (err) {
        this.handleError(err);
      }).finally(function () {
        this.isLoadingState = false;
      });
    },
    fetchVideosOnLoadMore: function fetchVideosOnLoadMore() {
      var self = this;
      if (this.posts[this.posts.length - 1]) {
        var lastId = String(this.posts[this.posts.length - 1].id);
        this.$http.get(this.$PATH_NAME + 'videos/get20&fromId=' + lastId).then(function (response) {
          response.body.forEach(function (post) {
            if (!self.posts.map(function (_ref) {
              var id = _ref.id;
              return id;
            }).includes(post.id)) {
              self.posts.push(post);
            }
          });
        }).catch(function (err) {
          this.handleError(err);
        });
      }
    },
    handleError: function handleError(err) {
      if (err.status >= 500) {
        console.log('Server-Related problem');
      } else if (err.status === 400) {
        console.log('A bad request occurred');
      } else if (err.status === 404) {
        console.log(err.body.message);
      }
    },
    checkWindowSize: function checkWindowSize() {
      if (!this.isSmallWindow && window.innerWidth < 1051) {
        this.isSmallWindow = true;
      } else if (this.isSmallWindow && window.innerWidth > 1051) {
        this.isSmallWindow = false;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.commit('setCurrentView', this.default);
    this.fetchVideosOnLoad();
    this.checkWindowSize();
    window.addEventListener('resize', function () {
      return _this.checkWindowSize();
    });
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),

/***/ "UIej":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-shareCampaignModal"},[_c('b-modal',{ref:"shareCampaignModal",attrs:{"id":"shareCampaignModal","centered":"","size":"lg","hide-footer":"","title":_vm.modalTitle}},[_c('p',{staticClass:"my-4"},[_vm._v("\n      Here will appear some images about the chart to be shared.\n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Udhw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__ = __webpack_require__("hjDc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4658cfe4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__ = __webpack_require__("XTee");
function injectStyle (ssrContext) {
  __webpack_require__("3gCV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4658cfe4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4658cfe4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V1l4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__("INCx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CountdownTimer',
  props: {
    date: {
      type: String
    }
  },
  data: function data() {
    return {
      now: 0
    };
  },

  methods: {
    timerLoop: function timerLoop() {
      this.now = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(new Date().getTime() / 1000);
      setTimeout(this.timerLoop, 1000);
    }
  },
  mounted: function mounted() {
    this.timerLoop();
  },

  computed: {
    seconds: function seconds() {
      return ('0' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()((this.modifiedDate - this.now) % 60)).slice(-2);
    },
    minutes: function minutes() {
      return ('0' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()((this.modifiedDate - this.now) / 60 % 60)).slice(-2);
    },
    hours: function hours() {
      return ('0' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()((this.modifiedDate - this.now) / 60 / 60 % 24)).slice(-2);
    },
    days: function days() {
      return ('0' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()((this.modifiedDate - this.now) / 60 / 60 / 24)).slice(-2);
    },

    modifiedDate: function modifiedDate() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(Date.parse(this.date) / 1000);
    }
  }
});

/***/ }),

/***/ "V2UA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rda.de2b272.jpg";

/***/ }),

/***/ "VBuC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThankYouModal_vue__ = __webpack_require__("oD+E");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99d0f602_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThankYouModal_vue__ = __webpack_require__("2t+/");
function injectStyle (ssrContext) {
  __webpack_require__("2bmP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-99d0f602"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThankYouModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99d0f602_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThankYouModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VTH6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilComponents_SocialCard__ = __webpack_require__("Kumg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_GridLoader_vue__ = __webpack_require__("A4IU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_masonry__ = __webpack_require__("w/U7");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_masonry__["a" /* VueMasonryPlugin */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SocialWallPage',
  components: { SocialCard: __WEBPACK_IMPORTED_MODULE_0__utilComponents_SocialCard__["a" /* default */], GridLoader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_GridLoader_vue__["a" /* default */] },
  data: function data() {
    return {
      posts: [],
      socialFilter: { 'Twitter': true, 'Instagram': true },
      userFilter: { 'AlpFoodway': true, 'Others': true },
      isLoadingState: true,
      areInformationOutdated: false,
      profilesToUpdate: [],
      iconWrapper: 'icon-wrapper',
      isSmallWindow: false
    };
  },

  props: {
    default: {
      type: Object
    }
  },
  methods: {
    changeSocialStatus: function changeSocialStatus(socialName) {
      if (socialName === 'Instagram' && !this.socialFilter['Twitter']) {
        this.socialFilter['Twitter'] = !this.socialFilter['Twitter'];
      }

      if (socialName === 'Instagram' && !this.socialFilter['Twitter']) {
        this.socialFilter['Twitter'] = !this.socialFilter['Twitter'];
      }
      if (socialName === 'Twitter' && !this.socialFilter['Instagram']) {
        this.socialFilter['Instagram'] = !this.socialFilter['Instagram'];
      }
      this.socialFilter[socialName] = !this.socialFilter[socialName];
      this.updatePosts();
    },
    changeUserStatus: function changeUserStatus(userName) {
      this.userFilter[userName] = !this.userFilter[userName];
      if (userName === 'AlpFoodway' && !this.userFilter['Others']) {
        this.userFilter['Others'] = !this.userFilter['Others'];
      }
      if (userName === 'Others' && !this.userFilter['AlpFoodway']) {
        this.userFilter['AlpFoodway'] = !this.userFilter['AlpFoodway'];
      }
      this.updatePosts();
    },
    updatePosts: function updatePosts() {
      this.isLoadingState = true;
      this.posts = [];
      var self = this;
      setTimeout(function () {
        self.fetchTweetsOnLoad();
      }, 1);
    },
    fetchTweetsOnLoad: function fetchTweetsOnLoad() {
      var self = this;
      this.$http.get(this.$PATH_NAME + 'social/get20' + this.getRequestValue).then(function (response) {
        if (response.status === 200) {
          self.posts = response.body;
          // setInterval(function () {
          //   self.pollNewPosts()
          // }, 3000)
        }
      }).catch(function (err) {
        this.handleError(err);
      }).finally(function () {
        this.isLoadingState = false;
      });
    },

    // pollNewPosts () {
    //   let self = this
    //   let lastId = this.posts[0].id_str
    //   this.$http.get(this.$PATH_NAME + 'social/pollNew&fromId=' + lastId + this.getRequestValue).then((response) => {
    //     if (response.status === 200) {
    //       response.body.forEach((post) => {
    //         self.posts.push(post)
    //       })
    //     }
    //   }).catch(function (err) {
    //     this.handleError(err)
    //   })
    // },
    fetchTweetsOnLoadMore: function fetchTweetsOnLoadMore() {
      var self = this;
      if (this.posts[this.posts.length - 1]) {
        var lastId = this.posts[this.posts.length - 1].id_str;
        this.$http.get(this.$PATH_NAME + 'social/get20&fromId=' + lastId + this.getRequestValue).then(function (response) {
          response.body.forEach(function (post) {
            self.posts.push(post);
          });
        }).catch(function (err) {
          this.handleError(err);
        });
      }
    },
    postIsShown: function postIsShown(post) {
      return this.socialFilter[post.type];
    },
    handleOutDatedPost: function handleOutDatedPost(userScreenName) {
      this.areInformationOutdated = true;
      if (!this.profilesToUpdate) {
        this.profilesToUpdate = [];
      }
      if (!this.profilesToUpdate.includes(userScreenName)) {
        this.profilesToUpdate.push(userScreenName);
        this.updateOutDatedPost(userScreenName);
      }
    },
    updateOutDatedPost: function updateOutDatedPost(userScreenName) {
      var self = this;
      this.$http.get(this.$PATH_NAME + '/social/updateProfileInformation/profile=' + userScreenName).then(function (response) {
        self.posts.forEach(function (post) {
          if (post.user.screenName === userScreenName) {
            post.user.profileImageUrl = response.body;
          }
        });
      }).catch(function (err) {
        this.handleError(err);
      });
    },
    handleError: function handleError(err) {
      if (err.status >= 500) {
        console.log('Server-Related problem');
      } else if (err.status === 400) {
        console.log('A bad request occurred');
      } else if (err.status === 404) {
        console.log(err.body.message);
      }
    },
    checkWindowSize: function checkWindowSize() {
      if (!this.isSmallWindow && window.innerWidth < 1051) {
        this.isSmallWindow = true;
      } else if (this.isSmallWindow && window.innerWidth > 1051) {
        this.isSmallWindow = false;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.commit('setCurrentView', this.default);
    this.fetchTweetsOnLoad();
    this.checkWindowSize();
    window.addEventListener('resize', function () {
      return _this.checkWindowSize();
    });
  },

  computed: {
    activeLanguage: function activeLanguage() {
      return this.$translations[this.$store.getters.currentLanguageValue];
    },
    isLoadingContent: function isLoadingContent() {
      return this.isLoadingState;
    },
    isEmptyContent: function isEmptyContent() {
      return this.posts.length === 0 && !this.isLoadingState;
    },
    getRequestValue: function getRequestValue() {
      return '/Twitter=' + this.socialFilter['Twitter'] + '&Instagram=' + this.socialFilter['Instagram'] + '/AlpFoodway=' + this.userFilter['AlpFoodway'] + '&OtherPosts=' + this.userFilter['Others'] + '/';
    },
    isAlpfoodwayDisabled: function isAlpfoodwayDisabled() {
      return !this.userFilter['AlpFoodway'];
    },
    getContainerClass: function getContainerClass() {
      return this.isSmallWindow ? 'post-container-mobile' : 'post-container';
    }
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),

/***/ "Vd6i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventsPage_vue__ = __webpack_require__("bJpY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7baabf32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventsPage_vue__ = __webpack_require__("iNEV");
function injectStyle (ssrContext) {
  __webpack_require__("JRwx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7baabf32"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventsPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7baabf32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventsPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VlXi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alpfoodway_background8_resized.8c38b56.jpg";

/***/ }),

/***/ "VynG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alpfoodway_logo.a6d5b64.png";

/***/ }),

/***/ "WWdp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alpfoodway_background5_resized.c059dd6.jpg";

/***/ }),

/***/ "XD4g":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/munich-university-of-applied-sciences.1a39568.jpg";

/***/ }),

/***/ "XGZy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-socialWallPage"},[_c('div',{staticClass:"title-container"},[_c('h1',[_vm._v(_vm._s(_vm.activeLanguage.socialWall))])]),_vm._v(" "),_c('b-row',{staticClass:"buttons-wrapper"},[_c('b-col',[_c('button',{class:[ _vm.iconWrapper],on:{"click":function($event){_vm.changeSocialStatus('Twitter')}}},[_c('div',{staticClass:"inline-label"},[(_vm.socialFilter.Twitter)?_c('div',{staticClass:"icon checkbox-enabled ",attrs:{"aria-label":"Enable Twitter","role":"presentation","title":"Enable Twitter"}}):_c('div',{staticClass:"icon checkbox-disabled ",attrs:{"aria-label":"Disable Twitter","role":"presentation","title":"Enable Twitter"}}),_vm._v(" "),_c('p',{class:[_vm.socialFilter.Twitter ? "activeLabel" : "disabledLabel"]},[_vm._v("Twitter")])])])]),_vm._v(" "),_c('b-col',{staticStyle:{"border-right":"2px solid #d8d8d8"}},[_c('button',{class:[ _vm.iconWrapper],on:{"click":function($event){_vm.changeSocialStatus('Instagram')}}},[_c('div',{staticClass:"inline-label"},[(_vm.socialFilter.Instagram)?_c('div',{staticClass:"icon checkbox-enabled",attrs:{"aria-label":"Enable Instagram","role":"presentation","title":"Enable Instagram"}}):_c('div',{staticClass:"icon checkbox-disabled ",attrs:{"aria-label":"Disable Instagram","role":"presentation","title":"Enable Instagram"}}),_vm._v(" "),_c('p',{class:[_vm.socialFilter.Instagram ? "activeLabel" : "disabledLabel"]},[_vm._v("Instagram")])])])]),_vm._v(" "),_c('div'),_vm._v(" "),_c('b-col',[_c('button',{staticClass:"icon-wrapper",on:{"click":function($event){_vm.changeUserStatus('AlpFoodway')}}},[_c('div',{staticClass:"inline-label"},[(_vm.userFilter.AlpFoodway)?_c('div',{staticClass:"icon checkbox-enabled ",attrs:{"aria-label":"Enable Instagram","role":"presentation","title":"Enable Instagram"}}):_c('div',{staticClass:"icon checkbox-disabled ",attrs:{"aria-label":"Disable Instagram","role":"presentation","title":"Enable Instagram"}}),_vm._v(" "),_c('p',{class:[_vm.userFilter.AlpFoodway ? "activeLabel" : "disabledLabel"]},[_vm._v("AlpFoodway")])])])]),_vm._v(" "),_c('b-col',[_c('button',{staticClass:"icon-wrapper",on:{"click":function($event){_vm.changeUserStatus('Others')}}},[_c('div',{staticClass:"inline-label"},[(_vm.userFilter.Others)?_c('div',{staticClass:"icon checkbox-enabled ",attrs:{"aria-label":"Enable Instagram","role":"presentation","title":"Enable Instagram"}}):_c('div',{staticClass:"icon checkbox-disabled ",attrs:{"aria-label":"Disable Instagram","role":"presentation","title":"Enable Instagram"}}),_vm._v(" "),_c('p',{class:[_vm.userFilter.Others ? "activeLabel" : "disabledLabel"]},[_vm._v(_vm._s(_vm.activeLanguage.others))])])])])],1),_vm._v(" "),_c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.fetchTweetsOnLoadMore),expression:"fetchTweetsOnLoadMore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"50"}},[_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[(_vm.isLoadingContent)?_c('div',{key:"1"},[_c('p',{staticClass:"loading-subtitle"},[_vm._v(_vm._s(_vm.activeLanguage.contentLoading))]),_vm._v(" "),_c('grid-loader',{staticStyle:{"width":"100%"},attrs:{"loading":_vm.isLoadingContent,"color":"#c41c21","size":"40px"}})],1):(_vm.isEmptyContent)?_c('div',{key:"2"},[_c('p',{staticClass:"loading-subtitle"},[_vm._v(_vm._s(_vm.activeLanguage.contentEmpty))]),_vm._v(" "),_c('div',{staticClass:"empty-box"})]):_c('div',{key:"3"},[_c('div',{directives:[{name:"masonry",rawName:"v-masonry"}],class:_vm.getContainerClass,attrs:{"fit-width":true,"item-selector":".item","transition-duration":"0.3s"}},_vm._l((_vm.posts),function(post,index){return _c('div',{directives:[{name:"masonry-tile",rawName:"v-masonry-tile"}],key:index,staticClass:"item"},[_c('social-card',{attrs:{"post-content":post},on:{"update-image":_vm.handleOutDatedPost}})],1)}))])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XTee":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.areNewsPresent),expression:"areNewsPresent"}],staticClass:"f-news"},[_c('h2',{staticClass:"title-container clickable",on:{"click":_vm.loadNews}},[_vm._v(_vm._s(_vm.activeLanguage.news))]),_vm._v(" "),_c('div',{staticClass:"post-container"},[_c('div',{directives:[{name:"masonry",rawName:"v-masonry"}],class:_vm.getContainerClass,attrs:{"transition-duration":"0.3s","item-selector":".item","fit-width":true}},_vm._l((_vm.news),function(post,index){return _c('div',{directives:[{name:"masonry-tile",rawName:"v-masonry-tile"}],key:index,staticClass:"item",class:[{'card-mobile': _vm.$store.getters.isMobileValue}]},[_c('news-article-card',{attrs:{"post-content":post}})],1)}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XWjL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alpfoodway_background9_resized.8557ad5.jpg";

/***/ }),

/***/ "XjtJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alpfoodway_background5_resized.718f036.jpg";

/***/ }),

/***/ "XtNF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"webdoc",attrs:{"id":"wrapperWebdoc","src":"http://155.253.11.103/webdoc/"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y88W":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alpfoodway_background4_resized.6b0d0ab.jpg";

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pagesComponents_homePageComponents_HomePage__ = __webpack_require__("GzlF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pagesComponents_eventsPageComponents_EventsPage__ = __webpack_require__("Vd6i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pagesComponents_newsPageComponents_NewsPage__ = __webpack_require__("CArz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pagesComponents_signPetitionPageComponents_SignPetitionPage__ = __webpack_require__("HPm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pagesComponents_socialsPageComponents_SocialWallPage__ = __webpack_require__("cxkx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pagesComponents_supportersPageComponents_SupportersPage__ = __webpack_require__("kJZW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pagesComponents_paperPageComponents_PaperPage__ = __webpack_require__("sH5r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_errorPageComponents_ErrorPage__ = __webpack_require__("sTpp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pagesComponents_contestPageComponents_ContestPage__ = __webpack_require__("gz4D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pagesComponents_videosPageComponents_VideosPage__ = __webpack_require__("qLdU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pagesComponents_inventoryMapPageComponents_InventoryMapPage__ = __webpack_require__("uwPJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pagesComponents_galleryPageComponents_GalleryPage__ = __webpack_require__("PkLM");















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },

  routes: [{
    path: '/countdown',
    redirect: '/home'
  }, {
    path: '/countdown/cassiano',
    redirect: '/home'
  }, {
    path: '*',
    name: 'pageNotFound',
    component: __WEBPACK_IMPORTED_MODULE_9__components_errorPageComponents_ErrorPage__["a" /* default */],
    props: { default: __WEBPACK_IMPORTED_MODULE_9__components_errorPageComponents_ErrorPage__["a" /* default */] }
  }, {
    path: '/',
    redirect: '/home'
  }, {
    path: '/home/:language?',
    name: 'MainPage',
    component: __WEBPACK_IMPORTED_MODULE_2__components_pagesComponents_homePageComponents_HomePage__["a" /* default */],
    props: { default: __WEBPACK_IMPORTED_MODULE_2__components_pagesComponents_homePageComponents_HomePage__["a" /* default */] }
  }, {
    path: '/events/:language?',
    name: 'eventsPage',
    component: __WEBPACK_IMPORTED_MODULE_3__components_pagesComponents_eventsPageComponents_EventsPage__["a" /* default */],
    props: { default: __WEBPACK_IMPORTED_MODULE_3__components_pagesComponents_eventsPageComponents_EventsPage__["a" /* default */] }
  }, {
    path: '/news/:language?',
    name: 'newsPage',
    component: __WEBPACK_IMPORTED_MODULE_4__components_pagesComponents_newsPageComponents_NewsPage__["a" /* default */],
    props: { default: __WEBPACK_IMPORTED_MODULE_4__components_pagesComponents_newsPageComponents_NewsPage__["a" /* default */] }
  }, {
    path: '/sign-petition/:language?',
    name: 'signPetitionPage',
    component: __WEBPACK_IMPORTED_MODULE_5__components_pagesComponents_signPetitionPageComponents_SignPetitionPage__["a" /* default */],
    props: { default: __WEBPACK_IMPORTED_MODULE_5__components_pagesComponents_signPetitionPageComponents_SignPetitionPage__["a" /* default */] }
  }, {
    path: '/social-wall/:language?',
    name: 'socialWall',
    component: __WEBPACK_IMPORTED_MODULE_6__components_pagesComponents_socialsPageComponents_SocialWallPage__["a" /* default */],
    props: { default: __WEBPACK_IMPORTED_MODULE_6__components_pagesComponents_socialsPageComponents_SocialWallPage__["a" /* default */] }
  }, {
    path: '/contest/:language?',
    name: 'contest',
    component: __WEBPACK_IMPORTED_MODULE_10__components_pagesComponents_contestPageComponents_ContestPage__["a" /* default */],
    props: { default: __WEBPACK_IMPORTED_MODULE_10__components_pagesComponents_contestPageComponents_ContestPage__["a" /* default */] }
  }, {
    path: '/supporters/:language?',
    name: 'supportersPage',
    component: __WEBPACK_IMPORTED_MODULE_7__components_pagesComponents_supportersPageComponents_SupportersPage__["a" /* default */],
    props: { default: __WEBPACK_IMPORTED_MODULE_7__components_pagesComponents_supportersPageComponents_SupportersPage__["a" /* default */] }
  }, {
    path: '/paper/:language?',
    name: 'paperPage',
    component: __WEBPACK_IMPORTED_MODULE_8__components_pagesComponents_paperPageComponents_PaperPage__["a" /* default */],
    props: { default: __WEBPACK_IMPORTED_MODULE_8__components_pagesComponents_paperPageComponents_PaperPage__["a" /* default */] }
  }, {
    path: '/videos-gallery/:language?',
    name: 'videosPage',
    component: __WEBPACK_IMPORTED_MODULE_11__components_pagesComponents_videosPageComponents_VideosPage__["a" /* default */],
    props: { default: __WEBPACK_IMPORTED_MODULE_11__components_pagesComponents_videosPageComponents_VideosPage__["a" /* default */] }
  }, {
    path: '/inventory-map/:language?',
    name: 'inventoryMapPage',
    component: __WEBPACK_IMPORTED_MODULE_12__components_pagesComponents_inventoryMapPageComponents_InventoryMapPage__["a" /* default */],
    props: { default: __WEBPACK_IMPORTED_MODULE_12__components_pagesComponents_inventoryMapPageComponents_InventoryMapPage__["a" /* default */] }
  }, {
    path: '/gallery/:language?',
    name: 'galleryPage',
    component: __WEBPACK_IMPORTED_MODULE_13__components_pagesComponents_galleryPageComponents_GalleryPage__["a" /* default */],
    props: { default: __WEBPACK_IMPORTED_MODULE_13__components_pagesComponents_galleryPageComponents_GalleryPage__["a" /* default */] }
  }, {
    path: '/valoriICH',
    name: 'valoriICH',
    // component: ValoriICH
    beforeEnter: function beforeEnter(to, from, next) {
      location.href = 'http://intangiblesearch.eu/alpfoodway-webdoc/';
    }
  }, {
    path: '/ICHvalues',
    redirect: '/valoriICH'
  }, {
    path: '/ICHValues',
    redirect: '/valoriICH'
  }, {
    path: '/ichvalues',
    redirect: '/valoriICH'
  }, {
    path: '/valoriich',
    redirect: '/valoriICH'
  }, {
    path: '/valorich',
    redirect: '/valoriICH'
  }]
}));

/***/ }),

/***/ "YcFV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tsm.17c9626.jpg";

/***/ }),

/***/ "ZZij":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zu6P":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/camonica-valley.5c8508a.jpg";

/***/ }),

/***/ "aDRB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.arePostsPresent),expression:"arePostsPresent"}],staticClass:"f-socialWall"},[_c('h2',{staticClass:"title-container clickable",on:{"click":_vm.loadSocialWall}},[_vm._v(_vm._s(_vm.activeLanguage.socialWall))]),_vm._v(" "),_c('div',{staticClass:"post-container"},[_c('div',{directives:[{name:"masonry",rawName:"v-masonry"}],class:_vm.getContainerClass,attrs:{"transition-duration":"0.3s","item-selector":".item","fit-width":true}},_vm._l((_vm.posts),function(post,index){return _c('div',{directives:[{name:"masonry-tile",rawName:"v-masonry-tile"}],key:index,staticClass:"item",class:[{'card-mobile': _vm.$store.getters.isMobileValue}]},[_c('social-card',{attrs:{"post-content":post}})],1)}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aLRN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.areEventsPresent),expression:"areEventsPresent"}],staticClass:"f-events"},[_c('h2',{staticClass:"title-container clickable",on:{"click":_vm.loadEvents}},[_vm._v(_vm._s(_vm.activeLanguage.events))]),_vm._v(" "),_c('div',{staticClass:"post-container"},[_c('div',{directives:[{name:"masonry",rawName:"v-masonry"}],staticClass:"post-container",attrs:{"transition-duration":"0.3s","item-selector":".item","fit-width":true}},_vm._l((_vm.events),function(event,index){return _c('div',{directives:[{name:"masonry-tile",rawName:"v-masonry-tile"}],key:index,staticClass:"item",class:[{'card-mobile': _vm.$store.getters.isMobileValue}]},[_c('event-card',{attrs:{"post-content":event}})],1)}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aW+R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SocialsModal"},[_c('b-modal',{ref:"SocialsModal",attrs:{"id":"SocialsModal","centered":"","size":"lg","hide-footer":"","title":"#AlpFoodway"}},[_c('p',{staticClass:"my-4"},[_vm._v(_vm._s(_vm.activeLanguage.joinUs))]),_vm._v(" "),_c('b-container',[_c('div',{staticClass:"socials-wrapper"},[_c('div',{staticClass:"row mr-2 ml-2"},[_c('a',{staticClass:"col-md-6 p-2",attrs:{"href":"http://www.facebook.com/alpfoodway/","target":"_blank"}},[_c('div',{staticClass:"text-center facebook-wrapper wrapper"},[_c('div',{staticClass:"icon facebook-icon mr-2",attrs:{"aria-label":"Discover us on Facebook","title":"Discover us on Facebook"}})])])]),_vm._v(" "),_c('div',{staticClass:"row mr-2 ml-2"},[_c('a',{staticClass:"col-md-6 p-2",attrs:{"href":"https://www.instagram.com/alpfoodway_project/","target":"_blank"}},[_c('div',{staticClass:"text-center instagram-wrapper wrapper"},[_c('div',{staticClass:"icon instagram-icon mr-2",attrs:{"aria-label":"Discover us on Instagram","title":"Discover us on Instagram"}})])])]),_vm._v(" "),_c('div',{staticClass:"row mr-2 ml-2"},[_c('a',{staticClass:"col-md-6 p-2",attrs:{"href":"https://twitter.com/AlpFoodway","target":"_blank"}},[_c('div',{staticClass:"text-center twitter-wrapper wrapper"},[_c('div',{staticClass:"icon twitter-icon mr-2",attrs:{"aria-label":"Discover us on Twitter","title":"Discover us on Twitter"}})])])]),_vm._v(" "),_c('div',{staticClass:"row mr-2 ml-2"},[_c('a',{staticClass:"col-md-6 p-2",attrs:{"href":"https://www.linkedin.com/in/alpfoodway-project-alpine-space-88a362139/","target":"_blank"}},[_c('div',{staticClass:"text-center linkedin-wrapper wrapper"},[_c('div',{staticClass:"icon linkedin-icon mr-2",attrs:{"aria-label":"Discover us on Linkedin","title":"Discover us on Linkedin"}})])])]),_vm._v(" "),_c('div',{staticClass:"row mr-2 ml-2"},[_c('a',{staticClass:"col-md-6 p-2",attrs:{"href":"https://www.youtube.com/channel/UCwctGbI6DSxE_peLz2wRmMQ/featured/","target":"_blank"}},[_c('div',{staticClass:"text-center youtube-wrapper wrapper"},[_c('div',{staticClass:"icon youtube-icon mr-2",attrs:{"aria-label":"Discover us on Linkedin","title":"Discover us on Linkedin"}})])])])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bJpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_GridLoader_vue__ = __webpack_require__("A4IU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilComponents_EventCard__ = __webpack_require__("4xIF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_masonry__ = __webpack_require__("w/U7");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_masonry__["a" /* VueMasonryPlugin */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EventsPage',
  components: { EventCard: __WEBPACK_IMPORTED_MODULE_1__utilComponents_EventCard__["a" /* default */], GridLoader: __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_GridLoader_vue__["a" /* default */] },
  data: function data() {
    return {
      isLoadingState: true,
      posts: [],
      eventFilter: { 'UpcomingEvents': true, 'PastEvents': false },
      iconWrapper: 'icon-wrapper'
    };
  },

  computed: {
    activeLanguage: function activeLanguage() {
      return this.$translations[this.$store.getters.currentLanguageValue];
    },
    isLoadingContent: function isLoadingContent() {
      return this.isLoadingState;
    },
    isEmptyContent: function isEmptyContent() {
      return this.posts.length === 0 && !this.isLoadingState;
    }
  },
  methods: {
    handleError: function handleError(err) {
      if (err.status >= 500) {
        console.log('Server-Related problem');
      } else if (err.status === 400) {
        console.log('A bad request occurred');
      } else if (err.status === 404) {
        console.log(err.body.message);
      }
    },
    fetchEventsOnLoad: function fetchEventsOnLoad() {
      this.isLoadingState = true;
      this.posts = [];
      var self = this;
      this.$http.get(this.$PATH_NAME + 'events/get20/').then(function (response) {
        if (response.status === 200) {
          self.posts = response.body;
        }
      }).catch(function (err) {
        this.handleError(err);
      }).finally(function () {
        this.isLoadingState = false;
      });
    },
    fetchEventsOnLoadMore: function fetchEventsOnLoadMore() {
      var self = this;
      if (this.posts[this.posts.length - 1]) {
        var lastId = this.posts[this.posts.length - 1].datePublished;
        this.$http.get(this.$PATH_NAME + 'events/get20&fromId=' + lastId + '/').then(function (response) {
          response.body.forEach(function (post) {
            self.posts.push(post);
          });
        }).catch(function (err) {
          this.handleError(err);
        });
      }
    },
    fetchPastEvents: function fetchPastEvents() {
      this.isLoadingState = true;
      this.posts = [];
      var self = this;
      this.$http.get(this.$PATH_NAME + 'events/getPastEvents/').then(function (response) {
        if (response.status === 200) {
          self.posts = response.body;
        }
      }).catch(function (err) {
        this.handleError(err);
      }).finally(function () {
        this.isLoadingState = false;
      });
    },
    linkClass: function linkClass(idx) {
      if (this.tabIndex === idx) {
        return ['selected-bg', 'selected-text'];
      } else {
        return ['non-selected-bg', 'non-selected-text'];
      }
    },
    changeEventsStatus: function changeEventsStatus(eventType) {
      this.eventFilter[eventType] = !this.eventFilter[eventType];
      if (eventType === 'UpcomingEvents' && !this.eventFilter['PastEvents']) {
        this.eventFilter['PastEvents'] = !this.eventFilter['PastEvents'];
      }
      if (eventType === 'UpcomingEvents' && this.eventFilter['PastEvents']) {
        this.eventFilter['PastEvents'] = !this.eventFilter['PastEvents'];
      }
      if (eventType === 'PastEvents' && !this.eventFilter['UpcomingEvents']) {
        this.eventFilter['UpcomingEvents'] = !this.eventFilter['UpcomingEvents'];
      }
      if (eventType === 'PastEvents' && this.eventFilter['UpcomingEvents']) {
        this.eventFilter['UpcomingEvents'] = !this.eventFilter['UpcomingEvents'];
      }
      this.updatePosts();
    },
    updatePosts: function updatePosts() {
      this.isLoadingState = true;
      this.posts = [];
      var self = this;
      setTimeout(function () {
        if (self.eventFilter['UpcomingEvents']) {
          self.fetchEventsOnLoad();
        } else {
          self.fetchPastEvents();
        }
      }, 1);
    }
  },
  mounted: function mounted() {
    this.fetchEventsOnLoad();
    // setTimeout(function () {
    //   let tabs = document.getElementById('__BVID__13__BV_tab_controls_').getElementsByTagName('LI')
    //   console.log(tabs.item(0))
    //   // tabs.item(0).getElementsByTagName('a').item(0).setAttribute('style', 'color: #c41c21 !important;')
    // }, 50)
  }
});

/***/ }),

/***/ "bWOx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "botx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "btNX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountdownFooter_vue__ = __webpack_require__("5Qhs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9080eaa0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountdownFooter_vue__ = __webpack_require__("Q8/9");
function injectStyle (ssrContext) {
  __webpack_require__("/I/1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9080eaa0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountdownFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9080eaa0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountdownFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c/fg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cUtD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__signPetitionPageComponents_SignPetitionPage__ = __webpack_require__("HPm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShareCampaignModal__ = __webpack_require__("BYKs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReadCartaModal__ = __webpack_require__("ORre");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DiscoverAlpFoodway__ = __webpack_require__("OtiY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CartaHeader',
  components: { DiscoverAlpFoodway: __WEBPACK_IMPORTED_MODULE_3__DiscoverAlpFoodway__["a" /* default */], ReadCartaModal: __WEBPACK_IMPORTED_MODULE_2__ReadCartaModal__["a" /* default */], ShareCampaignModal: __WEBPACK_IMPORTED_MODULE_1__ShareCampaignModal__["a" /* default */] },
  computed: {
    activeLanguage: function activeLanguage() {
      return this.$translations[this.$store.getters.currentLanguageValue];
    }
  },
  data: function data() {
    return {
      loadPdf: false
    };
  },

  methods: {
    loadSignPetition: function loadSignPetition() {
      this.$store.commit('setCurrentView', __WEBPACK_IMPORTED_MODULE_0__signPetitionPageComponents_SignPetitionPage__["a" /* default */]);
      this.$router.push('/sign-petition');
    },
    loadShareCampaignModal: function loadShareCampaignModal() {
      this.$refs.shareCampaignModalExt.showModal();
    },
    loadReadCartaModal: function loadReadCartaModal() {
      this.$refs.readCartaModalExt.showModal();
    },
    loadDiscoverAlpFoodway: function loadDiscoverAlpFoodway() {
      this.loadPdf = true;
      var self = this;
      setTimeout(function () {
        self.$refs.discoverAlpFoodway.showModal();
      }, 200);
    }
  }
});

/***/ }),

/***/ "cXLZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartaHeaderAccordion_vue__ = __webpack_require__("ID3B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a485acb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartaHeaderAccordion_vue__ = __webpack_require__("camx");
function injectStyle (ssrContext) {
  __webpack_require__("3dke")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a485acb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartaHeaderAccordion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a485acb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartaHeaderAccordion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "camx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-cartaHeaderAccordion"},[_c('h2',{staticClass:"title-container"},[_vm._v(_vm._s(_vm.activeLanguage.theCarta))]),_vm._v(" "),_c('vue-accordion',{attrs:{"items":_vm.items,"styles":_vm.styles}}),_vm._v(" "),_c('read-carta-modal',{ref:"readCartaModalExt"}),_vm._v(" "),_c('share-campaign-modal',{ref:"shareCampaignModalExt"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cjDp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoCard_vue__ = __webpack_require__("4pd3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3670dce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoCard_vue__ = __webpack_require__("qFvX");
function injectStyle (ssrContext) {
  __webpack_require__("6Yfi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a3670dce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3670dce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cxkx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialWallPage_vue__ = __webpack_require__("VTH6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44108142_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialWallPage_vue__ = __webpack_require__("XGZy");
function injectStyle (ssrContext) {
  __webpack_require__("zGiX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44108142"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialWallPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44108142_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialWallPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d9Uk":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./calogero.png": "fh64",
	"./match_logo.png": "tIw/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d9Uk";

/***/ }),

/***/ "dVbd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-countdownPanel"},[_vm._m(0),_vm._v(" "),_c('b-container',{staticClass:"contentPage",attrs:{"fluid":""}},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',[_c('countdown-header')],1)],1),_vm._v(" "),_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',[_c('countdown-timer',{attrs:{"date":"October 4, 2018 16:00:00"}})],1)],1),_vm._v(" "),_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',[_c('countdown-footer'),_vm._v(" "),_c('MainFooter')],1)],1)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"cb-slideshow list-unstyled"},[_c('li',[_c('span')]),_vm._v(" "),_c('li',[_c('span')]),_vm._v(" "),_c('li',[_c('span')]),_vm._v(" "),_c('li',[_c('span')]),_vm._v(" "),_c('li',[_c('span')]),_vm._v(" "),_c('li',[_c('span')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "djDa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ragor.5965a60.jpg";

/***/ }),

/***/ "dlX9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bauges-park.1491121.jpg";

/***/ }),

/***/ "eQos":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',{staticClass:"page-row"},[(_vm.notInCountdown)?_c('headers',{ref:"headersContainer"}):_vm._e()],1),_vm._v(" "),_c('main',{staticClass:"page-row page-row-expanded"},[_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[_c('router-view',{ref:"routerContainer",attrs:{"id":"mainPage"}})],1)],1),_vm._v(" "),_c('footer',{staticClass:"page-row"},[(_vm.notInCountdown)?_c('MainFooter'):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eue+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainFooter_vue__ = __webpack_require__("U+M1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fa801c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainFooter_vue__ = __webpack_require__("5LL5");
function injectStyle (ssrContext) {
  __webpack_require__("6qrn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6fa801c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fa801c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f2Ls":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BecomeSupporterModal_vue__ = __webpack_require__("/LwZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97f084f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BecomeSupporterModal_vue__ = __webpack_require__("ETHD");
function injectStyle (ssrContext) {
  __webpack_require__("BbRT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-97f084f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BecomeSupporterModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97f084f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BecomeSupporterModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fh64":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/calogero.ed4930a.png";

/***/ }),

/***/ "fizp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alpfoodway_background13_resized.81eb452.jpg";

/***/ }),

/***/ "fr9p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountdownTimer_vue__ = __webpack_require__("V1l4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d03327b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountdownTimer_vue__ = __webpack_require__("uJeA");
function injectStyle (ssrContext) {
  __webpack_require__("E06P")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d03327b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountdownTimer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d03327b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountdownTimer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fzgl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-errorPage"},[_c('h1',[_vm._v("Not Found")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g+Sx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ragor.5965a60.jpg";

/***/ }),

/***/ "gAhX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-regulationsModal"},[_c('b-modal',{ref:"regulationsModal",attrs:{"id":"regulationsModal","centered":"","no-footer":"","size":"lg","title":"Contest \"Alpine Food Heritage Stories\""}},[_vm._l((_vm.activeLanguage.regulationsItems),function(sect,index){return [_c('h3',{key:index},[_vm._v(_vm._s(sect.title))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(sect.content)}})]}),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-button',{staticClass:"button-style float-right",on:{"click":_vm.hideModal}},[_vm._v(_vm._s(_vm.activeLanguage.close))])],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gFFt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-valueSlider"},[_c('div',{staticClass:"iCountUp"},[_c('p',{staticClass:"counterCaption"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('ICountUp',{attrs:{"startVal":_vm.startVal,"endVal":_vm.endVal,"decimals":_vm.decimals,"duration":_vm.duration,"options":_vm.options},on:{"ready":_vm.onReady}}),_vm._v(" "),_c('p',{staticClass:"counterCaption"},[_vm._v(_vm._s(_vm.subTitle))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gFQ6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gz4D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContestPage_vue__ = __webpack_require__("ApDy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc5b1c4c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContestPage_vue__ = __webpack_require__("ABjK");
function injectStyle (ssrContext) {
  __webpack_require__("/Q6p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cc5b1c4c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContestPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc5b1c4c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContestPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hBPS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hLdN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsArticleCard_vue__ = __webpack_require__("Q5nK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aada4fb2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsArticleCard_vue__ = __webpack_require__("8JEu");
function injectStyle (ssrContext) {
  __webpack_require__("yJIF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aada4fb2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsArticleCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aada4fb2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsArticleCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hZG8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Headers_vue__ = __webpack_require__("BDJT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4de81f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Headers_vue__ = __webpack_require__("JyuJ");
function injectStyle (ssrContext) {
  __webpack_require__("wht9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b4de81f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Headers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4de81f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Headers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hgar":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-countdownHeader"},[_c('div',{staticClass:"container header"},[_c('div',[_c('a',{attrs:{"href":"http://www.alpine-space.eu/projects/alpfoodway/en/home","target":"_blank"}},[_c('img',{staticClass:"alp-logo logo",attrs:{"src":__webpack_require__("VynG")}})])]),_vm._v(" "),_c('h3',[_vm._v("The website is under construction")]),_vm._v(" "),_c('h3',{staticClass:"slogan"},[_c('a',{staticClass:"hyperref-style",attrs:{"href":"https://twitter.com/search?q=%23alpfoodway&src=typd"}},[_vm._v("#AlpFoodway")])]),_vm._v(" "),_c('h4',{staticClass:"slogan"},[_vm._v(" Safeguarding and valorising "),_c('br'),_vm._v(" the Alpine Food Cultural Heritage")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hjDc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__newsPageComponents_NewsPage__ = __webpack_require__("CArz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilComponents_NewsArticleCard__ = __webpack_require__("hLdN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'News',
  components: { NewsArticleCard: __WEBPACK_IMPORTED_MODULE_1__utilComponents_NewsArticleCard__["a" /* default */] },
  data: function data() {
    return {
      news: [],
      isSmallWindow: false
    };
  },

  computed: {
    activeLanguage: function activeLanguage() {
      return this.$translations[this.$store.getters.currentLanguageValue];
    },
    areNewsPresent: function areNewsPresent() {
      return this.news.length > 0;
    },
    getContainerClass: function getContainerClass() {
      return this.isSmallWindow ? 'post-container-mobile' : 'post-container';
    }
  },
  methods: {
    loadNews: function loadNews() {
      this.$store.commit('setCurrentView', __WEBPACK_IMPORTED_MODULE_0__newsPageComponents_NewsPage__["a" /* default */]);
      this.$router.push('/news');
    },
    fetchMostRecentNews: function fetchMostRecentNews() {
      var self = this;
      this.$http.get(this.$PATH_NAME + 'news/getHighlights/').then(function (response) {
        self.news = response.body;
      });
    },
    checkWindowSize: function checkWindowSize() {
      if (!this.isSmallWindow && window.innerWidth < 1051) {
        this.isSmallWindow = true;
      } else if (this.isSmallWindow && window.innerWidth > 1051) {
        this.isSmallWindow = false;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.fetchMostRecentNews();
    this.checkWindowSize();
    window.addEventListener('resize', function () {
      return _this.checkWindowSize();
    });
  }
});

/***/ }),

/***/ "hyH3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kedge-business-school.6a8f439.jpg";

/***/ }),

/***/ "iHBW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartaAlpFoodWay_CartaHeader__ = __webpack_require__("nFiQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Statistics__ = __webpack_require__("AC4n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__News__ = __webpack_require__("Udhw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Events__ = __webpack_require__("jH4o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SocialWall__ = __webpack_require__("osDI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ImagesCarousel__ = __webpack_require__("R2yG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__countdownComponents_CountdownPanel__ = __webpack_require__("7vcr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AboutUs__ = __webpack_require__("0u4U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cartaAlpFoodWay_CartaHeaderAccordion__ = __webpack_require__("cXLZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Contest__ = __webpack_require__("BnIg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomePage',
  components: {
    Contest: __WEBPACK_IMPORTED_MODULE_9__Contest__["a" /* default */],
    CartaHeaderAccordion: __WEBPACK_IMPORTED_MODULE_8__cartaAlpFoodWay_CartaHeaderAccordion__["a" /* default */],
    AboutUs: __WEBPACK_IMPORTED_MODULE_7__AboutUs__["a" /* default */],
    ImagesCarousel: __WEBPACK_IMPORTED_MODULE_5__ImagesCarousel__["a" /* default */],
    SocialWall: __WEBPACK_IMPORTED_MODULE_4__SocialWall__["a" /* default */],
    Events: __WEBPACK_IMPORTED_MODULE_3__Events__["a" /* default */],
    News: __WEBPACK_IMPORTED_MODULE_2__News__["a" /* default */],
    Statistics: __WEBPACK_IMPORTED_MODULE_1__Statistics__["a" /* default */],
    CartaHeader: __WEBPACK_IMPORTED_MODULE_0__cartaAlpFoodWay_CartaHeader__["a" /* default */],
    CountdownPanel: __WEBPACK_IMPORTED_MODULE_6__countdownComponents_CountdownPanel__["a" /* default */]
  },
  props: {
    default: {
      type: Object
    },
    preview: {
      default: false,
      type: Boolean
    }
  },
  created: function created() {
    if (!this.$store.getters.isPreviewModeValue && this.isPastRelaseDate && this.$PATH_NAME !== 'http://localhost:8080/') {
      this.$store.commit('setCurrentView', __WEBPACK_IMPORTED_MODULE_6__countdownComponents_CountdownPanel__["a" /* default */]);
      this.$router.push('/countdown');
    } else {
      this.$store.commit('setCurrentView', this.default);
    }

    if (this.preview) {
      this.$store.commit('setIsPreviewMode', true);
      this.$router.push('/');
      console.log('Preview mode: ' + this.$store.getters.isPreviewModeValue);
    }
  }
});

/***/ }),

/***/ "iNEV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-eventsPage"},[_c('div',{staticClass:"title-container"},[_c('h1',[_vm._v(_vm._s(_vm.activeLanguage.events))])]),_vm._v(" "),_c('b-row',{staticClass:"buttons-wrapper"},[_c('b-col',[_c('button',{class:[ _vm.iconWrapper],on:{"click":function($event){_vm.changeEventsStatus('UpcomingEvents')}}},[_c('div',{staticClass:"inline-label"},[(_vm.eventFilter.UpcomingEvents)?_c('div',{staticClass:"icon checkbox-enabled ",attrs:{"aria-label":"Enable Events","role":"presentation","title":"Enable Events"}}):_c('div',{staticClass:"icon checkbox-disabled ",attrs:{"aria-label":"Disable Events","role":"presentation","title":"Disable Events"}}),_vm._v(" "),_c('p',{class:[_vm.eventFilter.UpcomingEvents ? "activeLabel" : "disabledLabel"]},[_vm._v(_vm._s(_vm.activeLanguage.events))])])])]),_vm._v(" "),_c('b-col',[_c('button',{class:[ _vm.iconWrapper],on:{"click":function($event){_vm.changeEventsStatus('PastEvents')}}},[_c('div',{staticClass:"inline-label-long"},[(_vm.eventFilter.PastEvents)?_c('div',{staticClass:"icon checkbox-enabled",attrs:{"aria-label":"Enable Past Events","role":"presentation","title":"Enable Past Events"}}):_c('div',{staticClass:"icon checkbox-disabled ",attrs:{"aria-label":"Disable Past Events","role":"presentation","title":"Disable Past Events"}}),_vm._v(" "),_c('p',{class:[_vm.eventFilter.PastEvents ? "activeLabel" : "disabledLabel"]},[_vm._v(_vm._s(_vm.activeLanguage.pastEvents))])])])])],1),_vm._v(" "),_c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},[_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[(_vm.isLoadingContent)?_c('div',{key:"1"},[_c('p',{staticClass:"loading-subtitle"},[_vm._v(_vm._s(_vm.activeLanguage.contentLoading))]),_vm._v(" "),_c('grid-loader',{staticStyle:{"width":"100%"},attrs:{"loading":_vm.isLoadingContent,"color":"#c41c21","size":"40px"}})],1):(_vm.isEmptyContent)?_c('div',{key:"2"},[_c('p',{staticClass:"loading-subtitle"},[_vm._v(_vm._s(_vm.activeLanguage.contentEmpty))]),_vm._v(" "),_c('div',{staticClass:"empty-box"})]):_c('div',{key:"3"},[_c('div',{directives:[{name:"masonry",rawName:"v-masonry"}],staticClass:"post-container",attrs:{"fit-width":true,"item-selector":".item","transition-duration":"0.3s"}},_vm._l((_vm.posts),function(post,index){return _c('div',{directives:[{name:"masonry-tile",rawName:"v-masonry-tile"}],key:index,staticClass:"item"},[_c('event-card',{staticStyle:{"max-width":"285px !important"},attrs:{"post-content":post}})],1)}))])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iOrO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alpfoodway_background15_resized.badfa8f.jpg";

/***/ }),

/***/ "inwJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"selection-card",attrs:{"target":"_blank","href":_vm.viewOnSocialUrl}},[_c('div',{class:_vm.getCardClass},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-10"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3 avatar-size"},[(_vm.profileImageUrl !== '')?_c('img',{staticClass:"avatar avatar-edge",attrs:{"src":_vm.profileImageUrl}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-9 postAuthor"},[_c('a',{attrs:{"target":"_blank","href":_vm.userPostUrl}},[_c('span',{staticClass:"postAuthor-decoratedName"},[_c('span',{staticClass:"postAuthor-name identity-name",attrs:{"title":_vm.userName}},[_vm._v("\n                "+_vm._s(_vm.userName)+"\n              ")]),_vm._v(" "),_c('span',{staticClass:"postAuthor-verifiedBadge"},[_c('div',{class:[{'u-hiddenVisually': !_vm.verifiedUser}, _vm.iconStyle],attrs:{"aria-label":"Verified Account","title":"Verified Account","role":"img"}})])]),_vm._v(" "),_c('span',{staticClass:"postAuthor-screenName identity-screenName",attrs:{"title":_vm.atScreenName,"dir":"ltr"}},[_vm._v("\n              "+_vm._s(_vm.atScreenName)+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-2 post-brand"},[(_vm.isTwitter)?[_c('a',{attrs:{"target":"_blank","href":_vm.viewOnSocialUrl}},[_vm._m(0)])]:(_vm.isInstagram)?[_c('a',{attrs:{"target":"_blank","href":_vm.externalUrl}},[_vm._m(1)])]:(_vm.isFacebook)?[_c('a',{attrs:{"target":"_blank","href":_vm.externalUrl}},[_vm._m(2)])]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"post-body"},[_c('p',{staticClass:"post-text",attrs:{"dir":"ltr"},domProps:{"innerHTML":_vm._s(_vm.postText)}}),_vm._v(" "),_c('div',{staticClass:"post-metadata dateline"},[_c('a',{staticClass:"u-linkBlend u-url customisable-highlight long-permalink",attrs:{"data-datetime":"2017-04-06T15:24:15+0000","data-scribe":"element:full_timestamp","data-url-ref-attrs-injected":"true"}},[_c('p',{staticClass:"dt-updated post-alert",attrs:{"title":"Time posted"}},[_vm._v("\n            "+_vm._s(_vm._f("moment")(_vm.createdAtMoment,'h:mm A - MMMM D, YYYY'))+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"post-card"},[_c('img',{staticClass:"post-image",attrs:{"src":_vm.imageUrl}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"followButton"},[_c('div',{staticClass:"icon icon-twitter ",attrs:{"aria-label":"View on Social","title":"View on Social","role":"presentation"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"followButton"},[_c('div',{staticClass:"icon icon-instagram",attrs:{"aria-label":"View on Social","title":"View on Social","role":"presentation"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"followButton"},[_c('div',{staticClass:"icon icon-facebook",attrs:{"aria-label":"View on Social","title":"View on Social","role":"presentation"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jH4o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Events_vue__ = __webpack_require__("6omf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e3d4aec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Events_vue__ = __webpack_require__("aLRN");
function injectStyle (ssrContext) {
  __webpack_require__("qK1A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e3d4aec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Events_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e3d4aec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Events_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jNpv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/europe-logo.0267703.jpg";

/***/ }),

/***/ "jO9f":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/brel.eda4443.jpg";

/***/ }),

/***/ "jSHs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__signPetitionPageComponents_SignPetitionPage__ = __webpack_require__("HPm8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AboutUs',
  computed: {
    activeLanguage: function activeLanguage() {
      return this.$translations[this.$store.getters.currentLanguageValue];
    }
  },
  methods: {
    loadSignPetition: function loadSignPetition() {
      this.$store.commit('setCurrentView', __WEBPACK_IMPORTED_MODULE_0__signPetitionPageComponents_SignPetitionPage__["a" /* default */]);
      this.$router.push('/sign-petition');
    }
  }
});

/***/ }),

/***/ "jf0H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k+oK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rda.de2b272.jpg";

/***/ }),

/***/ "k9ZN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alpfoodway_background1_resized.02f3a61.jpg";

/***/ }),

/***/ "kHIP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kJZW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SupportersPage_vue__ = __webpack_require__("SqBM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7617754d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SupportersPage_vue__ = __webpack_require__("JGBB");
function injectStyle (ssrContext) {
  __webpack_require__("+vcn")
  __webpack_require__("s9eh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7617754d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SupportersPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7617754d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SupportersPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kSpF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kwnq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CountdownHeader'
});

/***/ }),

/***/ "l5zJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-mainHeader"},[_c('b-navbar',{staticClass:" bg-transparent",attrs:{"sticky":"","toggleable":"md","variant":"primary"}},[_c('b-navbar-toggle',{attrs:{"target":"nav_collapse"}}),_vm._v(" "),_c('b-navbar-brand',{staticClass:"home-brand",attrs:{"active":"","append":"","exact":"","replace":""}},[_c('a',{attrs:{"href":"http://www.alpine-space.eu/projects/alpfoodway/en/home","target":"_blank"}},[_c('img',{staticClass:"alp-logo",attrs:{"src":__webpack_require__("VynG")}})])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"nav_collapse","is-nav":""}},[_c('b-navbar-nav',{staticClass:"ml-auto f-navbar highlight",attrs:{"fill":"","justified":""}},[_c('b-nav-item',{class:{ active: _vm.isHomeActive},on:{"click":_vm.loadHome}},[_vm._v("\n          "+_vm._s(_vm.activeLanguage.home)+"\n        ")]),_vm._v(" "),_c('b-nav-item',{on:{"click":_vm.loadInventory}},[_vm._v("\n          "+_vm._s(_vm.activeLanguage.inventory)+"\n        ")]),_vm._v(" "),_c('b-nav-item',{class:{ active: _vm.isGalleryActive},on:{"click":_vm.loadGallery}},[_vm._v("\n          "+_vm._s(_vm.activeLanguage.gallery)+"\n        ")]),_vm._v(" "),_c('b-nav-item',{class:{ active: _vm.isEventsActive},on:{"click":_vm.loadEvents}},[_vm._v("\n          "+_vm._s(_vm.activeLanguage.events)+"\n        ")]),_vm._v(" "),_c('b-nav-item',{class:{ active: _vm.isSocialWallActive},on:{"click":_vm.loadSocialWall}},[_vm._v("\n          "+_vm._s(_vm.activeLanguage.socialWall)+"\n        ")]),_vm._v(" "),_c('b-nav-item',{class:{ active: _vm.isVideosActive},on:{"click":_vm.loadVideos}},[_vm._v("\n          "+_vm._s(_vm.activeLanguage.youtubeGallery)+"\n        ")]),_vm._v(" "),_c('b-nav-item',{class:{ active: _vm.isNewsActive},on:{"click":_vm.loadNews}},[_vm._v("\n          "+_vm._s(_vm.activeLanguage.news)+"\n        ")]),_vm._v(" "),_c('b-nav-item',{class:{ active: _vm.isSupportersActive},on:{"click":_vm.loadSupporters}},[_vm._v("\n          "+_vm._s(_vm.activeLanguage.supporters)+"\n        ")]),_vm._v(" "),_c('b-nav-item',{class:{ active: _vm.isPaperActive},on:{"click":_vm.loadPaper}},[_vm._v("\n          "+_vm._s(_vm.activeLanguage.theCarta)+"\n        ")]),_vm._v(" "),_c('b-nav-item',{class:{ active: _vm.isSignPetitionActive},attrs:{"id":"bordered-petition"},on:{"click":_vm.loadSignPetition}},[_vm._v("\n          "+_vm._s(_vm.activeLanguage.signPetition)+"\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "la/S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-paper-page"},[_c('div',{staticClass:"title-container"},[_c('h1',[_vm._v(_vm._s(_vm.activeLanguage.chartaContent.generalTitle))])]),_vm._v(" "),_c('div',{attrs:{"id":"carta-container"}},[_c('b-row',[_c('b-col',{staticClass:"charta-content",attrs:{"sm":"12","lg":"6"}},[_c('div',{staticClass:"paragraph-title section-title-left"},[_c('p',[_vm._v(_vm._s(_vm.activeLanguage.chartaContent.chapter1.title))])]),_vm._v(" "),_c('p',{staticClass:"paragraph-body"},[_vm._v("\n          "+_vm._s(_vm.activeLanguage.chartaContent.chapter1.text)+"\n        ")]),_vm._v(" "),(_vm.activeLanguage.chartaContent.chapter1.purposes)?[_c('ul',{staticClass:"text-left"},_vm._l((_vm.activeLanguage.chartaContent.chapter1.purposes),function(purpose,idx){return _c('li',{key:idx},[_vm._v("\n              "+_vm._s(purpose)+"\n            ")])}))]:_vm._e()],2),_vm._v(" "),_c('b-col',{staticClass:"charta-content",attrs:{"sm":"12","lg":"6"}},[_c('img',{attrs:{"src":__webpack_require__("k9ZN"),"alt":"AlpFoodway"}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSmallWindow),expression:"!isSmallWindow"}],staticClass:"charta-content",attrs:{"sm":"12","lg":"6"}},[_c('img',{attrs:{"src":__webpack_require__("omdU"),"alt":"AlpFoodway"}})]),_vm._v(" "),_c('b-col',{staticClass:"charta-content",attrs:{"sm":"12","lg":"6"}},[_c('div',{staticClass:"paragraph-title section-title-left"},[_c('p',[_vm._v(_vm._s(_vm.activeLanguage.chartaContent.chapter2.title))])]),_vm._v(" "),_c('p',{staticClass:"paragraph-body"},[_vm._v("\n          "+_vm._s(_vm.activeLanguage.chartaContent.chapter2.text)+"\n        ")])]),_vm._v(" "),_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSmallWindow),expression:"isSmallWindow"}],staticClass:"charta-content",attrs:{"sm":"12","lg":"6"}},[_c('img',{attrs:{"src":__webpack_require__("omdU"),"alt":"AlpFoodway"}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"charta-content",attrs:{"sm":"12","lg":"6"}},[_c('div',{staticClass:"paragraph-title section-title-left"},[_c('p',[_vm._v(_vm._s(_vm.activeLanguage.chartaContent.chapter3.title))])]),_vm._v(" "),_c('p',{staticClass:"paragraph-body"},[_vm._v("\n          "+_vm._s(_vm.activeLanguage.chartaContent.chapter3.text.p1)+"\n        ")]),_vm._v(" "),_c('p',{staticClass:"paragraph-body"},[_vm._v("\n          "+_vm._s(_vm.activeLanguage.chartaContent.chapter3.text.p2)+"\n        ")])]),_vm._v(" "),_c('b-col',{staticClass:"charta-content",attrs:{"sm":"12","lg":"6"}},[_c('img',{attrs:{"src":__webpack_require__("shP3"),"alt":"AlpFoodway"}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSmallWindow),expression:"!isSmallWindow"}],staticClass:"charta-content",attrs:{"sm":"12","lg":"6"}},[_c('img',{attrs:{"src":__webpack_require__("Y88W"),"alt":"AlpFoodway"}})]),_vm._v(" "),_c('b-col',{staticClass:"charta-content",attrs:{"sm":"12","lg":"6"}},[_c('p',{staticClass:"paragraph-body"},[_vm._v("\n          "+_vm._s(_vm.activeLanguage.chartaContent.chapter3.text.p3)+"\n        ")])]),_vm._v(" "),_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSmallWindow),expression:"isSmallWindow"}],staticClass:"charta-content",attrs:{"sm":"12","lg":"6"}},[_c('img',{attrs:{"src":__webpack_require__("Y88W"),"alt":"AlpFoodway"}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"charta-content",attrs:{"sm":"12","lg":"6"}},[_c('div',{staticClass:"paragraph-title section-title-left"},[_c('p',[_vm._v(_vm._s(_vm.activeLanguage.chartaContent.chapter4.title))])]),_vm._v(" "),_c('p',{staticClass:"paragraph-body"},[_vm._v("\n          "+_vm._s(_vm.activeLanguage.chartaContent.chapter4.text.p1)+"\n        ")]),_vm._v(" "),_c('p',{staticClass:"paragraph-body"},[_vm._v("\n          "+_vm._s(_vm.activeLanguage.chartaContent.chapter4.text.p2)+"\n        ")])]),_vm._v(" "),_c('b-col',{staticClass:"charta-content",attrs:{"sm":"12","lg":"6"}},[_c('img',{attrs:{"src":__webpack_require__("WWdp"),"alt":"AlpFoodway"}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSmallWindow),expression:"!isSmallWindow"}],staticClass:"charta-content",attrs:{"sm":"12","lg":"6"}},[_c('img',{attrs:{"src":__webpack_require__("O5be"),"alt":"AlpFoodway"}})]),_vm._v(" "),_c('b-col',{staticClass:"charta-content",attrs:{"sm":"12","lg":"6"}},[_c('div',{staticClass:"paragraph-title section-title-left"},[_c('p',[_vm._v(_vm._s(_vm.activeLanguage.chartaContent.chapter5.title))])]),_vm._v(" "),_c('p',{staticClass:"paragraph-body"},[_vm._v("\n          "+_vm._s(_vm.activeLanguage.chartaContent.chapter5.text.p1)+"\n        ")])]),_vm._v(" "),_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSmallWindow),expression:"isSmallWindow"}],staticClass:"charta-content",attrs:{"sm":"12","lg":"6"}},[_c('img',{attrs:{"src":__webpack_require__("O5be"),"alt":"AlpFoodway"}})])],1),_vm._v(" "),_vm._l((_vm.activeLanguage.chartaContent.chapter5.text.uls),function(ul,ul_index){return [_c('b-row',[(ul_index % 2 === 1 && !_vm.isSmallWindow)?_c('b-col',{staticClass:"charta-content",attrs:{"sm":"12","lg":"6"}},[_c('img',{attrs:{"src":_vm.imagePath(ul_index),"alt":"AlpFoodway"}})]):_vm._e(),_vm._v(" "),_c('b-col',{staticClass:"charta-content",attrs:{"sm":"12","lg":"6"}},[_c('p',{key:ul_index,staticClass:"as-people-style"},[_vm._v("\n            "+_vm._s(ul.title)+"\n          ")]),_vm._v(" "),_c('ul',{staticClass:"text-left"},_vm._l((ul.lis),function(li,index){return _c('li',{key:index},[_vm._v("\n              "+_vm._s(li)+"\n            ")])}))]),_vm._v(" "),(!(ul_index % 2 === 1) || _vm.isSmallWindow)?_c('b-col',{staticClass:"charta-content",attrs:{"sm":"12","lg":"6"}},[_c('img',{attrs:{"src":_vm.imagePath(ul_index),"alt":"AlpFoodway"}})]):_vm._e()],1)]}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"charta-content",attrs:{"sm":"12","lg":"6"}},[_c('img',{attrs:{"src":__webpack_require__("Cl5c"),"alt":"AlpFoodway"}})]),_vm._v(" "),_c('b-col',{staticClass:"charta-content",attrs:{"sm":"12","lg":"6"}},[_c('div',{staticClass:"paragraph-title section-title-left"},[_c('p',[_vm._v(_vm._s(_vm.activeLanguage.chartaContent.chapter6.title))])]),_vm._v(" "),_c('p',{staticClass:"paragraph-body"},[_vm._v("\n          "+_vm._s(_vm.activeLanguage.chartaContent.chapter6.text.p1)+"\n        ")]),_vm._v(" "),_c('p',{staticClass:"paragraph-body"},[_vm._v("\n          "+_vm._s(_vm.activeLanguage.chartaContent.chapter6.text.p2)+"\n        ")])])],1),_vm._v(" "),_c('p',{staticClass:"paragraph-body text-center stress"},[_vm._v("\n      "+_vm._s(_vm.activeLanguage.chartaContent.catchPhrase)+"\n    ")]),_vm._v(" "),_c('b-row',{key:"submitButton",staticClass:"my-3 button-align"},[_c('b-col',{attrs:{"sm":"12"}},[_c('b-button',{attrs:{"id":"signButton"},on:{"click":_vm.loadSignPetition}},[_vm._v(_vm._s(_vm.activeLanguage.signPetition))])],1)],1)],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m6FR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ErrorPage'
});

/***/ }),

/***/ "mKQ9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OtherSupporters_vue__ = __webpack_require__("SfCl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63512b6c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OtherSupporters_vue__ = __webpack_require__("1dLw");
function injectStyle (ssrContext) {
  __webpack_require__("0IXM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63512b6c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OtherSupporters_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63512b6c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OtherSupporters_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mjNv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/brel.eda4443.jpg";

/***/ }),

/***/ "mw6x":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lombardy-region.f933f50.jpg";

/***/ }),

/***/ "n//d":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/european-year.9db16e4.png";

/***/ }),

/***/ "nFiQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartaHeader_vue__ = __webpack_require__("cUtD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4436c788_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartaHeader_vue__ = __webpack_require__("N/Zt");
function injectStyle (ssrContext) {
  __webpack_require__("pjiR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4436c788"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartaHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4436c788_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartaHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nFoH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-homePage"},[_c('images-carousel'),_vm._v(" "),_c('CartaHeader',{staticClass:"top-spacing"}),_vm._v(" "),_c('about-us',{staticClass:"top-spacing"}),_vm._v(" "),_c('statistics',{staticClass:"top-spacing"}),_vm._v(" "),_c('events',{staticClass:"top-spacing"}),_vm._v(" "),_c('news',{staticClass:"top-spacing"}),_vm._v(" "),_c('social-wall',{staticClass:"top-spacing"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nlKv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oBgS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__ = __webpack_require__("iXLo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_countup_v2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ValueSlider',
  components: {
    ICountUp: __WEBPACK_IMPORTED_MODULE_0_vue_countup_v2___default.a
  },
  props: {
    startCount: {
      type: String
    },
    endCount: {
      type: String
    },
    durationTime: {
      type: String
    },
    decrementVal: {
      type: String
    },
    counterMode: {
      type: String
    },
    title: {
      type: String
    },
    subTitle: {
      type: String
    }
  },
  data: function data() {
    return {
      startVal: Number(this.startCount),
      endVal: Number(this.endCount) - Number(this.decrementVal || 0),
      decimals: 0,
      duration: Number(this.durationTime),
      options: {
        useEasing: true,
        useGrouping: true,
        separator: ',',
        decimal: '.',
        prefix: '',
        suffix: ''
      }
    };
  },

  methods: {
    onReady: function onReady(instance) {
      switch (this.counterMode) {
        case 'fakeIncrementer':
          this.fakeIncrementer(instance);
          break;
        default:
          return;
      }
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    fakeIncrementer: function fakeIncrementer(instance) {
      var self = this;
      var offset = this.getRandomInt(1, 10);
      setInterval(function () {
        if (self.endVal > self.endCount) return;
        instance.update(self.endVal + offset);
        offset += self.getRandomInt(1, 10);
      }, self.getRandomInt(1000, 4000));
    }
  }
});

/***/ }),

/***/ "oD+E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ThankYouModal',
  data: function data() {
    return {
      petitionerName: '',
      isMobile: this.$store.getters.isMobileValue,
      hasNotShared: ''
    };
  },

  methods: {
    showModal: function showModal(petitionerName) {
      this.petitionerName = petitionerName;
      this.$refs.panelWindowRef.show();
      this.hasNotShared = true;
    },
    hideModal: function hideModal() {
      this.$refs.panelWindowRef.hide();
    },
    emitClosing: function emitClosing() {
      this.$emit('closeModal');
    },
    hasShared: function hasShared(el) {
      if (el.target.childNodes[0] !== undefined) {
        this.eventFire(el.target.childNodes[0], 'click');
      }
      this.hasNotShared = false;
    },
    eventFire: function eventFire(el, etype) {
      if (el.fireEvent) {
        el.fireEvent('on' + etype);
      } else {
        var evObj = document.createEvent('Events');
        evObj.initEvent(etype, true, false);
        el.dispatchEvent(evObj);
      }
    }
  },
  mounted: function mounted() {
    if (!this.isMobile) {
      var whatsappWrapper = document.getElementsByClassName('whatsapp-wrapper')[0];
      whatsappWrapper.style.backgroundColor = 'rgb(73,82,70)';
      whatsappWrapper.style.cursor = 'not-allowed';
      var whatsappIcon = document.getElementsByClassName('whatsapp-icon')[0];
      whatsappIcon.style.cursor = 'not-allowed';
    }
  },

  computed: {
    activeLanguage: function activeLanguage() {
      return this.$translations[this.$store.getters.currentLanguageValue];
    }
  }
});

/***/ }),

/***/ "omdU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alpfoodway_background2_resized.bfd01fb.jpg";

/***/ }),

/***/ "oqCe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "osDI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialWall_vue__ = __webpack_require__("N4kB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2531b6fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialWall_vue__ = __webpack_require__("aDRB");
function injectStyle (ssrContext) {
  __webpack_require__("3cDv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2531b6fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialWall_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2531b6fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialWall_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ovMi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SignCaption',
  computed: {
    activeLanguage: function activeLanguage() {
      var currLang = this.$translations[this.$store.getters.currentLanguageValue];
      if (currLang.captionText) {
        return this.$translations[this.$store.getters.currentLanguageValue];
      } else {
        return this.$translations['English'];
      }
    }
  }
});

/***/ }),

/***/ "p12r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PrivacyPolicyModal',
  computed: {
    activeLanguage: function activeLanguage() {
      var currLang = this.$translations[this.$store.getters.currentLanguageValue];
      if (currLang.privacyPolicy) {
        return this.$translations[this.$store.getters.currentLanguageValue];
      } else {
        return this.$translations['English'];
      }
    }
  },
  methods: {
    showModal: function showModal() {
      this.$refs.privacyPolicyModal.show();
    },
    hideModal: function hideModal() {
      this.$refs.privacyPolicyModal.hide();
    }
  },
  mounted: function mounted() {
    document.getElementById('privacyPolicyModal___BV_modal_header_').setAttribute('style', 'background-color: #c41c21 !important; color: white !important;');
    document.getElementById('privacyPolicyModal___BV_modal_header_').lastChild.setAttribute('style', 'color: white !important;');
  }
});

/***/ }),

/***/ "pHbe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__socialsPageComponents_SocialWallPage__ = __webpack_require__("cxkx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__supportersPageComponents_SupportersPage__ = __webpack_require__("kJZW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__signPetitionPageComponents_SignPetitionPage__ = __webpack_require__("HPm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_odometer__ = __webpack_require__("r98d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_odometer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_odometer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_odometer_themes_odometer_theme_default_css__ = __webpack_require__("kSpF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_odometer_themes_odometer_theme_default_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_odometer_themes_odometer_theme_default_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Statistics',
  components: { IOdometer: __WEBPACK_IMPORTED_MODULE_3_vue_odometer___default.a },
  data: function data() {
    return {
      supportersNumber: 14,
      signsNumber: 0,
      socialContentsNumber: 0
    };
  },

  computed: {
    activeLanguage: function activeLanguage() {
      return this.$translations[this.$store.getters.currentLanguageValue];
    },
    areEnoughSigns: function areEnoughSigns() {
      return this.signsNumber >= 1000;
    }
  },
  methods: {
    loadSocialWall: function loadSocialWall() {
      this.$store.commit('setCurrentView', __WEBPACK_IMPORTED_MODULE_0__socialsPageComponents_SocialWallPage__["a" /* default */]);
      this.$router.push('/social-wall');
    },
    loadSupporters: function loadSupporters() {
      this.$store.commit('setCurrentView', __WEBPACK_IMPORTED_MODULE_1__supportersPageComponents_SupportersPage__["a" /* default */]);
      this.$router.push('/supporters');
    },
    loadSignPetition: function loadSignPetition() {
      this.$store.commit('setCurrentView', __WEBPACK_IMPORTED_MODULE_2__signPetitionPageComponents_SignPetitionPage__["a" /* default */]);
      this.$router.push('/sign-petition');
    },
    fetchStatistics: function fetchStatistics() {
      var self = this;
      this.$http.get(this.$PATH_NAME + 'statistics/homePage/').then(function (response) {
        if (response.status === 200) {
          self.signsNumber = response.body.statistics.signatures;
          self.socialContentsNumber = response.body.statistics.posts;
          self.supportersNumber = response.body.statistics.supporters;
        }
      });
    }
  },
  mounted: function mounted() {
    this.fetchStatistics();
  }
});

/***/ }),

/***/ "pLyr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/NRP.c1668b7.jpg";

/***/ }),

/***/ "pYJd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alpfoodway_background10_resized.fe89821.jpg";

/***/ }),

/***/ "pjiR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pzmR":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./alpfoodway_background1_resized.jpg": "58Na",
	"./alpfoodway_background2_resized.jpg": "MHDp",
	"./alpfoodway_background3_resized.jpg": "R+iC",
	"./alpfoodway_background4_resized.jpg": "Lsmu",
	"./alpfoodway_background5_resized.jpg": "XjtJ",
	"./alpfoodway_background6_resized.jpg": "zcxf"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "pzmR";

/***/ }),

/***/ "q/1w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValueSlider_vue__ = __webpack_require__("oBgS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d876a0f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValueSlider_vue__ = __webpack_require__("gFFt");
function injectStyle (ssrContext) {
  __webpack_require__("3I5K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d876a0f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValueSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d876a0f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValueSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q3Pw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qDsY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-signCaption"},[_c('div',{staticClass:"title-container"},[_c('h1',[_vm._v(_vm._s(_vm.activeLanguage.whySign))])]),_vm._v(" "),_c('div',{attrs:{"id":"captionText"}},[_c('p',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.activeLanguage.captionTitleSign))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.activeLanguage.captionText.p1))]),_vm._v(" "),_c('ul',_vm._l((_vm.activeLanguage.captionText.reasons),function(reason,idx){return _c('li',{key:idx},[_vm._v("\n        "+_vm._s(reason)+"\n      ")])})),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.activeLanguage.captionText.p2))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qFvX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticStyle:{"max-width":"285px !important"},attrs:{"target":"_blank","href":_vm.newsUrl}},[_c('div',{staticClass:"f-newsCard embeddedPost-post"},[_c('div',{class:_vm.getBodyClass},[(_vm.source === 'YouTube')?_c('div',{staticStyle:{"width":"25%"}},[_c('svg',{staticClass:"style-scope ytd-topbar-logo-renderer",staticStyle:{"pointer-events":"none","display":"block","width":"100%","height":"100%"},attrs:{"viewBox":"0 0 200 60","preserveAspectRatio":"xMidYMid meet","focusable":"false"}},[_c('g',{staticClass:"style-scope ytd-topbar-logo-renderer",attrs:{"viewBox":"0 0 200 60","preserveAspectRatio":"xMidYMid meet"}},[_c('g',{staticClass:"style-scope ytd-topbar-logo-renderer"},[_c('path',{staticClass:"style-scope ytd-topbar-logo-renderer",attrs:{"fill":"#FF0000","d":"M63,14.87c-0.72-2.7-2.85-4.83-5.56-5.56C52.54,8,32.88,8,32.88,8S13.23,8,8.32,9.31\n          c-2.7,0.72-4.83,2.85-5.56,5.56C1.45,19.77,1.45,30,1.45,30s0,10.23,1.31,15.13c0.72,2.7,2.85,4.83,5.56,5.56\n          C13.23,52,32.88,52,32.88,52s19.66,0,24.56-1.31c2.7-0.72,4.83-2.85,5.56-5.56C64.31,40.23,64.31,30,64.31,30\n          S64.31,19.77,63,14.87z"}}),_vm._v(" "),_c('polygon',{staticClass:"style-scope ytd-topbar-logo-renderer",attrs:{"fill":"#FFFFFF","points":"26.6,39.43 42.93,30 26.6,20.57"}})]),_vm._v(" "),_c('g',{staticClass:"style-scope ytd-topbar-logo-renderer"},[_c('g',{staticClass:"style-scope ytd-topbar-logo-renderer",attrs:{"id":"youtube-paths"}},[_c('path',{staticClass:"style-scope ytd-topbar-logo-renderer",attrs:{"fill":"#282828","d":"M92.69,48.03c-1.24-0.84-2.13-2.14-2.65-3.91c-0.52-1.77-0.79-4.12-0.79-7.06v-4\n            c0-2.97,0.3-5.35,0.9-7.15c0.6-1.8,1.54-3.11,2.81-3.93c1.27-0.82,2.94-1.24,5.01-1.24c2.04,0,3.67,0.42,4.9,1.26\n            c1.23,0.84,2.13,2.15,2.7,3.93c0.57,1.78,0.85,4.16,0.85,7.12v4c0,2.94-0.28,5.3-0.83,7.08c-0.55,1.78-1.45,3.09-2.7,3.91\n            c-1.24,0.82-2.93,1.24-5.06,1.24C95.65,49.29,93.93,48.87,92.69,48.03z M99.66,43.71c0.34-0.9,0.52-2.37,0.52-4.4v-8.59\n            c0-1.98-0.17-3.42-0.52-4.34c-0.34-0.91-0.95-1.37-1.82-1.37c-0.84,0-1.43,0.46-1.78,1.37c-0.34,0.91-0.52,2.36-0.52,4.34v8.59\n            c0,2.04,0.16,3.51,0.49,4.4c0.33,0.9,0.93,1.35,1.8,1.35C98.71,45.06,99.31,44.61,99.66,43.71z"}}),_vm._v(" "),_c('path',{staticClass:"style-scope ytd-topbar-logo-renderer",attrs:{"fill":"#282828","d":"M188.16,37.13v1.39c0,1.77,0.05,3.09,0.16,3.98c0.1,0.88,0.32,1.53,0.65,1.93\n            c0.33,0.4,0.84,0.61,1.53,0.61c0.93,0,1.57-0.36,1.91-1.08c0.34-0.72,0.53-1.92,0.56-3.6l5.35,0.31\n            c0.03,0.24,0.04,0.57,0.04,0.99c0,2.55-0.7,4.45-2.09,5.71c-1.39,1.26-3.36,1.89-5.91,1.89c-3.06,0-5.2-0.96-6.43-2.88\n            c-1.23-1.92-1.84-4.88-1.84-8.9v-4.81c0-4.14,0.64-7.15,1.91-9.06c1.27-1.9,3.45-2.85,6.54-2.85c2.13,0,3.76,0.39,4.9,1.17\n            c1.14,0.78,1.94,1.99,2.41,3.64c0.46,1.65,0.7,3.93,0.7,6.83v4.72H188.16z M188.95,25.53c-0.31,0.39-0.52,1.03-0.63,1.91\n            c-0.11,0.88-0.16,2.23-0.16,4.02v1.98h4.54v-1.98c0-1.77-0.06-3.11-0.18-4.02c-0.12-0.91-0.34-1.56-0.65-1.93\n            c-0.31-0.37-0.8-0.56-1.46-0.56C189.75,24.94,189.26,25.14,188.95,25.53z"}}),_vm._v(" "),_c('path',{staticClass:"style-scope ytd-topbar-logo-renderer",attrs:{"fill":"#282828","d":"M77.59,36.61l-7.06-25.49h6.16l2.47,11.55c0.63,2.85,1.09,5.27,1.39,7.28h0.18\n            c0.21-1.44,0.67-3.85,1.39-7.24l2.56-11.6h6.16L83.7,36.61v12.23h-6.11V36.61z"}}),_vm._v(" "),_c('path',{staticClass:"style-scope ytd-topbar-logo-renderer",attrs:{"fill":"#282828","d":"M126.45,21.28v27.55h-4.85l-0.54-3.37h-0.13c-1.32,2.55-3.3,3.82-5.93,3.82c-1.83,0-3.18-0.6-4.05-1.8\n            c-0.87-1.2-1.3-3.07-1.3-5.62V21.28h6.2v20.23c0,1.23,0.13,2.11,0.4,2.63c0.27,0.52,0.72,0.79,1.35,0.79\n            c0.54,0,1.06-0.16,1.55-0.49c0.49-0.33,0.86-0.75,1.1-1.26V21.28H126.45z"}}),_vm._v(" "),_c('path',{staticClass:"style-scope ytd-topbar-logo-renderer",attrs:{"fill":"#282828","d":"M158.27,21.28v27.55h-4.85l-0.54-3.37h-0.13c-1.32,2.55-3.3,3.82-5.93,3.82c-1.83,0-3.18-0.6-4.05-1.8\n            c-0.87-1.2-1.3-3.07-1.3-5.62V21.28h6.2v20.23c0,1.23,0.13,2.11,0.4,2.63c0.27,0.52,0.72,0.79,1.35,0.79\n            c0.54,0,1.06-0.16,1.55-0.49c0.49-0.33,0.86-0.75,1.1-1.26V21.28H158.27z"}}),_vm._v(" "),_c('path',{staticClass:"style-scope ytd-topbar-logo-renderer",attrs:{"fill":"#282828","d":"M143.31,16.11h-6.16v32.72h-6.07V16.11h-6.16v-4.99h18.38V16.11z"}}),_vm._v(" "),_c('path',{staticClass:"style-scope ytd-topbar-logo-renderer",attrs:{"fill":"#282828","d":"M178.8,25.69c-0.38-1.74-0.98-3-1.82-3.78c-0.84-0.78-1.99-1.17-3.46-1.17c-1.14,0-2.2,0.32-3.19,0.97\n            c-0.99,0.64-1.75,1.49-2.29,2.54h-0.05l0-14.52h-5.98v39.11h5.12l0.63-2.61h0.13c0.48,0.93,1.2,1.66,2.16,2.2\n            c0.96,0.54,2.02,0.81,3.19,0.81c2.1,0,3.64-0.97,4.63-2.9c0.99-1.93,1.48-4.95,1.48-9.06v-4.36\n            C179.36,29.84,179.17,27.43,178.8,25.69z M173.11,36.93c0,2.01-0.08,3.58-0.25,4.72c-0.16,1.14-0.44,1.95-0.83,2.43\n            c-0.39,0.48-0.91,0.72-1.57,0.72c-0.51,0-0.98-0.12-1.42-0.36c-0.43-0.24-0.79-0.6-1.06-1.08V27.71\n            c0.21-0.75,0.57-1.36,1.08-1.84c0.51-0.48,1.06-0.72,1.66-0.72c0.63,0,1.12,0.25,1.46,0.74c0.34,0.49,0.58,1.33,0.72,2.49\n            c0.13,1.17,0.2,2.83,0.2,4.99V36.93z"}})])])])])]):_vm._e(),_vm._v(" "),(_vm.imageUrl)?_c('div',{class:_vm.getCardClass},[_c('img',{staticClass:"post-image",attrs:{"src":_vm.imageUrl}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 postAuthor"},[_c('span',{staticClass:"postAuthor-name identity-name",attrs:{"title":_vm.title}},[_vm._v("\n                "+_vm._s(_vm.title)+"\n              ")])])])])]),_vm._v(" "),_c('div',{staticClass:"post-metadata dateline"},[_c('a',{staticClass:"u-linkBlend u-url customisable-highlight long-permalink",attrs:{"data-datetime":"2017-04-06T15:24:15+0000","data-scribe":"element:full_timestamp","data-url-ref-attrs-injected":"true"}},[_c('p',{staticClass:"dt-updated post-alert",staticStyle:{"float":"left","padding-bottom":"0"},attrs:{"title":"Time posted"}},[_vm._v("\n            "+_vm._s(_vm._f("moment")(_vm.createdAtMoment,'MMMM D, YYYY'))+"\n          ")])])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"post-text text-justify",attrs:{"dir":"ltr"}},[_vm._v(_vm._s(_vm.description))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qK1A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qLdU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideosPage_vue__ = __webpack_require__("U7Oc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_076a0068_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideosPage_vue__ = __webpack_require__("+iZI");
function injectStyle (ssrContext) {
  __webpack_require__("oqCe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-076a0068"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideosPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_076a0068_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideosPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qb6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qci1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qgrV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qxbl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/polo-poschiavo.c39cc25.jpg";

/***/ }),

/***/ "r7S6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_odometer__ = __webpack_require__("r98d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_odometer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_odometer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_odometer_themes_odometer_theme_default_css__ = __webpack_require__("kSpF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_odometer_themes_odometer_theme_default_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_odometer_themes_odometer_theme_default_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SignaturesCounter',
  components: { IOdometer: __WEBPACK_IMPORTED_MODULE_0_vue_odometer___default.a },
  data: function data() {
    return {
      signatures: 0,
      signaturesMaxBound: 0,
      max: 3000,
      signaturesForProgress: 0,
      effectiveSignatures: 0
    };
  },

  computed: {
    activeLanguage: function activeLanguage() {
      return this.$translations[this.$store.getters.currentLanguageValue];
    },
    petitionSignatures: function petitionSignatures() {
      return this.signaturesForProgress;
    },
    maxToString: function maxToString() {
      return this.max.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  },
  methods: {
    loadPetitionSigns: function loadPetitionSigns() {
      var _this = this;

      var self = this;
      this.$http.get(this.$PATH_NAME + 'statistics/petitionPage/').then(function (response) {
        if (response.status === 200) {
          _this.slowAnimateProgress(response.body.statistics.signatures);
          _this.effectiveSignatures = response.body.statistics.signatures;
          _this.setMaxGoal();
          setTimeout(function () {
            if (response.body.statistics.signatures > 30 && response.body.statistics.signatures >= 1000) {
              self.signatures = response.body.statistics.signatures - 30;
            } else if (response.body.statistics.signatures < 1000) {
              self.signatures = response.body.statistics.signatures - 15;
            } else {
              self.signatures = response.body.statistics.signatures;
            }
            self.signaturesMaxBound = response.body.statistics.signatures;
            setTimeout(function () {
              self.counterIncrementer();
            }, 500);
          }, 200);
        }
      });
    },
    slowAnimateProgress: function slowAnimateProgress(signatures) {
      var repetitions = 15;
      var slice = signatures / repetitions;
      var self = this;
      this.setIntervalX(function () {
        self.signaturesForProgress += slice;
      }, 100, repetitions);
    },
    setIntervalX: function setIntervalX(callback, delay, repetitions) {
      var x = 0;
      var intervalID = window.setInterval(function () {
        callback();

        if (++x === repetitions) {
          window.clearInterval(intervalID);
        }
      }, delay);
    },
    setMaxGoal: function setMaxGoal() {
      while (this.effectiveSignatures - this.max >= 0) {
        this.max += 3000;
      }
    },
    counterIncrementer: function counterIncrementer() {
      if (this.signatures < this.signaturesMaxBound) {
        var that = this;
        var randomRepetition = Math.floor(Math.random() * (3000 - 1500 + 1)) + 1500;
        setTimeout(function () {
          that.signatures += Math.floor(Math.random() * (3 - 1 + 1)) + 1;
          that.counterIncrementer();
        }, randomRepetition);
      }
    }
  },
  mounted: function mounted() {
    this.loadPetitionSigns();
  }
});

/***/ }),

/***/ "rBvK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainHeader_vue__ = __webpack_require__("yt4F");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41ef1f7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainHeader_vue__ = __webpack_require__("l5zJ");
function injectStyle (ssrContext) {
  __webpack_require__("ES+L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-41ef1f7c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41ef1f7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rMqX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'WinnersModal',
  computed: {
    activeLanguage: function activeLanguage() {
      var currLang = this.$translations[this.$store.getters.currentLanguageValue];
      if (currLang.regulationsItems) {
        return this.$translations[this.$store.getters.currentLanguageValue];
      } else {
        return this.$translations['Italian'];
      }
    }
  },
  methods: {
    showModal: function showModal() {
      this.$refs.winnersModal.show();
    },
    hideModal: function hideModal() {
      this.$refs.winnersModal.hide();
    }
  },
  mounted: function mounted() {
    document.getElementById('winnersModal___BV_modal_header_').setAttribute('style', 'background-color: #c41c21 !important; color: white !important;');
    document.getElementById('winnersModal___BV_modal_header_').lastChild.setAttribute('style', 'color: white !important;');
  }
});

/***/ }),

/***/ "rOPM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ruDj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tsm.17c9626.jpg";

/***/ }),

/***/ "s9eh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sBQ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sH5r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaperPage_vue__ = __webpack_require__("Dfce");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330da34c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaperPage_vue__ = __webpack_require__("la/S");
function injectStyle (ssrContext) {
  __webpack_require__("hBPS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-330da34c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaperPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330da34c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaperPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sHBF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.areEnoughSigns),expression:"areEnoughSigns"}],staticClass:"f-statistics"},[_c('h2',{staticClass:"title-container"},[_vm._v(_vm._s(_vm.activeLanguage.statistics))]),_vm._v(" "),_c('b-row',{staticClass:"justify-content-md-center section",attrs:{"align-h":"center"}},[_c('b-col',[_c('div',{staticClass:"supporters-icon icon",on:{"click":_vm.loadSupporters}}),_vm._v(" "),_c('p',{staticClass:"counterStyle"},[_c('IOdometer',{attrs:{"value":_vm.supportersNumber}})],1),_vm._v(" "),_c('p',{staticClass:"counterSubStyle"},[_vm._v(_vm._s(_vm.activeLanguage.supporters))])]),_vm._v(" "),_c('b-col',[_c('div',{staticClass:"signs-icon icon",on:{"click":_vm.loadSignPetition}}),_vm._v(" "),_c('p',{staticClass:"counterStyle"},[_c('IOdometer',{attrs:{"value":_vm.signsNumber}})],1),_vm._v(" "),_c('p',{staticClass:"counterSubStyle"},[_vm._v(_vm._s(_vm.activeLanguage.signs))])]),_vm._v(" "),_c('b-col',[_c('div',{staticClass:"social-icon icon",on:{"click":_vm.loadSocialWall}}),_vm._v(" "),_c('p',{staticClass:"counterStyle"},[_c('IOdometer',{attrs:{"value":_vm.socialContentsNumber}})],1),_vm._v(" "),_c('p',{staticClass:"counterSubStyle"},[_vm._v(_vm._s(_vm.activeLanguage.socialContents))])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sOzK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/match_logo.b048250.png";

/***/ }),

/***/ "sTpp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorPage_vue__ = __webpack_require__("m6FR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fcee1e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorPage_vue__ = __webpack_require__("fzgl");
function injectStyle (ssrContext) {
  __webpack_require__("sBQ7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8fcee1e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fcee1e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "shP3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alpfoodway_background3_resized.dd6b42f.jpg";

/***/ }),

/***/ "si9r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WinnersModal_vue__ = __webpack_require__("rMqX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_187f36e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WinnersModal_vue__ = __webpack_require__("7EGA");
function injectStyle (ssrContext) {
  __webpack_require__("J1JE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-187f36e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WinnersModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_187f36e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WinnersModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "skj6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/crepa.3c53986.jpg";

/***/ }),

/***/ "tC7f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignCaption_vue__ = __webpack_require__("ovMi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a121f7ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignCaption_vue__ = __webpack_require__("qDsY");
function injectStyle (ssrContext) {
  __webpack_require__("nlKv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a121f7ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignCaption_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a121f7ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignCaption_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tIw/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/match_logo.b048250.png";

/***/ }),

/***/ "tLpT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tdpW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-languageHeader bg-dark shrink",attrs:{"id":"languageHeader"}},[_c('div',{attrs:{"id":"container-menu"}},[_c('b-row',{attrs:{"id":"container-menu","no-gutters":""}},[_c('b-col',{class:[{'col-11': _vm.isSmallWindow}, {'col-9': !_vm.isSmallWindow}]},[_c('b-nav',{class:[{'min-fontsize': _vm.isSmallWindow}, "f-navbar", "highlight"],attrs:{"tabs":""}},[_c('b-nav-item',{class:{ active: _vm.isItalianActive},on:{"click":_vm.setItalianLanguage}},[_vm._v("\n            "+_vm._s(_vm.rightLengthItalianLanguage)+"\n          ")]),_vm._v(" "),_c('b-nav-item',{class:{ active: _vm.isEnglishActive},on:{"click":_vm.setEnglishLanguage}},[_vm._v("\n            "+_vm._s(_vm.rightLengthEnglishLanguage)+"\n          ")]),_vm._v(" "),_c('b-nav-item',{class:{ active: _vm.isGermanActive},on:{"click":_vm.setGermanLanguage}},[_vm._v("\n            "+_vm._s(_vm.rightLengthGermanLanguage)+"\n          ")]),_vm._v(" "),_c('b-nav-item',{class:{ active: _vm.isFrenchActive},on:{"click":_vm.setFrenchLanguage}},[_vm._v("\n            "+_vm._s(_vm.rightLengthFrenchLanguage)+"\n          ")]),_vm._v(" "),_c('b-nav-item',{class:{ active: _vm.isSlovenianActive},on:{"click":_vm.setSlovenianLanguage}},[_vm._v("\n            "+_vm._s(_vm.rightLengthSlovenianLanguage)+"\n          ")])],1)],1),_vm._v(" "),_c('b-col',{class:[{'col-1': _vm.isSmallWindow}, {'col-3': !_vm.isSmallWindow}]},[_c('b-nav',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSmallWindow),expression:"!isSmallWindow"}],staticClass:"f-navbar icons",staticStyle:{"margin-left":"-20%"},attrs:{"tabs":""}},[_c('b-nav-item',{staticClass:"label-wrapper",on:{"click":_vm.loadSocialWall}},[_c('p',{staticClass:"label"},[_vm._v("\n            #AlpFoodway")])]),_vm._v(" "),_c('b-nav-item',{staticClass:"facebook",attrs:{"target":"_blank","href":"http://www.facebook.com/alpfoodway/"}}),_vm._v(" "),_c('b-nav-item',{staticClass:"instagram",attrs:{"target":"_blank","href":"https://www.instagram.com/alpfoodway_project/"}}),_vm._v(" "),_c('b-nav-item',{staticClass:"twitter",attrs:{"target":"_blank","href":"https://twitter.com/AlpFoodway"}}),_vm._v(" "),_c('b-nav-item',{staticClass:"linkedin",attrs:{"target":"_blank","href":"https://www.linkedin.com/in/alpfoodway-project-alpine-space-88a362139/"}}),_vm._v(" "),_c('b-nav-item',{staticClass:"youtube",staticStyle:{"margin-top":"5px"},attrs:{"target":"_blank","href":"https://www.youtube.com/channel/UCwctGbI6DSxE_peLz2wRmMQ/featured/"}})],1),_vm._v(" "),_c('b-nav',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSmallWindow),expression:"isSmallWindow"}],staticClass:"f-navbar icons",attrs:{"tabs":""}},[_c('b-nav-item',{staticClass:"social-icon",on:{"click":_vm.loadSocialsModal}})],1)],1)],1)],1),_vm._v(" "),_c('socials-modal',{ref:"SocialsModalExt"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "teHs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EventCard',
  data: function data() {
    return {
      iconStyle: 'icon icon-verified',
      city: '',
      link: '',
      country: '',
      title: '',
      datePublished: '',
      description: '',
      type: ''
    };
  },

  props: {
    postContent: {
      type: Object
    }
  },
  computed: {
    eventUrl: function eventUrl() {
      return this.link;
    },
    createdAtMoment: function createdAtMoment() {
      if (this.datePublished) {
        var s = this.$moment(this.datePublished);
        if (s.isValid()) {
          return s;
        }
      }
      return this.$moment();
    },
    giveClassFromType: function giveClassFromType() {
      return 'icon ' + this.type;
    }
  },
  methods: {
    initializeFields: function initializeFields() {
      this.city = this.postContent.city;
      this.link = this.postContent.link;
      this.country = this.postContent.country;
      this.title = this.postContent.title;
      this.datePublished = this.postContent.datePublished;
      this.description = this.postContent.description;
      this.type = this.postContent.type;
    }
  },
  mounted: function mounted() {
    this.initializeFields();
  }
});

/***/ }),

/***/ "trBh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-discoverAlpfoodway"},[_c('b-modal',{ref:"discoverAlpfoodway",attrs:{"id":"discoverAlpfoodway","size":"lg","title":"Discover AlpFoodway"}},[_c('img',{attrs:{"src":__webpack_require__("LPd/")}}),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-button',{staticClass:"button-style-grey float-right",on:{"click":_vm.hideModal}},[_vm._v("Close")]),_vm._v(" "),_c('a',{attrs:{"href":"../../../../../static/img/poster.pdf","download":""}},[_c('b-button',{staticClass:"button-style float-left"},[_vm._v("Download the poster")])],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uCeh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AboutUsModal',
  computed: {
    activeLanguage: function activeLanguage() {
      return this.$translations[this.$store.getters.currentLanguageValue];
    }
  },
  methods: {
    showModal: function showModal() {
      this.$refs.aboutUsModal.show();
    },
    hideModal: function hideModal() {
      this.$refs.aboutUsModal.hide();
    },
    expandModal: function expandModal() {
      document.getElementById('captionText').innerHTML += '"Depopulation, ageing population and globalization put Alpine food heritage at risk of disappearing. The project will create a sustainable development model for peripheral mountain areas based on the preservation/valorization of Alpine Space cultural food heritage and on the adoption of innovative marketing and governance tools. It will also foster the emerging of a transnational alpine identity based on the common cultural values expressed in food heritage. Project outputs include Vision Paper, Value Charta, mapping of traditional food heritage, creation of a cutting edge online inventory, courses and educational units, and a cultural exchange platform based on events and tourist tours. The project will benefit heritage communities; local development professionals and organizations; cultural institutions; local, regional and national authorities. The project is innovative since it links food heritage with marketing and consumer culture, and does not consider heritage communities as passive recipients of ‘top-down’ interventions, but instead supports ‘bottom-up’ mobilization processes based on engagement/empowerment of the citizenship. The project also contributes to a recent international debate (the 2003 UNESCO Convention) on the Intangible Cultural Heritage. All Alpine administrations are experimenting safeguard and valorization solutions – albeit in a fragmented and uncoordinated way. The project will develop this theme at a scale – the entire Alps – never attempted before. As future perspective, the Alpine community could aspire to inscribe the Alpine food heritage on the UNESCO intangible cultural heritage list as a traditional foodway.\n' + '\n' + 'The project contributes to Priority 3 (Liveable Alpine Space) as it valorizes Alpine Space cultural/natural heritage and enhances protection and conservation of the Alpine Space. "';
    }
  },
  mounted: function mounted() {
    document.getElementById('aboutUsModal___BV_modal_header_').setAttribute('style', 'background-color: #c41c21 !important; color: white !important;');
    document.getElementById('aboutUsModal___BV_modal_header_').lastChild.setAttribute('style', 'color: white !important;');
  }
});

/***/ }),

/***/ "uJeA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-countdownTimer"},[_c('div',{class:[{'f-timer-small':_vm.$store.getters.isMobileValue},'f-timer']},[_c('ul',{attrs:{"id":"f-countdownList"}},[_c('li',[_c('span',{staticClass:"f-timer-val"},[_vm._v(_vm._s(_vm.days))]),_vm._v(" "),_c('p',{staticClass:"f-timer-desc"},[_vm._v("days")])]),_vm._v(" "),_c('li',{staticClass:"f-timer-sep "},[_vm._v(":")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"f-timer-val"},[_vm._v(_vm._s(_vm.hours))]),_vm._v(" "),_c('p',{staticClass:"f-timer-desc"},[_vm._v("hours")])]),_vm._v(" "),_c('li',{staticClass:"f-timer-sep "},[_vm._v(":")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"f-timer-val"},[_vm._v(_vm._s(_vm.minutes))]),_vm._v(" "),_c('p',{staticClass:"f-timer-desc"},[_vm._v("minutes")])]),_vm._v(" "),_c('li',{staticClass:"f-timer-sep "},[_vm._v(":")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"f-timer-val"},[_vm._v(_vm._s(_vm.seconds))]),_vm._v(" "),_c('p',{staticClass:"f-timer-desc"},[_vm._v("seconds")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "udBC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-readCartaModal"},[_c('b-modal',{ref:"readCartaModal",attrs:{"id":"readCartaModal","centered":"","size":"lg","title":_vm.modalTitle}},[_c('p',{staticClass:"my-4"},[_vm._v(_vm._s(_vm.activeLanguage.chartaContent.chapter1.text))]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-button',{staticClass:"button-style float-left",on:{"click":_vm.loadPaper}},[_vm._v(_vm._s(_vm.activeLanguage.readMore))]),_vm._v(" "),_c('b-button',{staticClass:"button-style float-right",on:{"click":_vm.loadSignPetition}},[_vm._v(_vm._s(_vm.activeLanguage.signPetition))])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uwPJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InventoryMapPage_vue__ = __webpack_require__("66Im");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_083267d2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InventoryMapPage_vue__ = __webpack_require__("MBgH");
function injectStyle (ssrContext) {
  __webpack_require__("kHIP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-083267d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InventoryMapPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_083267d2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InventoryMapPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w8Xv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wht9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wkq0":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAQAAAACach9AAACMUlEQVR4Ae3ShY7jQBAE0Aoz/f9/HTMzhg1zrdKUrJbdx+Kd2nD8VNudfsL/Th///dyQN2TH6f3y/BGpC379rV+S+qqetBOxImNQXL8JCAr2V4iMQXHGNJxeCfZXhSRBcQMfvkOWUdtfzlLgAENmZDcmo2TVmt8OSM2eXxBp3DjHSMFutqS7SbmemzBiR+xpKCNUIRkdkkYxhAkyGoBvyQFEJEefwSmmvBfJuJ6aKqKWnAkvGZOaZXTUgFqYULWNSHUckZuR1HIIimUExutRxwzOLROIG4vKmCKQt364mIlhSyzAf1m9lHZHJZrlAOMMztRRiKimp/rpdJDc9Awry5xTZCte7FHtuS8wJgeYGrex28xNTd086Dik7vUMscQOa8y4DoGtCCSkAKlNwpgNtphjrC6MIHUkR6YWxxs6Sc5xqn222mmCRFzIt8lEdKx+ikCtg91qS2WpwVfBelJCiQJwvzixfI9cxZQWgiSJelKnwBElKYtDOb2MFbhmUigbReQBV0Cg4+qMXSxXSyGUn4UbF8l+7qdSGnTC0XLCmahIgUHLhLOhpVCtw4CzYXvLQWQbJNmxoCsOKAxSgBJno75avolkRw8iIAFcsdc02e9iyCd8tHwmeSSoKTowIgvscSGZUOA7PuCN5b2BX9mQM7S0wYhMNU74zgsPBj3HU7wguAfnxxjFQGBE6pwN+GjME9zHY7zGp8wVxMShYX9NXvEWD3HbwJf4giO4CFIQxXScH1/TM+04kkBiAAAAAElFTkSuQmCC"

/***/ }),

/***/ "wqwS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyModal_vue__ = __webpack_require__("p12r");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1d3ad96_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyModal_vue__ = __webpack_require__("ES82");
function injectStyle (ssrContext) {
  __webpack_require__("OCZh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d1d3ad96"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicyModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1d3ad96_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicyModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wtEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageContentPlaceholder__ = __webpack_require__("HLWc");




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  currentView: __WEBPACK_IMPORTED_MODULE_2__components_PageContentPlaceholder__["a" /* default */],
  currentLanguage: 'Italian',
  isPreviewMode: false,
  isMobile: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))
};

var mutations = {
  // setVariable(state, variable) {
  //   state.variable = variable;
  // }
  setIsMobile: function setIsMobile(state, isMobile) {
    state.isMobile = isMobile;
  },
  setCurrentView: function setCurrentView(state, view) {
    state.currentView = view;
  },
  setCurrentLanguage: function setCurrentLanguage(state, language) {
    state.currentLanguage = language.charAt(0).toUpperCase() + language.slice(1).toLowerCase();
  },
  setIsPreviewMode: function setIsPreviewMode(state, previewMode) {
    state.isPreviewMode = previewMode;
  }
};

var actions = {};

var getters = {
  // variableValue (state) {
  //   if (state.variable) {
  //     return variable.value
  //   }
  //   return ''
  // }
  isMobileValue: function isMobileValue(state) {
    return state.isMobile;
  },
  currentViewValue: function currentViewValue(state) {
    if (state.currentView) {
      return state.currentView;
    }
    return { name: '' };
  },
  currentLanguageValue: function currentLanguageValue(state) {
    if (state.currentLanguage) {
      return state.currentLanguage;
    }
    return 'Italian';
  },
  isPreviewModeValue: function isPreviewModeValue(state) {
    return state.isPreviewMode;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}));

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__("INCx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_headerComponents_Headers__ = __webpack_require__("hZG8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_footerComponents_MainFooter__ = __webpack_require__("eue+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: { Headers: __WEBPACK_IMPORTED_MODULE_2__components_headerComponents_Headers__["a" /* default */], MainFooter: __WEBPACK_IMPORTED_MODULE_3__components_footerComponents_MainFooter__["a" /* default */] },
  mounted: function mounted() {
    // this.checkForDate()
    if (this.notInCountdown) {
      var self = this;
      window.onscroll = function () {
        self.$refs.headersContainer.stickyAndDisappear();
        self.leaveSpace();
      };
    }

    if (this.$route.params.language) {
      switch (this.$route.params.language.toLowerCase()) {
        case 'italian':
          this.setItalianLanguage();
          break;
        case 'english':
          this.setEnglishLanguage();
          break;
        case 'german':
          this.setGermanLanguage();
          break;
        case 'french':
          this.setFrenchLanguage();
          break;
        case 'slovenian':
          this.setSlovenianLanguage();
          break;
        default:
          this.setItalianLanguage();
      }
    } else {
      this.setItalianLanguage();
    }
  },
  created: function created() {
    // console.log('Preview mode: ' + this.$store.getters.isPreviewModeValue)
    if (document.getElementById('mobile-meta-tag-counter')) {
      document.getElementsByTagName('head')[0].removeChild(document.getElementById('mobile-meta-tag-counter'));
    }
    var meta = document.createElement('meta');
    meta.name = 'viewport';
    meta.content = 'width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=0';
    meta.id = 'mobile-meta-tag';
    document.getElementsByTagName('head')[0].appendChild(meta);
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])({
    currentView: 'currentViewValue'
  }), {
    notInCountdown: function notInCountdown() {
      return this.currentView.name !== 'CountdownPanel';
    }
  }),
  methods: {
    // checkForDate () {
    //   if ((!this.$store.getters.isPreviewModeValue) && this.isPastRelaseDate && this.$PATH_NAME !== 'http://localhost:8080/') {
    //     this.$router.push('/countdown')
    //   }
    // },
    leaveSpace: function leaveSpace() {
      var header = document.getElementById('headersWrapper');
      var container = document.getElementById('mainPage');
      var sticky = header.offsetTop;
      if (window.pageYOffset > sticky) {
        if (this.$store.getters.isMobileValue) {
          container.classList.add('spacing-mobile');
        } else {
          container.classList.add('spacing');
        }
      } else {
        if (this.$store.getters.isMobileValue) {
          container.classList.remove('spacing-mobile');
        } else {
          container.classList.remove('spacing');
        }
      }
    },
    isPastRelaseDate: function isPastRelaseDate() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(Date.parse('October 4, 2018 16:00:00') / 1000) - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(new Date().getTime() / 1000) > 0;
    }
  },
  updated: function updated() {
    // this.checkForDate()
  }
});

/***/ }),

/***/ "xPuL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dislivelli-association.17c1eb3.jpg";

/***/ }),

/***/ "y2RP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zrc-sazu.3ee27da.jpg";

/***/ }),

/***/ "yBR0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-signaturesCounter"},[_c('div',{staticClass:"text-center"},[_c('p',[_c('span',{staticClass:"number-sign-style"},[_c('IOdometer',{attrs:{"value":_vm.signatures}})],1),_vm._v(" "+_vm._s(_vm.activeLanguage.haveSigned)+"\n    ")])]),_vm._v(" "),_c('b-progress',{staticClass:"mb-3 rounded-edges",attrs:{"max":_vm.max,"height":"2rem"}},[_c('b-progress-bar',{staticClass:"line-style",attrs:{"variant":"danger","value":_vm.petitionSignatures}}),_vm._v(" "),_c('div',{staticClass:"arrow-right-fit-finish"})],1),_vm._v(" "),_c('div',[_c('p',{staticClass:"font-weight-bold"},[_vm._v("\n      "+_vm._s(_vm.activeLanguage.letsGetTo)+" "+_vm._s(_vm.maxToString)+"\n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yJIF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yt4F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pagesComponents_homePageComponents_HomePage__ = __webpack_require__("GzlF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pagesComponents_eventsPageComponents_EventsPage__ = __webpack_require__("Vd6i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pagesComponents_socialsPageComponents_SocialWallPage__ = __webpack_require__("cxkx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pagesComponents_newsPageComponents_NewsPage__ = __webpack_require__("CArz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pagesComponents_supportersPageComponents_SupportersPage__ = __webpack_require__("kJZW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pagesComponents_signPetitionPageComponents_SignPetitionPage__ = __webpack_require__("HPm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pagesComponents_paperPageComponents_PaperPage__ = __webpack_require__("sH5r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pagesComponents_contestPageComponents_ContestPage__ = __webpack_require__("gz4D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pagesComponents_videosPageComponents_VideosPage__ = __webpack_require__("qLdU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pagesComponents_inventoryMapPageComponents_InventoryMapPage__ = __webpack_require__("uwPJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











// import GalleryPage from '../pagesComponents/galleryPageComponents/GalleryPage'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MainHeader',
  computed: {
    isHomeActive: function isHomeActive() {
      return this.$store.getters.currentViewValue.name === 'HomePage';
    },
    isEventsActive: function isEventsActive() {
      return this.$store.getters.currentViewValue.name === 'EventsPage';
    },
    isSocialWallActive: function isSocialWallActive() {
      return this.$store.getters.currentViewValue.name === 'SocialWallPage';
    },
    isContestActive: function isContestActive() {
      return this.$store.getters.currentViewValue.name === 'ContestPage';
    },
    isNewsActive: function isNewsActive() {
      return this.$store.getters.currentViewValue.name === 'NewsPage';
    },
    isSupportersActive: function isSupportersActive() {
      return this.$store.getters.currentViewValue.name === 'SupportersPage';
    },
    isSignPetitionActive: function isSignPetitionActive() {
      return this.$store.getters.currentViewValue.name === 'SignPetitionPage';
    },
    isPaperActive: function isPaperActive() {
      return this.$store.getters.currentViewValue.name === 'PaperPage';
    },
    isVideosActive: function isVideosActive() {
      return this.$store.getters.currentViewValue.name === 'VideosPage';
    },
    isInventoryMapActive: function isInventoryMapActive() {
      return this.$store.getters.currentViewValue.name === 'InventoryMapPage';
    },
    isGalleryActive: function isGalleryActive() {
      return this.$store.getters.currentViewValue.name === 'GalleryPage';
    },
    activeLanguage: function activeLanguage() {
      return this.$translations[this.$store.getters.currentLanguageValue];
    }
  },
  methods: {
    loadHome: function loadHome() {
      this.$store.commit('setCurrentView', __WEBPACK_IMPORTED_MODULE_0__pagesComponents_homePageComponents_HomePage__["a" /* default */]);
      this.$router.push('/home' + this.getCurrentLanguage());
    },
    loadEvents: function loadEvents() {
      this.$store.commit('setCurrentView', __WEBPACK_IMPORTED_MODULE_1__pagesComponents_eventsPageComponents_EventsPage__["a" /* default */]);
      this.$router.push('/events' + this.getCurrentLanguage());
    },
    loadSocialWall: function loadSocialWall() {
      this.$store.commit('setCurrentView', __WEBPACK_IMPORTED_MODULE_2__pagesComponents_socialsPageComponents_SocialWallPage__["a" /* default */]);
      this.$router.push('/social-wall' + this.getCurrentLanguage());
    },
    loadContest: function loadContest() {
      this.$store.commit('setCurrentView', __WEBPACK_IMPORTED_MODULE_7__pagesComponents_contestPageComponents_ContestPage__["a" /* default */]);
      this.$router.push('/contest' + this.getCurrentLanguage());
    },
    loadNews: function loadNews() {
      this.$store.commit('setCurrentView', __WEBPACK_IMPORTED_MODULE_3__pagesComponents_newsPageComponents_NewsPage__["a" /* default */]);
      this.$router.push('/news' + this.getCurrentLanguage());
    },
    loadSupporters: function loadSupporters() {
      this.$store.commit('setCurrentView', __WEBPACK_IMPORTED_MODULE_4__pagesComponents_supportersPageComponents_SupportersPage__["a" /* default */]);
      this.$router.push('/supporters' + this.getCurrentLanguage());
    },
    loadSignPetition: function loadSignPetition() {
      this.$store.commit('setCurrentView', __WEBPACK_IMPORTED_MODULE_5__pagesComponents_signPetitionPageComponents_SignPetitionPage__["a" /* default */]);
      this.$router.push('/sign-petition' + this.getCurrentLanguage());
    },
    loadPaper: function loadPaper() {
      this.$store.commit('setCurrentView', __WEBPACK_IMPORTED_MODULE_6__pagesComponents_paperPageComponents_PaperPage__["a" /* default */]);
      this.$router.push('/paper' + this.getCurrentLanguage());
    },
    loadVideos: function loadVideos() {
      this.$store.commit('setCurrentView', __WEBPACK_IMPORTED_MODULE_8__pagesComponents_videosPageComponents_VideosPage__["a" /* default */]);
      this.$router.push('/videos-gallery' + this.getCurrentLanguage());
    },
    loadInventoryMap: function loadInventoryMap() {
      this.$store.commit('setCurrentView', __WEBPACK_IMPORTED_MODULE_9__pagesComponents_inventoryMapPageComponents_InventoryMapPage__["a" /* default */]);
      this.$router.push('/inventory-map' + this.getCurrentLanguage());
    },
    loadGallery: function loadGallery() {
      // this.$store.commit('setCurrentView', GalleryPage)
      // this.$router.push('/gallery' + this.getCurrentLanguage())
      window.open('http://intangiblesearch.eu/alpfoodway-webdoc', '_blank');
    },
    loadInventory: function loadInventory() {
      var language = void 0;
      switch (this.$store.getters.currentLanguageValue) {
        case 'Italian':
          language = this.$translations['Italian'].italianLanguage;
          break;
        case 'English':
          language = this.$translations['Italian'].englishLanguage;
          break;
        case 'German':
          language = this.$translations['Italian'].germanLanguage;
          break;
        case 'French':
          language = this.$translations['Italian'].frenchLanguage;
          break;
        case 'Slovenian':
          language = this.$translations['Italian'].englishLanguage;
          break;
        default:
          break;
      }
      window.open('http://intangiblesearch.eu/search/search_by_tag.php?db_name=intangible_search&lingua=' + language.toLowerCase() + '&tag_code=TAG_1268&showmode=MAP\n', '_blank');
    },
    getCurrentLanguage: function getCurrentLanguage() {
      switch (this.$store.getters.currentLanguageValue) {
        case 'Italian':
          return '/italian';
        case 'English':
          return '/english';
        case 'German':
          return '/german';
        case 'French':
          return '/french';
        case 'Slovenian':
          return '/slovenian';
        default:
          return '/italian';
      }
    }
  }
});

/***/ }),

/***/ "zGiX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zcxf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alpfoodway_background6_resized.e80f73f.jpg";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.84a0f558d50bbd0b1880.js